var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { computed, markRaw, inject, defineComponent, reactive, ref, watch, shallowRef, onMounted, getCurrentInstance, toRefs, provide, createBlock, openBlock, unref, withCtx, createVNode, mergeProps, createCommentVNode, createTextVNode, toDisplayString, h, compile, resolveComponent, resolveDynamicComponent, normalizeProps, createSlots, renderList, renderSlot, createElementBlock, Fragment, resolveDirective, withDirectives, createElementVNode, defineAsyncComponent, nextTick, normalizeClass, vShow, onBeforeUnmount, mergeDefaults, useAttrs, Suspense, normalizeStyle, guardReactiveProps } from "vue";
import { getData, getConfig, hasShowRule, isVisible, getAjv, getTranslator, getI18nKeyPrefixBySchema, isInherentlyEnabled, getCells, getRenderers, findUISchema, composePaths, NOT_APPLICABLE, Generate, defaultMiddleware, getI18nKey, Resolve, createDefaultValue, rankWith, uiTypeIs, and, isStringControl, optionIs, formatIs, schemaMatches, or, schemaTypeIs } from "@jsonforms/core";
import { useControl, JsonForms, DispatchRenderer, rendererProps, useJsonFormsLayout, useJsonFormsOneOfEnumControl, useJsonFormsControl, useJsonFormsLabel, useJsonFormsArrayControl } from "@jsonforms/vue";
import { normalizeId } from "ajv/dist/compile/resolve";
import * as JsonRefs from "json-refs";
import get from "lodash/get";
import isFunction from "lodash/isFunction";
import { useTheme, useRtl, useDisplay } from "vuetify";
import { VLocaleProvider, VThemeProvider, VDefaultsProvider, VContainer, VRow, VCol, VProgressLinear, VAlert, VIcon, VBtn, VSelect, VTextField, VNumberInput, VMenu, VConfirmEdit, VCardText, VCardActions, VCard, VToolbarTitle, VToolbar, VSpacer, VDialog, VFileInput, VCheckbox, VLabel, VSheet, VTooltip, VProgressCircular, VCardTitle } from "vuetify/components";
import dayjs from "dayjs";
import customParsingPlugin from "dayjs/plugin/customParseFormat";
import durationPlugin from "dayjs/plugin/duration";
import timezonePlugin from "dayjs/plugin/timezone";
import utcPlugin from "dayjs/plugin/utc";
import "ajv";
import keywords from "ajv-keywords";
import dynamicDefaults from "ajv-keywords/dist/definitions/dynamicDefaults";
import { stringify, _, getProperty } from "ajv/dist/compile/codegen";
import capitalizeFn from "lodash/capitalize";
import startCaseFn from "lodash/startCase";
import templateFn from "lodash/template";
import merge from "lodash/merge";
import { createAjv as createAjv$1, useStyles, useTranslator, useVuetifyLayout, useJsonForms, DisabledIconFocus, ControlWrapper, useVuetifyControl, IconSymbol, useIcons as useIcons$1, determineClearValue, useVuetifyLabel, ValidationIcon, useVuetifyArrayControl } from "@jsonforms/vue-vuetify";
import ajvErrors from "ajv-errors";
import cloneDeep from "lodash/cloneDeep";
import isPlainObject from "lodash/isPlainObject";
import { Splitpanes, Pane } from "splitpanes";
import memoize from "lodash/memoize";
import { vMaska } from "maska";
import toNumber from "lodash/toNumber";
import { VDefaultsProvider as VDefaultsProvider$1 } from "vuetify/components/VDefaultsProvider";
import * as defaultDirectives from "vuetify/directives";
import Ractive from "ractive";
import find from "lodash/find";
import uniqueId from "lodash/uniqueId";
import isEmpty from "lodash/isEmpty";
dayjs.extend(customParsingPlugin);
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
dayjs.extend(durationPlugin);
const dynamic = (args) => {
  let func = void 0;
  if ((args == null ? void 0 : args.func) && typeof args.func === "string") {
    func = args == null ? void 0 : args.func;
  }
  if (func) {
    try {
      const fn = new Function(
        "args",
        `const func = ${func}; return func(args);`
      );
      return () => {
        try {
          return fn(args);
        } catch (e) {
          console.error(`Error at dynamicDefaults 'dynamic': ${e}`);
        }
      };
    } catch (e) {
      console.error(`Error at dynamicDefaults 'dynamic': ${e}`);
    }
  }
  throw new Error(`missing argument 'func' for dynamicDefaults func 'dynamic'`);
};
const searchParams = (args) => {
  let paramName = void 0;
  if ((args == null ? void 0 : args.param) && typeof args.param === "string") {
    paramName = args == null ? void 0 : args.param;
  }
  const url = new URL(window.location.href);
  const params = url.searchParams;
  let result = void 0;
  if (paramName) {
    if (params.has(paramName)) {
      result = params.get(paramName);
    } else {
      const hash = url.hash;
      const index = hash.indexOf("?");
      if (index > 0 && index < hash.length - 1) {
        const hashSearchParams = new URLSearchParams(hash.substring(index + 1));
        if (hashSearchParams.has(paramName)) {
          result = hashSearchParams.get(paramName);
        }
      }
    }
  }
  return () => result;
};
const datetimeOffset = (args) => {
  const dateTime = nowOffset(args);
  let result = void 0;
  if (dateTime.isValid()) {
    const datetimeLocalFormat = "YYYY-MM-DDTHH:mm:ss.SSS";
    result = dateTime.local().format(datetimeLocalFormat);
  }
  return () => result;
};
const timeOffset = (args) => {
  const dateTime = nowOffset(args);
  let result = void 0;
  if (dateTime.isValid()) {
    const datetimeLocalFormat = "HH:mm:ss.SSS";
    result = dateTime.local().format(datetimeLocalFormat);
  }
  return () => result;
};
const dateOffset = (args) => {
  const date = nowOffset(args);
  let result = void 0;
  if (date.isValid()) {
    result = date.local().format("YYYY-MM-DD");
  }
  return () => result;
};
const dateUnit = (args) => {
  const date = nowOffset(args);
  let result = void 0;
  if (date.isValid()) {
    let unit = "millisecond";
    if ((args == null ? void 0 : args.unit) && typeof args.unit === "string") {
      unit = args == null ? void 0 : args.unit;
    }
    result = date.local().get(unit);
  }
  return () => result;
};
const nowOffset = (args) => {
  let duration = void 0;
  if ((args == null ? void 0 : args.duration) && typeof args.duration === "string") {
    duration = args == null ? void 0 : args.duration;
  }
  let date = /* @__PURE__ */ new Date();
  if ((args == null ? void 0 : args.date) && typeof args.date === "string") {
    if (args.date !== "now") {
      date = args == null ? void 0 : args.date;
    }
  }
  let operation = "add";
  if ((args == null ? void 0 : args.op) && args.op === "substract") {
    operation = "substract";
  }
  let dateObj = dayjs(date);
  if (dateObj.isValid() && duration) {
    const offset = dayjs.duration(duration);
    dateObj = operation == "add" ? dateObj.add(offset) : dateObj.subtract(offset);
  }
  return dateObj;
};
const transform = {
  trimStart: (s) => s.trimStart(),
  trimEnd: (s) => s.trimEnd(),
  trimLeft: (s) => s.trimStart(),
  trimRight: (s) => s.trimEnd(),
  trim: (s) => s.trim(),
  toLowerCase: (s) => s.toLowerCase(),
  toUpperCase: (s) => s.toUpperCase(),
  toEnumCase: (s, cfg) => (cfg == null ? void 0 : cfg.hash[configKey(s)]) || s,
  capitalize: (s) => capitalizeFn(s),
  startCase: (s) => startCaseFn(s)
};
const getDef = Object.assign(_getDef, { transform });
function _getDef() {
  return {
    keyword: "transform",
    schemaType: "array",
    before: "enum",
    code(cxt) {
      const { gen, data, schema, parentSchema, it: it2 } = cxt;
      const { parentData, parentDataProperty } = it2;
      const tNames = schema;
      if (!tNames.length) return;
      let cfg;
      if (tNames.includes("toEnumCase")) {
        const config = getEnumCaseCfg(parentSchema);
        cfg = gen.scopeValue("obj", { ref: config, code: stringify(config) });
      }
      gen.if(
        _`typeof ${data} == "string" && ${parentData} !== undefined`,
        () => {
          gen.assign(data, transformExpr(tNames.slice()));
          gen.assign(_`${parentData}[${parentDataProperty}]`, data);
        }
      );
      function transformExpr(ts) {
        if (!ts.length) return data;
        const t = ts.pop();
        if (!(t in transform))
          throw new Error(`transform: unknown transformation ${t}`);
        const func = gen.scopeValue("func", {
          ref: transform[t],
          code: _`require("ajv-keywords/dist/definitions/transform").transform${getProperty(
            t
          )}`
        });
        const arg = transformExpr(ts);
        return cfg && t === "toEnumCase" ? _`${func}(${arg}, ${cfg})` : _`${func}(${arg})`;
      }
    },
    metaSchema: {
      type: "array",
      items: { type: "string", enum: Object.keys(transform) }
    }
  };
}
function getEnumCaseCfg(parentSchema) {
  const cfg = { hash: {} };
  if (!parentSchema.enum)
    throw new Error('transform: "toEnumCase" requires "enum"');
  for (const v of parentSchema.enum) {
    if (typeof v !== "string") continue;
    const k = configKey(v);
    if (cfg.hash[k]) {
      throw new Error(
        'transform: "toEnumCase" requires all lowercased "enum" values to be unique'
      );
    }
    cfg.hash[k] = v;
  }
  return cfg;
}
function configKey(s) {
  return s.toLowerCase();
}
const ajvKeywords = (ajv) => {
  keywords(ajv);
  ajv.removeKeyword("transform");
  ajv.addKeyword(getDef());
  dynamicDefaults.DEFAULTS.dynamic = dynamic;
  dynamicDefaults.DEFAULTS.searchParams = searchParams;
  dynamicDefaults.DEFAULTS.datetime = datetimeOffset;
  dynamicDefaults.DEFAULTS.date = dateOffset;
  dynamicDefaults.DEFAULTS.time = timeOffset;
  dynamicDefaults.DEFAULTS.dateUnit = dateUnit;
};
const interpolate = /{{([\s\S]+?)}}/g;
const template = (templateString, options) => {
  return templateFn(
    templateString,
    merge({ interpolate }, options)
  );
};
const AsyncFunction = Object.getPrototypeOf(async function(_event) {
}).constructor;
const DataProviderKey = Symbol.for(
  "jsonforms-vuetify-renderers:dataProvider"
);
const TemplateDirectivesKey = Symbol.for(
  "jsonforms-vuetify-renderers:templateLayoutRendererComponentDirectives"
);
const TemplateComputedKey = Symbol.for(
  "jsonforms-vuetify-renderers:templateLayoutRendererComponentComputed"
);
const TemplateMethodsKey = Symbol.for(
  "jsonforms-vuetify-renderers:templateLayoutRendererComponentMethods"
);
const TemplateFiltersKey = Symbol.for(
  "jsonforms-vuetify-renderers:templateLayoutRendererComponentFilters"
);
const TemplateComponentsKey = Symbol.for(
  "jsonforms-vuetify-renderers:templateLayoutRendererComponentComponents"
);
const FormContextKey = Symbol.for(
  "jsonforms-vuetify-renderers:formContext"
);
const TemplateRenderSlotContentsKey = Symbol.for("jsonforms-vuetify-renderers:templateRendererSlotContents");
const HandleActionEmitterKey = Symbol.for("jsonforms-vuetify-renderers:handleActionEmitter");
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var en = function localize_en(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "additionalProperties":
        out = "must NOT have additional properties";
        break;
      case "anyOf":
        out = 'must match a schema in "anyOf"';
        break;
      case "const":
        out = "must be equal to constant";
        break;
      case "contains":
        out = "must contain a valid item";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "must have propert";
        if (n == 1) {
          out += "y";
        } else {
          out += "ies";
        }
        out += " " + e.params.deps + " when property " + e.params.property + " is present";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'must pass "' + e.keyword + '" keyword validation';
        }
        break;
      case "enum":
        out = "must be equal to one of the allowed values";
        break;
      case "false schema":
        out = "boolean schema is false";
        break;
      case "format":
        out = 'must match format "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "if":
        out = 'must match "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "must NOT be longer than " + n + " character";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "must NOT have more than " + n + " propert";
        if (n == 1) {
          out += "y";
        } else {
          out += "ies";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "must NOT have less than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "must NOT be shorter than " + n + " character";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "must NOT have less than " + n + " propert";
        if (n == 1) {
          out += "y";
        } else {
          out += "ies";
        }
        break;
      case "multipleOf":
        out = "must be a multiple of " + e.params.multipleOf;
        break;
      case "not":
        out = 'must NOT be valid according to schema in "not"';
        break;
      case "oneOf":
        out = 'must match exactly one schema in "oneOf"';
        break;
      case "pattern":
        out = 'must match pattern "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'must have property matching pattern "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "property name is invalid";
        break;
      case "required":
        out = "must have required property " + e.params.missingProperty;
        break;
      case "type":
        out = "must be " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "must NOT have duplicate items (items ## " + e.params.j + " and " + e.params.i + " are identical)";
        break;
      default:
        out = 'must pass "' + e.keyword + '" keyword validation';
    }
    e.message = out;
  }
};
var ar = function localize_ar(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += " يجب أن لا يحوي أكثر من " + n + " عنصر";
        break;
      case "additionalProperties":
        out = "يجب أن لا يحوي خصائص إضافية";
        break;
      case "anyOf":
        out = 'يجب أن يوافق أحد المخططات الموجودة في "anyOf"';
        break;
      case "const":
        out = "يجب أن يكون ثابتاً";
        break;
      case "contains":
        out = "يجب أن يحوي عنصرا صحيح";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += " يجب أن يحوي الخصائص " + e.params.deps + " عندما تكون الخاصية " + e.params.property + " موجودة";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'يجب أن تمرر كلمة التحقق المفتاحية "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "قيمة هذا الحقل يجب أن تكون مساوية لأحد القيم المعرفة مسبقاً";
        break;
      case "false schema":
        out = "المخطط المنطقي غير صحيح";
        break;
      case "format":
        out = 'يجب أن يوافق الصيغة "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " يجب أن يكون " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " يجب أن يكون " + cond;
        break;
      case "if":
        out = 'يجب أن توافق المخطط "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " يجب أن يكون " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += " يجب أن لا يحوي أكثر من " + n + " عنصر";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += " يجب أن لا يحوي أكثر من " + n + " محرف";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += " يجب أن لا يحوي أكثر من " + n + " خصائص";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " يجب أن يكون " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += " يجب أن لا يحوي أقل من " + n + " عنصر";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += " يجب أن لا يحوي أقل من " + n + " محرف";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += " يجب أن لا يحوي أقل من " + n + " خصائص";
        break;
      case "multipleOf":
        out = " يجب أن يحوي أكثر من " + e.params.multipleOf;
        break;
      case "not":
        out = 'يجب أن يكون غير صحيح وفقاً للمخطط "not"';
        break;
      case "oneOf":
        out = 'يجب أن يوافق مخطط واحد فقط موجود في "oneOf"';
        break;
      case "pattern":
        out = 'يجب أن يوافق النمط "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'يجب أن يحوي خاصية توافق النمط "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "اسم الخاصية غير صالح";
        break;
      case "required":
        out = "هذا الحقل إلزامي";
        break;
      case "type":
        out = "قيمة هذا الحقل غير صالحة";
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "يجب أن لا يحوي عناصر مكررة (العنصر ## " + e.params.j + " و " + e.params.i + " متطابقة)";
        break;
      default:
        out = 'يجب أن تمرر كلمة التحقق المفتاحية "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var ca = function localize_ca(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "no ha de tenir més de " + n + " element";
        if (n != 1) {
          out += "s";
        }
        break;
      case "additionalProperties":
        out = "no ha de tenir propietats addicionals";
        break;
      case "anyOf":
        out = 'ha de coincidir amb algun esquema definit a "anyOf"';
        break;
      case "const":
        out = "ha de ser igual a la constant";
        break;
      case "contains":
        out = "ha de contenir un ítem vàlid";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "ha de contenir la propietat";
        if (n != 1) {
          out += "s";
        }
        out += " " + e.params.deps + " quan la propietat " + e.params.property + " és present";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'ha de passar la validació de la clau "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "ha de ser igual a un dels valors predefinits";
        break;
      case "false schema":
        out = "l’esquema és fals";
        break;
      case "format":
        out = 'ha de coincidir amb el format "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ha de ser " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ha de ser " + cond;
        break;
      case "if":
        out = 'ha de correspondre’s amb l’esquema "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ha de ser " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "no ha de tenir més de " + n + " ítem";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "no pot contenir més de " + n + " caràcter";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "no pot contenir més de " + n + " propietat";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ha de ser " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "no ha de tenir menys de " + n + " ítem";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "no pot contenir menys de " + n + " caràcter";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "no pot contenir menys de " + n + " propietat";
        if (n != 1) {
          out += "s";
        }
        break;
      case "multipleOf":
        out = "ha de ser múltiple de " + e.params.multipleOf;
        break;
      case "not":
        out = 'no ha de ser vàlid d’acord amb l’esquema definit a "not"';
        break;
      case "oneOf":
        out = 'ha de coincidir només amb un esquema definit a "oneOf"';
        break;
      case "pattern":
        out = 'ha de coincidir amb el patró "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'la propietat ha de coincidir amb el patró "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "la propietat no és vàlida";
        break;
      case "required":
        out = "ha de tenir la propietat requerida " + e.params.missingProperty;
        break;
      case "type":
        out = "ha de ser del tipus " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "no ha de tenir ítems duplicats (els ítems ## " + e.params.j + " i " + e.params.i + " són idèntics)";
        break;
      default:
        out = 'ha de passar la validació de la clau "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var cs = function localize_cs(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "nemůže mít víc, než " + n + " prv";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "ek";
        } else {
          out += "ků";
        }
        break;
      case "additionalProperties":
        out = "nemůže mít další položky";
        break;
      case "anyOf":
        out = 'musí vyhovět alespoň jednomu schématu v "anyOf"';
        break;
      case "const":
        out = "musí být roven konstantě";
        break;
      case "contains":
        out = "musí obsahovat prvek odpovídající schématu";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "musí mít polož";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "ek";
        } else {
          out += "ka";
        }
        out += ": " + e.params.deps + ", pokud obsahuje " + e.params.property;
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'musí vyhovět "' + e.keyword + '" validaci';
        }
        break;
      case "enum":
        out = "musí být rovno jedné hodnotě z výčtu";
        break;
      case "false schema":
        out = "schéma je false";
        break;
      case "format":
        out = 'musí být ve formátu "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí být " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí být " + cond;
        break;
      case "if":
        out = 'musí vyhovět "' + e.params.failingKeyword + '" schématu';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí být " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "nesmí obsahovat víc než " + n + " prv";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "ek";
        } else {
          out += "ků";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "nesmí být delší než " + n + " zna";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "k";
        } else {
          out += "ků";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "nesmí mít víc než " + n + " polož";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "ek";
        } else {
          out += "ka";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí být " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "nesmí obsahovat méně než " + n + " prv";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "ek";
        } else {
          out += "ků";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "nesmí být kratší než " + n + " zna";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "k";
        } else {
          out += "ků";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "nesmí mít méně než " + n + " polož";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "ek";
        } else {
          out += "ka";
        }
        break;
      case "multipleOf":
        out = "musí být násobkem " + e.params.multipleOf;
        break;
      case "not":
        out = 'nesmí vyhovět schématu v "not"';
        break;
      case "oneOf":
        out = 'musí vyhovět právě jednomu schématu v "oneOf"';
        break;
      case "pattern":
        out = 'musí vyhovět regulárnímu výrazu "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'musí obsahovat položku vyhovující regulárnímu výrazu "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "název položky není platný";
        break;
      case "required":
        out = "musí obsahovat požadovanou položku " + e.params.missingProperty;
        break;
      case "type":
        out = "musí být " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "nesmí obsahovat duplicitní prvky (prvky ## " + e.params.j + " a " + e.params.i + " jsou identické)";
        break;
      default:
        out = 'musí vyhovět "' + e.keyword + '" validaci';
    }
    e.message = out;
  }
};
var de = function localize_de(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "darf nicht mehr als " + n + " Element";
        if (n != 1) {
          out += "e";
        }
        out += " enthalten";
        break;
      case "additionalProperties":
        out = "darf keine zusätzlichen Attribute haben";
        break;
      case "anyOf":
        out = 'muss einem der Schemata in "anyOf" entsprechen';
        break;
      case "const":
        out = "muss gleich der Konstanten sein";
        break;
      case "contains":
        out = "muss ein valides Element enthalten";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "muss Attribut";
        if (n != 1) {
          out += "e";
        }
        out += " " + e.params.deps + " aufweisen, wenn Attribut " + e.params.property + " gesetzt ist";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'der Tag "' + e.params.tag + '" muss eine Zeichenkette sein';
            break;
          case "mapping":
            out = 'der Wert vom Tag "' + e.params.tag + '" muss im oneOf enthalten sein';
            break;
          default:
            out = 'muss die Validierung "' + e.keyword + '" bestehen';
        }
        break;
      case "enum":
        out = "muss einem der vorgegebenen Werte entsprechen";
        break;
      case "false schema":
        out = "boolesches Schema ist falsch";
        break;
      case "format":
        out = 'muss diesem Format entsprechen: "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "muss " + cond + " sein";
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "muss " + cond + " sein";
        break;
      case "if":
        out = 'muss dem Schema "' + e.params.failingKeyword + '" entsprechen';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "muss " + cond + " sein";
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "darf nicht mehr als " + n + " Element";
        if (n != 1) {
          out += "e";
        }
        out += " haben";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "darf nicht länger als " + n + " Zeichen sein";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "darf nicht mehr als " + n + " Attribut";
        if (n != 1) {
          out += "e";
        }
        out += " haben";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "muss " + cond + " sein";
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "darf nicht weniger als " + n + " Element";
        if (n != 1) {
          out += "e";
        }
        out += " haben";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "darf nicht kürzer als " + n + " Zeichen sein";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "darf nicht weniger als " + n + " Attribut";
        if (n != 1) {
          out += "e";
        }
        out += " haben";
        break;
      case "multipleOf":
        out = "muss ein Vielfaches von " + e.params.multipleOf + " sein";
        break;
      case "not":
        out = 'muss dem in "not" angegebenen Schema widersprechen';
        break;
      case "oneOf":
        out = 'muss genau einem der Schemata in "oneOf" entsprechen';
        break;
      case "pattern":
        out = 'muss diesem Muster entsprechen: "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'muss ein Attribut nach folgendem Muster haben "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "Attributname ist ungültig";
        break;
      case "required":
        out = "muss das erforderliche Attribut " + e.params.missingProperty + " enthalten";
        break;
      case "type":
        out = "muss sein: " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "darf nicht mehr als " + n + " Element";
        if (n != 1) {
          out += "e";
        }
        out += " haben";
        break;
      case "unevaluatedProperties":
        out = "darf keine unausgewerteten Attribute haben";
        break;
      case "uniqueItems":
        out = "darf keine Duplikate enthalten (Elemente #" + e.params.j + " und #" + e.params.i + " sind gleich)";
        break;
      default:
        out = 'muss die Validierung "' + e.keyword + '" bestehen';
    }
    e.message = out;
  }
};
var es = function localize_es(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "no debe tener más de " + n + " elemento";
        if (n != 1) {
          out += "s";
        }
        break;
      case "additionalProperties":
        out = "no debe tener propiedades adicionales";
        break;
      case "anyOf":
        out = 'debe coincidir con algún esquema en "anyOf"';
        break;
      case "const":
        out = "debe ser igual a la constante";
        break;
      case "contains":
        out = "debe contener un elemento válido";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "debe contener la";
        if (n != 1) {
          out += "s";
        }
        out += " propiedad";
        if (n != 1) {
          out += "es";
        }
        out += " " + e.params.deps + " cuando la propiedad " + e.params.property + " se encuentra presente";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'debe pasar la validación de palabra clave "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "deber ser igual a uno de los valores predefinidos";
        break;
      case "false schema":
        out = "el esquema és falso";
        break;
      case "format":
        out = 'debe coincidir con el formato "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "debe ser " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "debe ser " + cond;
        break;
      case "if":
        out = 'debe corresponderse con el esquema "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "debe ser " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "no debe contener más de " + n + " elemento";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "no debe contener más de " + n + " caracter";
        if (n != 1) {
          out += "es";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "no debe contener más de " + n + " propiedad";
        if (n != 1) {
          out += "es";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "debe ser " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "no debe contener menos de " + n + " elemento";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "no debe contener menos de " + n + " caracter";
        if (n != 1) {
          out += "es";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "no debe contener menos de " + n + " propiedad";
        if (n != 1) {
          out += "es";
        }
        break;
      case "multipleOf":
        out = "debe ser múltiplo de " + e.params.multipleOf;
        break;
      case "not":
        out = 'no debe ser válido según el esquema en "not"';
        break;
      case "oneOf":
        out = 'debe coincidir con un solo esquema en "oneOf"';
        break;
      case "pattern":
        out = 'debe coincidir con el patron "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'la propiedad debe coincidir con el patrón "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "la propiedad no és válida";
        break;
      case "required":
        out = "debe tener la propiedad requerida " + e.params.missingProperty;
        break;
      case "type":
        out = "debe ser " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "no debe contener elementos duplicados, (los elementos ## " + e.params.j + " y " + e.params.i + " son idénticos)";
        break;
      default:
        out = 'debe pasar la validación de palabra clave "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var fi = function localize_fi(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "saa sisältää enintään " + n;
        if (n == 1) {
          out += ":n elementin";
        } else {
          out += " elementtiä";
        }
        break;
      case "additionalProperties":
        out = "ei saa sisältää ylimääräisiä ominaisuuksia";
        break;
      case "anyOf":
        out = 'täytyy vastata "anyOf" skeemaa';
        break;
      case "const":
        out = "täytyy olla yhtä kuin vakio";
        break;
      case "contains":
        out = "täytyy sisältää kelvollinen elementti";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "täytyy sisältää " + e.params.deps + " ominaisuu";
        if (n == 1) {
          out += "s";
        } else {
          out += "det";
        }
        out += " kun " + e.params.property + "-ominaisuus on läsnä";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tunniste "' + e.params.tag + '" täytyy olla merkkijono';
            break;
          case "mapping":
            out = 'tunnisteen "' + e.params.tag + '" arvon muoto pitää olla oneOf';
            break;
          default:
            out = 'täytyy läpäistä "' + e.keyword + '" avainsanatarkistus';
        }
        break;
      case "enum":
        out = "täytyy olla yhtä kuin jokin sallituista arvoista";
        break;
      case "false schema":
        out = "boolean skeema on väärä";
        break;
      case "format":
        out = 'täytyy vastata muotoa "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "täytyy olla " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "täytyy olla " + cond;
        break;
      case "if":
        out = 'täytyy vastata "' + e.params.failingKeyword + '" skeemaa';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "täytyy olla " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "tulee sisältää enintään " + n + " ";
        if (n == 1) {
          out += "elementti";
        } else {
          out += "elementtiä";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "ei saa olla pidempi kuin " + n + " merkki";
        if (n != 1) {
          out += "ä";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "tulee sisältää enintään " + n + " ";
        if (n == 1) {
          out += "ominaisuus";
        } else {
          out += "ominaisuutta";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "täytyy olla " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "tulee sisältää vähintään " + n + " ";
        if (n == 1) {
          out += "elementti";
        } else {
          out += "elementtiä";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "ei saa olla lyhyempi kuin " + n + " merkki";
        if (n != 1) {
          out += "ä";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "tulee sisältää vähintään " + n + " ";
        if (n == 1) {
          out += "ominaisuus";
        } else {
          out += "ominaisuutta";
        }
        break;
      case "multipleOf":
        out = "täytyy olla moninkertainen: " + e.params.multipleOf;
        break;
      case "not":
        out = 'ei saa olla hyväksytty skeeman "not" mukaan';
        break;
      case "oneOf":
        out = 'täytyy vastata täsmälleen yhtä "oneOf" -kohdassa määriteltyä skeemaa';
        break;
      case "pattern":
        out = 'täytyy vastata muotoa "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'täytyy sisältää ominaisuus joka vastaa kaavaa "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "ominaisuuden nimi on virheellinen";
        break;
      case "required":
        out = "täytyy sisältää vaadittu ominaisuus " + e.params.missingProperty;
        break;
      case "type":
        out = "";
        var t = e.params.type;
        out += "täytyy olla ";
        if (t == "number") {
          out += "numero";
        } else if (t == "integer") {
          out += "kokonaisluku";
        } else if (t == "string") {
          out += "merkkijono";
        } else if (t == "boolean") {
          out += "boolean";
        } else {
          out += t;
        }
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "ei saa olla enemmän kuin " + n + " elementti";
        if (n != 1) {
          out += "ä";
        }
        break;
      case "unevaluatedProperties":
        out = "ei saa sisältää arvioimattomia ominaisuuksia";
        break;
      case "uniqueItems":
        out = "ei saa sisältää duplikaatteja (elementit ## " + e.params.j + " ja " + e.params.i + " ovat identtiset)";
        break;
      default:
        out = 'täytyy läpäistä "' + e.keyword + '" avainsanatarkistus';
    }
    e.message = out;
  }
};
var fr = function localize_fr(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "ne doit pas contenir plus de " + n + " élémént";
        if (n != 1) {
          out += "s";
        }
        break;
      case "additionalProperties":
        out = "ne doit pas contenir de propriétés additionnelles";
        break;
      case "anyOf":
        out = 'doit correspondre à un schéma de "anyOf"';
        break;
      case "const":
        out = "doit être égal à la constante";
        break;
      case "contains":
        out = "doit contenir un élément valide";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "doit avoir la propriété " + e.params.deps + " quand la propriété " + e.params.property + " est présente";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'doit être valide selon le critère "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "doit être égal à une des valeurs prédéfinies";
        break;
      case "false schema":
        out = 'le schema est "false"';
        break;
      case "format":
        out = 'doit correspondre au format "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "doit être " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "doit être " + cond;
        break;
      case "if":
        out = 'doit correspondre au schéma "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "doit être " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "ne doit pas contenir plus de " + n + " élément";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "ne doit pas dépasser " + n + " caractère";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "ne doit pas contenir plus de " + n + " propriété";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "doit être " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "ne doit pas contenir moins de " + n + " élément";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "ne doit pas faire moins de " + n + " caractère";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "ne doit pas contenir moins de " + n + " propriété";
        if (n != 1) {
          out += "s";
        }
        break;
      case "multipleOf":
        out = "doit être un multiple de " + e.params.multipleOf;
        break;
      case "not":
        out = 'est invalide selon le schéma "not"';
        break;
      case "oneOf":
        out = 'doit correspondre à exactement un schéma de "oneOf"';
        break;
      case "pattern":
        out = 'doit correspondre au format "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'la propriété doit correspondre au format "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "le nom de propriété est invalide";
        break;
      case "required":
        out = "requiert la propriété " + e.params.missingProperty;
        break;
      case "type":
        out = "doit être de type " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "ne doit pas contenir de doublons (les éléments ## " + e.params.j + " et " + e.params.i + " sont identiques)";
        break;
      default:
        out = 'doit être valide selon le critère "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var hu = function localize_hu(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "nem lehet több, mint " + n + " eleme";
        break;
      case "additionalProperties":
        out = "nem lehetnek további elemei";
        break;
      case "anyOf":
        out = 'meg kell feleljen legalább egy "anyOf" alaknak';
        break;
      case "const":
        out = "must be equal to constant";
        break;
      case "contains":
        out = "must contain a valid item";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "-nak kell legyen";
        if (n > 1) {
          out += "ek";
        }
        out += " a következő tulajdonsága";
        if (n != 1) {
          out += "i";
        }
        out += ": " + e.params.deps + ", ha van " + e.params.property + " tulajdonsága";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'must pass "' + e.keyword + '" keyword validation';
        }
        break;
      case "enum":
        out = "egyenlő kell legyen valamely előre meghatározott értékkel";
        break;
      case "false schema":
        out = "boolean schema is false";
        break;
      case "format":
        out = 'meg kell feleljen a következő formátumnak: "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "if":
        out = 'must match "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "kell legyen " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "nem lehet több, mint " + n + " eleme";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "nem lehet hosszabb, mint " + n + " szimbólum";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "nem lehet több, mint " + n + " tulajdonsága";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "kell legyen " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "nem lehet kevesebb, mint " + n + " eleme";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "nem lehet rövidebb, mint " + n + " szimbólum";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "nem lehet kevesebb, mint " + n + " tulajdonsága";
        break;
      case "multipleOf":
        out = "a többszöröse kell legyen a következő számnak: " + e.params.multipleOf;
        break;
      case "not":
        out = 'nem lehet érvényes a "not" alaknak megfelelően';
        break;
      case "oneOf":
        out = 'meg kell feleljen pontosan egy "oneOf" alaknak';
        break;
      case "pattern":
        out = 'meg kell feleljen a következő mintának: "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'must have property matching pattern "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "property name is invalid";
        break;
      case "required":
        out = "kell legyen " + e.params.missingProperty + " tulajdonsága";
        break;
      case "type":
        out = "" + e.params.type + " kell legyen";
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "nem lehetnek azonos elemei (" + e.params.j + " és " + e.params.i + " elemek azonosak)";
        break;
      default:
        out = 'must pass "' + e.keyword + '" keyword validation';
    }
    e.message = out;
  }
};
var id = function localize_id(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += " tidak boleh memiliki lebih dari " + n + " item";
        break;
      case "additionalProperties":
        out = "tidak boleh memiliki properti tambahan";
        break;
      case "anyOf":
        out = 'harus cocok dengan beberapa skema pada "anyOf"';
        break;
      case "const":
        out = "harus sama dengan konstan";
        break;
      case "contains":
        out = "harus berisi item yang valid";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += " harus memiliki properti " + e.params.deps + " ketika properti " + e.params.property + " hadir";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'harus lulus validasi kata kunci "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "harus sama dengan salah satu dari nilai yang telah ditentukan";
        break;
      case "false schema":
        out = "skema boolean salah";
        break;
      case "format":
        out = 'harus cocok dengan format "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "harus " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "harus " + cond;
        break;
      case "if":
        out = 'harus cocok dengan skema "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "harus " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += " tidak boleh memiliki lebih dari " + n + " item";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += " tidak boleh lebih dari " + n + " karakter";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += " tidak boleh memiliki lebih dari " + n + " properti";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "harus " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += " tidak boleh kurang dari " + n + " item";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += " tidak boleh lebih pendek dari " + n + " karakter";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += " tidak boleh kurang dari " + n + " properti";
        break;
      case "multipleOf":
        out = "harus merupakan kelipatan dari " + e.params.multipleOf;
        break;
      case "not":
        out = 'tidak boleh valid sesuai dengan skema pada "not"';
        break;
      case "oneOf":
        out = 'harus sama persis dengan satu skema pada "oneOf"';
        break;
      case "pattern":
        out = 'harus cocok dengan pola "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'harus memiliki pola pencocokan properti "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "nama properti tidak valid";
        break;
      case "required":
        out = "harus memiliki properti " + e.params.missingProperty;
        break;
      case "type":
        out = "harus berupa " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "tidak boleh memiliki item duplikat (item ## " + e.params.j + " dan " + e.params.i + " identik)";
        break;
      default:
        out = 'harus lulus validasi kata kunci "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var it = function localize_it(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "non dovrebbe avere più di " + n + " element";
        if (n == 1) {
          out += "o";
        } else {
          out += "i";
        }
        break;
      case "additionalProperties":
        out = "non deve avere attributi aggiuntivi";
        break;
      case "anyOf":
        out = 'deve corrispondere ad uno degli schema in "anyOf"';
        break;
      case "const":
        out = "deve essere uguale alla costante";
        break;
      case "contains":
        out = "deve contentere un elemento valido";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "dovrebbe avere ";
        if (n == 1) {
          out += "l'";
        } else {
          out += "gli ";
        }
        out += "attribut";
        if (n == 1) {
          out += "o";
        } else {
          out += "i";
        }
        out += " " + e.params.deps + " quando l'attributo " + e.params.property + " è presente";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'il tag "' + e.params.tag + '" deve essere di tipo stringa';
            break;
          case "mapping":
            out = 'il valore del tag "' + e.params.tag + '" deve essere nei oneOf';
            break;
          default:
            out = 'deve essere valido secondo il criterio "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "deve essere uguale ad uno dei valori consentiti";
        break;
      case "false schema":
        out = "lo schema booleano è falso";
        break;
      case "format":
        out = 'deve corrispondere al formato "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve essere " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve essere " + cond;
        break;
      case "if":
        out = 'deve corrispondere allo schema "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve essere " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "non deve avere più di " + n + " element";
        if (n == 1) {
          out += "o";
        } else {
          out += "i";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "non deve essere più lungo di " + n + " caratter";
        if (n == 1) {
          out += "e";
        } else {
          out += "i";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "non deve avere più di " + n + " attribut";
        if (n == 1) {
          out += "o";
        } else {
          out += "i";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve essere " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "non deve avere meno di " + n + " element";
        if (n == 1) {
          out += "o";
        } else {
          out += "i";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "non deve essere meno lungo di " + n + " caratter";
        if (n == 1) {
          out += "e";
        } else {
          out += "i";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "non deve avere meno di " + n + " attribut";
        if (n == 1) {
          out += "o";
        } else {
          out += "i";
        }
        break;
      case "multipleOf":
        out = "deve essere un multiplo di " + e.params.multipleOf;
        break;
      case "not":
        out = 'non deve essere valido in base allo schema di "non"';
        break;
      case "oneOf":
        out = 'deve corrispondere esattamente ad uno degli schema in "oneOf"';
        break;
      case "pattern":
        out = 'deve corrispondere al formato "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'deve avere un attributo che corrisponda al formato "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "il nome dell'attritbuto non è valido";
        break;
      case "required":
        out = "deve avere l'attributo obbligatorio " + e.params.missingProperty;
        break;
      case "type":
        out = "deve essere di tipo " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "non deve avere più di " + n + " elementi";
        if (n == 1) {
          out += "o";
        } else {
          out += "i";
        }
        break;
      case "unevaluatedProperties":
        out = "non deve avere attributi non valutati";
        break;
      case "uniqueItems":
        out = "non deve avere duplicati (gli elementi ## " + e.params.j + " e " + e.params.i + " sono uguali)";
        break;
      default:
        out = 'deve essere valido secondo il criterio "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var ja = function localize_ja(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "は" + n + "以上あってはいけない";
        break;
      case "additionalProperties":
        out = "追加してはいけない";
        break;
      case "anyOf":
        out = '"anyOf"のスキーマとマッチしなくてはいけない';
        break;
      case "const":
        out = "must be equal to constant";
        break;
      case "contains":
        out = "must contain a valid item";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "" + e.params.property + "がある場合、";
        var n = e.params.depsCount;
        out += "は" + e.params.deps + "をつけなければいけない";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'must pass "' + e.keyword + '" keyword validation';
        }
        break;
      case "enum":
        out = "事前に定義された値のいずれかに等しくなければいけない";
        break;
      case "false schema":
        out = "boolean schema is false";
        break;
      case "format":
        out = '"' + e.params.format + '"形式に揃えなければいけない';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "must be " + cond;
        break;
      case "if":
        out = 'must match "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += cond + "でなければいけない";
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "は" + n + "個以上であってはいけない";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "は" + n + "文字以上であってはいけない";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "は" + n + "個以上のプロパティを有してはいけない";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += cond + "でなければいけない";
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "は" + n + "個以下であってはいけない";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "は" + n + "文字以下であってはいけない";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "は" + n + "個以下のプロパティを有してはいけない";
        break;
      case "multipleOf":
        out = "" + e.params.multipleOf + "の倍数でなければいけない";
        break;
      case "not":
        out = '"not"のスキーマに従って有効としてはいけない';
        break;
      case "oneOf":
        out = '"oneOf"のスキーマと完全に一致しなくてはいけない';
        break;
      case "pattern":
        out = '"' + e.params.pattern + '"のパターンと一致しなければいけない';
        break;
      case "patternRequired":
        out = 'must have property matching pattern "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "property name is invalid";
        break;
      case "required":
        out = "必要なプロパティ" + e.params.missingProperty + "がなければいけない";
        break;
      case "type":
        out = "" + e.params.type + "でなければいけない";
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "重複するアイテムがあってはいけない（" + e.params.j + "と" + e.params.i + "は同じである）";
        break;
      default:
        out = 'must pass "' + e.keyword + '" keyword validation';
    }
    e.message = out;
  }
};
var ko = function localize_ko(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += " 항목은 아이템을 " + n + "개 이상 가질 수 없습니다";
        break;
      case "additionalProperties":
        out = "추가적인 속성은 허용되지 않습니다";
        break;
      case "anyOf":
        out = '"anyOf"의 스키마와 일치해야 합니다';
        break;
      case "const":
        out = "상수와 같아야합니다";
        break;
      case "contains":
        out = "올바른 아이템을 포함해야 합니다";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += e.params.property + "속성이 있는 경우, " + e.params.deps + " 속성이 있어야합니다";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = '"' + e.params.tag + '"태그는 반드시 문자열이여야 합니다';
            break;
          case "mapping":
            out = '"' + e.params.tag + '"태그의 값은 반드시 oneOf에 있어야 합니다';
            break;
          default:
            out = '"' + e.keyword + '"키워드 검사를 통과해야 합니다';
        }
        break;
      case "enum":
        out = "미리 정의된 값중 하나여야 합니다";
        break;
      case "false schema":
        out = "boolean 스키마는 올바르지 않습니다";
        break;
      case "format":
        out = '"' + e.params.format + '" 포맷과 일치해야 합니다';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " " + cond + " 이여야 합니다";
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " " + cond + " 이여야 합니다";
        break;
      case "if":
        out = '"' + e.params.failingKeyword + '" 스키마와 일치해야 합니다';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " " + cond + " 이여야 합니다";
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "아이템이 최대 " + n + "개이여야 합니다";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "최대 " + n + "글자여야 합니다";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "속성은 최대 " + n + "개 이내여야 합니다";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += " " + cond + " 이여야 합니다";
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "아이템이 최소 " + n + "개이여야 합니다";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "최소 " + n + "글자여야 합니다";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "속성은 최소 " + n + "개 이상이여야 합니다";
        break;
      case "multipleOf":
        out = "" + e.params.multipleOf + "의 배수여야 합니다";
        break;
      case "not":
        out = '"not"스키마에 따라 유효하지 않아야 합니다';
        break;
      case "oneOf":
        out = '"oneOf" 스키마중 하나와 정확하게 일치해야 합니다';
        break;
      case "pattern":
        out = '"' + e.params.pattern + '"패턴과 일치해야 합니다';
        break;
      case "patternRequired":
        out = '"' + e.params.missingPattern + '"패턴과 일치하는 속성을 가져야 합니다';
        break;
      case "propertyNames":
        out = "속성명이 올바르지 않습니다";
        break;
      case "required":
        out = "" + e.params.missingProperty + " 속성은 필수입니다";
        break;
      case "type":
        out = "" + e.params.type + "이여야 합니다";
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "항목이 " + n + "개 아이템을 초과하면 안됩니다";
        break;
      case "unevaluatedProperties":
        out = "평가되지 않은 속성이 없어야합니다.";
        break;
      case "uniqueItems":
        out = "중복 아이템이 없어야 합니다 (아이템" + e.params.j + "과 아이템" + e.params.i + "가 동일합니다)";
        break;
      default:
        out = '"' + e.keyword + '"키워드 검사를 통과해야 합니다';
    }
    e.message = out;
  }
};
var nb = function localize_nb(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "kan ikke ha mer enn " + n + " element";
        if (n != 1) {
          out += "er";
        }
        break;
      case "additionalProperties":
        out = "kan ikke ha flere egenskaper";
        break;
      case "anyOf":
        out = 'må samsvare med et schema i "anyOf"';
        break;
      case "const":
        out = "må være lik konstanten";
        break;
      case "contains":
        out = "må inneholde et gyldig element";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "må ha egenskapen";
        if (n != 1) {
          out += "e";
        }
        out += " " + e.params.deps + " når egenskapen " + e.params.property + " er angitt";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = "må samsvare med valideringen for " + e.keyword;
        }
        break;
      case "enum":
        out = "må være lik en av de forhåndsdefinerte verdiene";
        break;
      case "false schema":
        out = "boolsk schema er usannt";
        break;
      case "format":
        out = 'må stemme overens med formatet "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "må være " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "må være " + cond;
        break;
      case "if":
        out = 'must match "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "må være " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "kan ikke ha fler enn " + n + " element";
        if (n != 1) {
          out += "er";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "kan ikke være lengre enn " + n + " tegn";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "kan ikke ha mer enn " + n + " egenskap";
        if (n != 1) {
          out += "er";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "må være " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "kan ikke ha færre enn " + n + " element";
        if (n != 1) {
          out += "er";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "kan ikke være kortere enn " + n + " tegn";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "kan ikke ha mindre enn " + n + " egenskap";
        if (n != 1) {
          out += "er";
        }
        break;
      case "multipleOf":
        out = "må være et multiplum av " + e.params.multipleOf;
        break;
      case "not":
        out = 'kan ikke samsvare med schema i "not"';
        break;
      case "oneOf":
        out = 'må samsvare med nøyaktig ett schema i "oneOf"';
        break;
      case "pattern":
        out = 'må samsvare med mønsteret "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'må ha en egenskap som samsvarer med mønsteret "' + e.params.missingPattern;
        break;
      case "propertyNames":
        out = "egenskapen med navnet '";
        e.params.propertyNameout += "' er ugyldig";
        break;
      case "required":
        out = "må ha den påkrevde egenskapen " + e.params.missingProperty;
        break;
      case "type":
        out = "";
        var t = e.params.type;
        out += "må være ";
        if (t == "number") {
          out += "et tall";
        } else if (t == "integer") {
          out += "et heltall";
        } else if (t == "string") {
          out += "en streng";
        } else if (t == "boolean") {
          out += "ja eller nei";
        } else {
          out += t;
        }
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "kan ikke ha duplikate elemeneter (elementene ## " + e.params.j + " og " + e.params.i + " er identiske)";
        break;
      default:
        out = "må samsvare med valideringen for " + e.keyword;
    }
    e.message = out;
  }
};
var nl = function localize_nl(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "mag niet meer dan " + n + " item";
        if (n != 1) {
          out += "s";
        }
        out += " bevatten";
        break;
      case "additionalProperties":
        out = "mag geen extra eigenschappen bevatten";
        break;
      case "anyOf":
        out = 'moet overeenkomen met een schema in "anyOf"';
        break;
      case "const":
        out = "moet gelijk zijn aan constante";
        break;
      case "contains":
        out = "moet een geldig item bevatten";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "moet de eigenschap";
        if (n != 1) {
          out += "pen";
        }
        out += " " + e.params.deps + " bevatten als " + e.params.property + " is gedefinieerd";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" moet een tekenreeks zijn';
            break;
          case "mapping":
            out = 'de waarde van het veld "' + e.params.tag + '" moet voorkomen in de oneOf';
            break;
          default:
            out = 'moet sleutelwoord validatie "' + e.keyword + '" doorstaan';
        }
        break;
      case "enum":
        out = "moet overeenkomen met één van de voorgedefinieerde waarden";
        break;
      case "false schema":
        out = "boolean schema is fout";
        break;
      case "format":
        out = 'moet overeenkomen met het volgende formaat: "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "moet " + cond + " zijn";
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "moet " + cond + " zijn";
        break;
      case "if":
        out = 'moet overeenkomen met "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "moet " + cond + " zijn";
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "mag niet meer dan " + n + " item";
        if (n != 1) {
          out += "s";
        }
        out += " bevatten";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "mag niet langer dan " + n + " karakter";
        if (n != 1) {
          out += "s";
        }
        out += " zijn";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "mag niet meer dan " + n + " eigenschap";
        if (n != 1) {
          out += "pen";
        }
        out += " bevatten";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "moet " + cond + " zijn";
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "mag niet minder dan " + n + " item";
        if (n != 1) {
          out += "s";
        }
        out += " bevatten";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "mag niet korter dan " + n + " karakter";
        if (n != 1) {
          out += "s";
        }
        out += " zijn";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "mag niet minder dan " + n + " eigenschap";
        if (n != 1) {
          out += "pen";
        }
        out += " bevatten";
        break;
      case "multipleOf":
        out = "moet een veelvoud van " + e.params.multipleOf + " zijn";
        break;
      case "not":
        out = 'mag niet overeenkomen met een schema in "not"';
        break;
      case "oneOf":
        out = 'moet overeenkomen met één schema in "oneOf"';
        break;
      case "pattern":
        out = 'moet overeenkomen met het volgende patroon: "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'moet een eigenschap bevatten die overeenkomt met het pattroon: "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "eigenschapnaam is ongeldig";
        break;
      case "required":
        out = "moet de eigenschap " + e.params.missingProperty + " bevatten";
        break;
      case "type":
        out = "";
        var t = e.params.type;
        out += "moet een ";
        if (t == "number") {
          out += "nummer";
        } else if (t == "integer") {
          out += "geheel getal";
        } else if (t == "string") {
          out += "tekenreeks";
        } else if (t == "boolean") {
          out += "ja of nee waarde";
        }
        out += " (" + t + ") bevatten";
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "mag niet meer dan " + n + " item";
        if (n != 1) {
          out += "s";
        }
        out += " bevatten";
        break;
      case "unevaluatedProperties":
        out = "mag geen ongecontroleerde eigenschappen bevatten";
        break;
      case "uniqueItems":
        out = "mag geen gedupliceerde items bevatten (items ## " + e.params.j + " en " + e.params.i + " zijn identiek)";
        break;
      default:
        out = 'moet sleutelwoord validatie "' + e.keyword + '" doorstaan';
    }
    e.message = out;
  }
};
var pl = function localize_pl(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "nie powinien mieć więcej niż " + n + " element";
        if (n == 1) {
          out += "u";
        } else {
          out += "ów";
        }
        break;
      case "additionalProperties":
        out = "nie powinien zawierać dodatkowych pól";
        break;
      case "anyOf":
        out = 'powinien pasować do wzoru z sekcji "anyOf"';
        break;
      case "const":
        out = "powinien być równy stałej";
        break;
      case "contains":
        out = "must contain a valid item";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "powinien zawierać pol";
        if (n == 1) {
          out += "e";
        } else {
          out += "a";
        }
        out += " " + e.params.deps + " kiedy pole " + e.params.property + " jest obecne";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'powinien przejść walidację "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "powinien być równy jednej z predefiniowanych wartości";
        break;
      case "false schema":
        out = "boolean schema is false";
        break;
      case "format":
        out = 'powinien zgadzać się z formatem "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "powinien być " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "powinien być " + cond;
        break;
      case "if":
        out = 'must match "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "powinien być " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "nie powinien mieć więcej niż " + n + " element";
        if (n == 1) {
          out += "u";
        } else {
          out += "ów";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "nie powinien być dłuższy niż " + n + " znak";
        if (n != 1) {
          out += "ów";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "nie powinien zawierać więcej niż " + n + " ";
        if (n == 1) {
          out += "pole";
        } else {
          out += "pól";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "powinien być " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "nie powinien mieć mniej niż " + n + " element";
        if (n == 1) {
          out += "u";
        } else {
          out += "ów";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "nie powinien być krótszy niż " + n + " znak";
        if (n != 1) {
          out += "ów";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "nie powinien zawierać mniej niż " + n + " ";
        if (n == 1) {
          out += "pole";
        } else {
          out += "pól";
        }
        break;
      case "multipleOf":
        out = "powinien być wielokrotnością " + e.params.multipleOf;
        break;
      case "not":
        out = 'nie powinien pasować do wzoru z sekcji "not"';
        break;
      case "oneOf":
        out = 'powinien pasować do jednego wzoru z sekcji "oneOf"';
        break;
      case "pattern":
        out = 'powinien zgadzać się ze wzorem "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'powinien mieć pole pasujące do wzorca "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "property name is invalid";
        break;
      case "required":
        out = "powinien zawierać wymagane pole " + e.params.missingProperty;
        break;
      case "type":
        out = "powinien być " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "nie powinien zawierać elementów które się powtarzają (elementy " + e.params.j + " i " + e.params.i + " są identyczne)";
        break;
      default:
        out = 'powinien przejść walidację "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var ptBR = function localize_pt_BR(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "não são permitidos itens adicionais (mais do que " + n + ")";
        break;
      case "additionalProperties":
        out = "não são permitidas propriedades adicionais";
        break;
      case "anyOf":
        out = 'os dados não correspondem a nenhum schema de "anyOf"';
        break;
      case "const":
        out = "deve ser igual à constante";
        break;
      case "contains":
        out = "deve conter um item válido";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += " deve ter propriedade";
        if (n != 1) {
          out += "s";
        }
        out += " " + e.params.deps + " quando a propriedade " + e.params.property + " estiver presente";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'a tag "' + e.params.tag + '" deve ser uma string';
            break;
          case "mapping":
            out = 'o valor da tag "' + e.params.tag + '" deve estar no oneOf';
            break;
          default:
            out = 'deve passar a validação da keyword "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "deve ser igual a um dos valores permitidos";
        break;
      case "false schema":
        out = 'o schema booleano é "false"';
        break;
      case "format":
        out = 'deve corresponder ao formato "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve ser " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve ser " + cond;
        break;
      case "if":
        out = 'deve corresponder ao schema "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve ser " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "não deve ter mais que " + n + " elemento";
        if (n != 1) {
          out += "s";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "não deve ser maior que " + n + " caracter";
        if (n != 1) {
          out += "es";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "não deve ter mais que " + n + " propriedade";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "deve ser " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "não deve ter menos que " + n + " elemento";
        if (n != 1) {
          out += "s";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "não deve ser mais curta que " + n + " caracter";
        if (n != 1) {
          out += "es";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "não deve ter menos que " + n + " propriedade";
        if (n != 1) {
          out += "s";
        }
        break;
      case "multipleOf":
        out = "deve ser múltiplo de " + e.params.multipleOf;
        break;
      case "not":
        out = 'não deve ser valido segundo o schema em "not"';
        break;
      case "oneOf":
        out = 'deve corresponder exatamente com um schema em "oneOf"';
        break;
      case "pattern":
        out = 'deve corresponder ao padrão "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'deve ter a propriedade correspondente ao padrão "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "o nome da propriedade é inválido";
        break;
      case "required":
        out = "deve ter a propriedade obrigatória " + e.params.missingProperty;
        break;
      case "type":
        out = "";
        var t = e.params.type;
        out += "deve ser ";
        if (t == "number") {
          out += "um número";
        } else if (t == "integer") {
          out += "um número inteiro";
        } else if (t == "string") {
          out += "um texto";
        } else if (t == "boolean") {
          out += "um booleano";
        } else {
          out += t;
        }
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "não pode possuir mais que " + n + " ";
        if (n == 1) {
          out += "item";
        } else {
          out += "itens";
        }
        break;
      case "unevaluatedProperties":
        out = "não pode possuir propridades não avaliadas";
        break;
      case "uniqueItems":
        out = "não deve ter itens duplicados (os itens ## " + e.params.j + " e " + e.params.i + " são idênticos)";
        break;
      default:
        out = 'deve passar a validação da keyword "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var ru = function localize_ru(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "должно иметь не более, чем " + n + " элемент";
        if (n >= 2 && n <= 4) {
          out += "а";
        } else if (n != 1) {
          out += "ов";
        }
        break;
      case "additionalProperties":
        out = "не должно иметь дополнительных полей";
        break;
      case "anyOf":
        out = 'должно соответствовать одной их схем в "anyOf"';
        break;
      case "const":
        out = "должно быть равно заданному значению";
        break;
      case "contains":
        out = "должно содержать значение соответствующее схеме";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "должно иметь пол";
        if (n == 1) {
          out += "е";
        } else {
          out += "я";
        }
        out += " " + e.params.deps + ", когда присутствует поле " + e.params.property;
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'поле "' + e.params.tag + '" должно быть строкой';
            break;
          case "mapping":
            out = 'значение поля "' + e.params.tag + '" должно быть в одной из oneOf схем ';
            break;
          default:
            out = 'должно соответствовать правилу "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "должно быть равно одному из разрешенных значений";
        break;
      case "false schema":
        out = "схема равна false";
        break;
      case "format":
        out = 'должно соответствовать формату "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "должно быть " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "должно быть " + cond;
        break;
      case "if":
        out = 'должно соответствовать схемe "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "должно быть " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "должно иметь не более, чем " + n + " элемент";
        if (n >= 2 && n <= 4) {
          out += "а";
        } else if (n != 1) {
          out += "ов";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "должно быть не длиннее, чем " + n + " символ";
        if (n >= 2 && n <= 4) {
          out += "а";
        } else if (n != 1) {
          out += "ов";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "должно иметь не более, чем " + n + " пол";
        if (n == 1) {
          out += "е";
        } else if (n >= 2 && n <= 4) {
          out += "я";
        } else {
          out += "ей";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "должно быть " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "должно иметь не менее, чем " + n + " элемент";
        if (n >= 2 && n <= 4) {
          out += "а";
        } else if (n != 1) {
          out += "ов";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "должно быть не короче, чем " + n + " символ";
        if (n >= 2 && n <= 4) {
          out += "а";
        } else if (n != 1) {
          out += "ов";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "должно иметь не менее, чем " + n + " пол";
        if (n == 1) {
          out += "е";
        } else if (n >= 2 && n <= 4) {
          out += "я";
        } else {
          out += "ей";
        }
        break;
      case "multipleOf":
        out = "должно быть кратным " + e.params.multipleOf;
        break;
      case "not":
        out = 'должно не соответствовать схеме в "not"';
        break;
      case "oneOf":
        out = 'должно соответствовать в точности одной схемe в "oneOf"';
        break;
      case "pattern":
        out = 'должно соответствовать образцу "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'должно иметь поле, соответствующее образцу "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "имя поля не соответствует схеме";
        break;
      case "required":
        out = "должно иметь обязательное поле " + e.params.missingProperty;
        break;
      case "type":
        out = "должно быть " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "должно иметь не более, чем " + n + " элемент";
        if (n >= 2 && n <= 4) {
          out += "а";
        } else if (n != 1) {
          out += "ов";
        }
        break;
      case "unevaluatedProperties":
        out = "не должно иметь непроверенных полей";
        break;
      case "uniqueItems":
        out = "не должно иметь повторяющихся элементов (элементы " + e.params.j + " и " + e.params.i + " идентичны)";
        break;
      default:
        out = 'должно соответствовать правилу "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var sk = function localize_sk(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "nemôže obsahovať viac, než " + n + " prv";
        if (n == 1) {
          out += "ok";
        } else {
          out += "kov";
        }
        break;
      case "additionalProperties":
        out = "nemôže obsahovať ďalšie položky";
        break;
      case "anyOf":
        out = 'musí splňovať aspoň jednu zo schém v "anyOf"';
        break;
      case "const":
        out = "musí byť konštanta";
        break;
      case "contains":
        out = "musí obsahovať prvok zodpovedajúci schéme";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += " musí obsahovať polož";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "iek";
        } else {
          out += "ka";
        }
        out += ": " + e.params.deps + ", ak obsahuje " + e.params.property;
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'musí splniť "' + e.keyword + '" validáciu';
        }
        break;
      case "enum":
        out = "musí byť jedna z definovaných hodnôt";
        break;
      case "false schema":
        out = "schéma je false";
        break;
      case "format":
        out = 'musí obsahovať formát "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí byť " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí byť " + cond;
        break;
      case "if":
        out = 'must match "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí byť " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "nesmie obsahovať viac než " + n + " prv";
        if (n == 1) {
          out += "ok";
        } else {
          out += "kov";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "nesmie byť dlhší než " + n + " znak";
        if (n != 1) {
          out += "ov";
        }
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "nesmie obsahovať viac než " + n + " polož";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "iek";
        } else {
          out += "ka";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "musí byť " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "nesmie obsahovať menej než " + n + " prv";
        if (n == 1) {
          out += "ok";
        } else {
          out += "kov";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "nesmie byť kratší než " + n + " znak";
        if (n != 1) {
          out += "ov";
        }
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "nesmie obsahovať menej než " + n + " polož";
        if (n >= 2 && n <= 4) {
          out += "ky";
        } else if (n != 1) {
          out += "iek";
        } else {
          out += "ka";
        }
        break;
      case "multipleOf":
        out = "musí byť násobkom " + e.params.multipleOf;
        break;
      case "not":
        out = 'nesmie splňovať schému v "not"';
        break;
      case "oneOf":
        out = 'musí splňovať práve jednu schému v "oneOf"';
        break;
      case "pattern":
        out = 'musí splňovať regulárny výraz "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'musí obsahovať položku splňjúcu regulárny výraz "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "názov položky nezodpovedá schéme";
        break;
      case "required":
        out = "musí obsahovať požadovanú položku " + e.params.missingProperty;
        break;
      case "type":
        out = "musí byť " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "nesmie obsahovať duplicitné prvky (prvky ## " + e.params.j + " a " + e.params.i + " sú rovnaké)";
        break;
      default:
        out = 'musí splniť "' + e.keyword + '" validáciu';
    }
    e.message = out;
  }
};
var sv = function localize_sv(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "borde ha fler än " + n + " sak";
        if (n != 1) {
          out += "er";
        }
        break;
      case "additionalProperties":
        out = "borde inte ha fler egenskaper";
        break;
      case "anyOf":
        out = 'borde matcha något schema i "anyOf"';
        break;
      case "const":
        out = "bör vara en konstant";
        break;
      case "contains":
        out = "bör innehålla ett giltigt objekt";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "borde ha egenskap";
        if (n != 1) {
          out += "er";
        }
        out += " " + e.params.deps + " när egenskap " + e.params.property + " finns tillgängligt";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" must be string';
            break;
          case "mapping":
            out = 'value of tag "' + e.params.tag + '" must be in oneOf';
            break;
          default:
            out = 'bör passera "' + e.keyword + '" nyckelord validering';
        }
        break;
      case "enum":
        out = "borde vara ekvivalent med en av dess fördefinierade värden";
        break;
      case "false schema":
        out = "boolean schema är falskt";
        break;
      case "format":
        out = 'borde matcha formatet "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "bör vara " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "bör vara " + cond;
        break;
      case "if":
        out = 'must match "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "borde vara " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "borde inte ha fler än " + n + " sak";
        if (n != 1) {
          out += "er";
        }
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "borde inte vara längre än " + n + " tecken";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "borde inte ha fler än " + n + " egenskap";
        if (n != 1) {
          out += "er";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "borde vara " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "borde inte ha färre än " + n + " sak";
        if (n != 1) {
          out += "er";
        }
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "borde inte vara kortare än " + n + " tecken";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "borde inte ha färre än " + n + " egenskap";
        if (n != 1) {
          out += "er";
        }
        break;
      case "multipleOf":
        out = "borde vara en multipel av " + e.params.multipleOf;
        break;
      case "not":
        out = 'borde inte vara giltigt enligt schema i "not"';
        break;
      case "oneOf":
        out = 'borde matcha exakt ett schema i "oneOf"';
        break;
      case "pattern":
        out = 'borde matcha mönstret "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'bör ha en egenskap som matchar mönstret "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "egenskap med namnet är inte giltig";
        break;
      case "required":
        out = "borde ha den nödvändiga egenskapen " + e.params.missingProperty;
        break;
      case "type":
        out = "borde vara " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "must NOT have more than " + n + " item";
        if (n != 1) {
          out += "s";
        }
        break;
      case "unevaluatedProperties":
        out = "must NOT have unevaluated properties";
        break;
      case "uniqueItems":
        out = "borde inte ha duplicerade saker (sakerna ## " + e.params.j + " och " + e.params.i + " är identiska)";
        break;
      default:
        out = 'bör passera "' + e.keyword + '" nyckelord validering';
    }
    e.message = out;
  }
};
var th = function localize_th(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "ต้องมีสมาชิกไม่เกิน " + n + " ตัว";
        break;
      case "additionalProperties":
        out = "ต้องไม่มี property อื่นๆ นอกเหนีอจากที่กำหนดไว้";
        break;
      case "anyOf":
        out = 'ต้องตรงกับหนึ่งใน schema ที่กำหนดไว้ใน "anyOf"';
        break;
      case "const":
        out = "ต้องเท่ากับค่าคงที่";
        break;
      case "contains":
        out = "ต้องมีสมาชิกที่ผ่านเงื่อนไขอยู่";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "เมื่อมี property " + e.params.property + " แล้วจะต้องมี property " + e.params.deps + " ด้วย";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'tag "' + e.params.tag + '" ต้องเป็น string';
            break;
          case "mapping":
            out = 'ต้องมีค่าของ tag "' + e.params.tag + '" ใน oneOf';
            break;
          default:
            out = 'ต้องผ่านคีย์เวิร์ด "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "ต้องตรงกับหนึ่งในค่าที่กำหนดไว้";
        break;
      case "false schema":
        out = "schema เป็น false";
        break;
      case "format":
        out = 'ต้องเป็นรูปแบบ "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ต้อง " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ต้อง " + cond;
        break;
      case "if":
        out = 'ต้องตรงกับ schema "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ต้อง " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "ต้องมีสมาชิกไม่เกิน " + n;
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "ต้องยาวไม่เกิน " + n + " ตัวอักษร";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "ต้องมี property ไม่เกิน " + n + " ตัว";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "ต้อง " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "ควรมีสมาชิกไม่น้อยกว่า " + n;
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "ต้องมีอย่างน้อย " + n + " ตัวอักษร";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "ต้องมี property อย่างน้อย " + n + " ตัว";
        break;
      case "multipleOf":
        out = "ต้องเป็นเลขที่หาร " + e.params.multipleOf + " ลงตัว";
        break;
      case "not":
        out = 'ต้องไม่ผ่าน schema ที่กำหนดไว้ใน "not"';
        break;
      case "oneOf":
        out = 'ต้องตรงกับ schema ตัวเดียวใน "oneOf" เท่านั้น';
        break;
      case "pattern":
        out = 'ต้องตรงตาม pattern "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'ต้องมี property ที่มีชื่อตรงตาม pattern "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "ชื่อ property ไม่ถูกต้อง";
        break;
      case "required":
        out = "ต้องมี property " + e.params.missingProperty + " ด้วย";
        break;
      case "type":
        out = "ต้องเป็น " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += "ต้องมีไม่เกิน " + n + " ตัว";
        break;
      case "unevaluatedProperties":
        out = "ต้องไม่มี property ที่ยังไม่ได้ผ่านการตรวจสอบเงื่อนไขใดๆ";
        break;
      case "uniqueItems":
        out = "ต้องมีสมาชิกไม่ซ้ำักัน (ลำดับที่ " + e.params.j + " กับ " + e.params.i + " ซ้ำกัน)";
        break;
      default:
        out = 'ต้องผ่านคีย์เวิร์ด "' + e.keyword + '"';
    }
    e.message = out;
  }
};
var zh = function localize_zh(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "不允许超过" + n + "个元素";
        break;
      case "additionalProperties":
        out = "不允许有额外的属性";
        break;
      case "anyOf":
        out = "数据应为 anyOf 所指定的其中一个";
        break;
      case "const":
        out = "应当等于常量";
        break;
      case "contains":
        out = "应当包含一个有效项";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "应当拥有属性" + e.params.property + "的依赖属性" + e.params.deps;
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = '标签 "' + e.params.tag + '" 的类型必须为字符串';
            break;
          case "mapping":
            out = '标签 "' + e.params.tag + '" 的值必须在 oneOf 之中';
            break;
          default:
            out = '应当通过 "' + e.keyword + ' 关键词校验"';
        }
        break;
      case "enum":
        out = "应当是预设定的枚举值之一";
        break;
      case "false schema":
        out = "布尔模式出错";
        break;
      case "format":
        out = '应当匹配格式 "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "应当是 " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "应当是 " + cond;
        break;
      case "if":
        out = '应当匹配模式 "' + e.params.failingKeyword + '" ';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "应当为 " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "不应多于 " + n + " 个项";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "不应多于 " + n + " 个字符";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "不应有多于 " + n + " 个属性";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "应当为 " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "不应少于 " + n + " 个项";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "不应少于 " + n + " 个字符";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "不应有少于 " + n + " 个属性";
        break;
      case "multipleOf":
        out = "应当是 " + e.params.multipleOf + " 的整数倍";
        break;
      case "not":
        out = '不应当匹配 "not" schema';
        break;
      case "oneOf":
        out = '只能匹配一个 "oneOf" 中的 schema';
        break;
      case "pattern":
        out = '应当匹配模式 "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = "应当有属性匹配模式 " + e.params.missingPattern;
        break;
      case "propertyNames":
        out = "属性名 无效";
        break;
      case "required":
        out = "应当有必需属性 " + e.params.missingProperty;
        break;
      case "type":
        out = "应当是 " + e.params.type + " 类型";
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += " 不允许有超过 " + n + " 个元素";
        break;
      case "unevaluatedProperties":
        out = "不允许存在未求值的属性";
        break;
      case "uniqueItems":
        out = "不应当含有重复项 (第 " + e.params.j + " 项与第 " + e.params.i + " 项是重复的)";
        break;
      default:
        out = '应当通过 "' + e.keyword + ' 关键词校验"';
    }
    e.message = out;
  }
};
var zhTW = function localize_zh_TW(errors) {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        var n = e.params.limit;
        out += "不可以超過" + n + "個元素";
        break;
      case "additionalProperties":
        out = "不可以有額外的屬性";
        break;
      case "anyOf":
        out = "不符合 anyOf 指定的模式";
        break;
      case "const":
        out = "應該等於常數";
        break;
      case "contains":
        out = "應該包含一個有效元素";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        var n = e.params.depsCount;
        out += "應該要有屬性" + e.params.property + "的依賴屬性" + e.params.deps;
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = '標籤 "' + e.params.tag + '" 的類型必須是字串';
            break;
          case "mapping":
            out = '標籤 "' + e.params.tag + '" 必須在 oneOf 其中之一';
            break;
          default:
            out = '應該通過 "' + e.keyword + ' 關鍵詞檢驗"';
        }
        break;
      case "enum":
        out = "應該要在預設的值之中";
        break;
      case "false schema":
        out = "布林模式不正確";
        break;
      case "format":
        out = "應該要符合" + e.params.format + "格式";
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "應該是 " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "應該是 " + cond;
        break;
      case "if":
        out = '應該符合 "' + e.params.failingKeyword + '" schema';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "應該要 " + cond;
        break;
      case "maxItems":
        out = "";
        var n = e.params.limit;
        out += "不應該多於 " + n + " 個";
        break;
      case "maxLength":
        out = "";
        var n = e.params.limit;
        out += "不應該多於 " + n + " 個字元";
        break;
      case "maxProperties":
        out = "";
        var n = e.params.limit;
        out += "不應該多於 " + n + " 個屬性";
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        var cond = e.params.comparison + " " + e.params.limit;
        out += "應該要 " + cond;
        break;
      case "minItems":
        out = "";
        var n = e.params.limit;
        out += "不應該少於 " + n + " 個";
        break;
      case "minLength":
        out = "";
        var n = e.params.limit;
        out += "不應該少於 " + n + " 個字元";
        break;
      case "minProperties":
        out = "";
        var n = e.params.limit;
        out += "不應該少於 " + n + " 個屬性";
        break;
      case "multipleOf":
        out = "應該是 " + e.params.multipleOf + " 的整數倍";
        break;
      case "not":
        out = '不應該符合 "not" schema';
        break;
      case "oneOf":
        out = '只能符合一個 "oneOf" 中的 schema';
        break;
      case "pattern":
        out = '應該符合模式 "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = "應該有屬性對應模式 " + e.params.missingPattern;
        break;
      case "propertyNames":
        out = "属性名 無效";
        break;
      case "required":
        out = "應該有必須屬性 " + e.params.missingProperty;
        break;
      case "type":
        out = "應該是 " + e.params.type + " 類型";
        break;
      case "unevaluatedItems":
        out = "";
        var n = e.params.len;
        out += " 的元素不可以超過 " + n + " 個";
        break;
      case "unevaluatedProperties":
        out = "不應該有未驗證的屬性";
        break;
      case "uniqueItems":
        out = "不應該有重複項目 (第 " + e.params.j + " 項和第 " + e.params.i + " 項是重複的)";
        break;
      default:
        out = '應該通過 "' + e.keyword + ' 關鍵詞檢驗"';
    }
    e.message = out;
  }
};
var localize = {
  en,
  ar,
  ca,
  cs,
  de,
  es,
  fi,
  fr,
  hu,
  id,
  it,
  ja,
  ko,
  nb,
  nl,
  pl,
  "pt-BR": ptBR,
  ru,
  sk,
  sv,
  th,
  zh,
  "zh-TW": zhTW
};
const localize$1 = /* @__PURE__ */ getDefaultExportFromCjs(localize);
const localize_bg = (errors) => {
  if (!(errors && errors.length)) return;
  for (const e of errors) {
    let out;
    let n;
    let cond;
    switch (e.keyword) {
      case "additionalItems":
      case "items":
        out = "";
        n = e.params.limit;
        out += "не трябва да има повече от " + n + " елемент";
        if (n != 1) {
          out += "а";
        }
        break;
      case "additionalProperties":
        out = "не трябва да има допълнителни полета";
        break;
      case "anyOf":
        out = 'трябва да съответства на схема в "anyOf"';
        break;
      case "const":
        out = "трябва да бъде равно на константа";
        break;
      case "contains":
        out = "трябва да съдържа валиден елемент";
        break;
      case "dependencies":
      case "dependentRequired":
        out = "";
        n = e.params.depsCount;
        out += "трябва да има поле";
        if (n != 1) {
          out += "та";
        }
        out += " " + e.params.deps + " когато полето " + e.params.property + " е налично";
        break;
      case "discriminator":
        switch (e.params.error) {
          case "tag":
            out = 'полето "' + e.params.tag + '" трябва да бъде низ';
            break;
          case "mapping":
            out = 'стойноста на полето "' + e.params.tag + '" трябва да бъде в oneOf';
            break;
          default:
            out = 'трябва да премине валидацията на ключовата дума "' + e.keyword + '"';
        }
        break;
      case "enum":
        out = "трябва да бъде равно на едно от разрешените стойности";
        break;
      case "false schema":
        out = "схемата е равна на false";
        break;
      case "format":
        out = 'трябва да съответства на формата "' + e.params.format + '"';
        break;
      case "formatMaximum":
      case "formatExclusiveMaximum":
        out = "";
        cond = e.params.comparison + " " + e.params.limit;
        out += "трябва да бъде " + cond;
        break;
      case "formatMinimum":
      case "formatExclusiveMinimum":
        out = "";
        cond = e.params.comparison + " " + e.params.limit;
        out += "трябва да бъде " + cond;
        break;
      case "if":
        out = 'трябва да съответства на схемата "' + e.params.failingKeyword + '"';
        break;
      case "maximum":
      case "exclusiveMaximum":
        out = "";
        cond = e.params.comparison + " " + e.params.limit;
        out += "трябва да бъде " + cond;
        break;
      case "maxItems":
        out = "";
        n = e.params.limit;
        out += "не трябва да има повече от " + n + " елемент";
        if (n != 1) {
          out += "а";
        }
        break;
      case "maxLength":
        out = "";
        n = e.params.limit;
        out += "не трябва да бъде по-дълго от " + n + " символ";
        if (n != 1) {
          out += "а";
        }
        break;
      case "maxProperties":
        out = "";
        n = e.params.limit;
        out += "не трябва да има повече от " + n + " поле";
        if (n != 1) {
          out += "та";
        }
        break;
      case "minimum":
      case "exclusiveMinimum":
        out = "";
        cond = e.params.comparison + " " + e.params.limit;
        out += "трябва да бъде " + cond;
        break;
      case "minItems":
        out = "";
        n = e.params.limit;
        out += "не трябва да има по-малко от " + n + " елемент";
        if (n != 1) {
          out += "а";
        }
        break;
      case "minLength":
        out = "";
        n = e.params.limit;
        out += "не трябва да бъде по-късо от " + n + " символ";
        if (n != 1) {
          out += "а";
        }
        break;
      case "minProperties":
        out = "";
        n = e.params.limit;
        out += "не трябва да има по-малко от " + n + " поле";
        if (n != 1) {
          out += "та";
        }
        break;
      case "multipleOf":
        out = "трябва да бъде кратно на " + e.params.multipleOf;
        break;
      case "not":
        out = 'не трябва да бъде валидно съгласно схемата в "not"';
        break;
      case "oneOf":
        out = 'трябва да съответства точно на една схема в "oneOf"';
        break;
      case "pattern":
        out = 'трябва да съответства на шаблон "' + e.params.pattern + '"';
        break;
      case "patternRequired":
        out = 'трябва да има поле, което съответства на шаблон "' + e.params.missingPattern + '"';
        break;
      case "propertyNames":
        out = "името на полето е невалидно";
        break;
      case "required":
        out = "трябва да има задължително поле " + e.params.missingProperty;
        break;
      case "type":
        out = "трябва да бъде " + e.params.type;
        break;
      case "unevaluatedItems":
        out = "";
        n = e.params.len;
        out += "не трябва да има повече от " + n + " елемент";
        if (n != 1) {
          out += "а";
        }
        break;
      case "unevaluatedProperties":
        out = "не трябва да има непроверени полета";
        break;
      case "uniqueItems":
        out = "не трябва да има дублиращи се елементи (елементи ## " + e.params.j + " и " + e.params.i + " са идентични)";
        break;
      default:
        out = 'трябва да премине валидацията на ключовата дума "' + e.keyword + '"';
    }
    e.message = out;
  }
};
function injectAdditionalLocales() {
  const bg = "bg";
  if (!localize$1[bg]) {
    localize$1[bg] = localize_bg;
  }
  localize$1[bg] = (errors) => {
    if (!(errors && errors.length)) return;
    localize_bg(errors);
    for (const e of errors) {
      if (e.keyword === "required") {
        e.message = "полето е задължително";
      }
    }
  };
}
const ajvTranslations = (ajv, options) => {
  injectAdditionalLocales();
  const compileFunction = ajv.compile;
  ajv.compile = Object.assign(
    (...compileProps) => {
      const validateFunction = compileFunction.apply(ajv, compileProps);
      const newValidateFunction = Object.assign(
        (...innerProps) => {
          var _a;
          const validationResult = validateFunction.apply(
            compileFunction,
            innerProps
          );
          if (!validationResult && validateFunction.errors) {
            const i18n = (_a = options.i18n) == null ? void 0 : _a.value;
            const language = i18n ? i18n.locale : void 0;
            const localized = language && (localize$1[language] || localize$1[language.split("-")[0]]);
            if (localized) {
              localized(
                // exclude errorMessage keyword since the message itself will be comming from the schema itself and possible then translated
                validateFunction.errors.filter(
                  (error) => error.keyword !== "errorMessage"
                )
              );
            }
            validateFunction.errors = unwrapErrorMessageErrors(
              validateFunction.errors,
              options.i18n
            );
          }
          Object.assign(newValidateFunction, validateFunction);
          return validationResult;
        },
        validateFunction
      );
      return newValidateFunction;
    },
    compileFunction
  );
  return ajv;
};
const unwrapErrorMessageErrors = (errors, i18n) => {
  return errors.filter((error) => error["emUsed"] !== true).map((error) => {
    var _a;
    if (error.keyword === "errorMessage" && Array.isArray((_a = error.params) == null ? void 0 : _a.errors)) {
      const result = error.params.errors.map((paramError) => ({
        ...paramError,
        message: computed(
          () => {
            var _a2;
            return ((_a2 = i18n == null ? void 0 : i18n.value) == null ? void 0 : _a2.translate) && error.message ? i18n.value.translate(
              `error.errorMessage.${error.message}`,
              error.message
            ) : error.message;
          }
        )
      }));
      return result;
    }
    return error;
  }).flat();
};
const createAjv = (i18n) => {
  const options = {
    useDefaults: true,
    $data: true,
    discriminator: true
  };
  const ajv = createAjv$1(options);
  ajvKeywords(ajv);
  ajvErrors(ajv);
  ajvTranslations(ajv, { i18n });
  return markRaw(ajv);
};
const mapStateToButtonProps = (state, ownProps) => {
  const rootData = getData(state);
  const { uischema } = ownProps;
  const config = getConfig(state);
  const visible = ownProps.visible === void 0 || hasShowRule(uischema) ? isVisible(
    ownProps.uischema,
    rootData,
    ownProps.path,
    getAjv(state),
    config
  ) : ownProps.visible;
  const label = uischema.label;
  const icon = uischema.icon;
  const action = uischema.action;
  const script = uischema.script;
  const color = uischema.color;
  const params = uischema.params;
  const t = getTranslator()(state);
  const i18nKeyPrefix = getI18nKeyPrefixBySchema(void 0, uischema);
  const i18nKey = i18nKeyPrefix ? `${i18nKeyPrefix}.label` : label ?? "";
  const i18nText = t(i18nKey, label, { uischema });
  const enabled = isInherentlyEnabled(
    state,
    ownProps,
    uischema,
    void 0,
    // layouts have no associated schema
    rootData,
    config
  );
  return {
    label: i18nText,
    icon,
    action,
    script,
    params,
    visible,
    enabled,
    color,
    config: getConfig(state),
    renderers: ownProps.renderers || getRenderers(state),
    cells: ownProps.cells || getCells(state)
  };
};
const useJsonFormsButton = (props) => {
  const { control, ...other } = useControl(props, mapStateToButtonProps);
  return { button: control, ...other };
};
const useVuetifyButton = (input) => {
  const styles = useStyles(input.button.value.uischema);
  const appliedOptions = computed(
    () => merge(
      {},
      cloneDeep(input.button.value.config),
      cloneDeep(input.button.value.uischema.options)
    )
  );
  const vuetifyProps = (path) => {
    var _a;
    const props = get((_a = appliedOptions.value) == null ? void 0 : _a.vuetify, path);
    return props && isPlainObject(props) ? props : {};
  };
  return {
    ...input,
    appliedOptions,
    vuetifyProps,
    styles
  };
};
const useElementArrayControl = (input) => {
  const childUiSchema = computed(
    () => findUISchema(
      input.control.value.uischemas,
      input.control.value.schema,
      input.control.value.uischema.scope,
      input.control.value.path,
      void 0,
      input.control.value.uischema,
      input.control.value.rootSchema
    )
  );
  return {
    ...input,
    childUiSchema,
    composePaths
  };
};
const useFormContext = () => {
  const formContext = inject(FormContextKey);
  if (!formContext) {
    throw new Error(
      "'formContext' couldn't be injected. Are you within JsonForms?"
    );
  }
  return formContext;
};
const resolveUISchemaValidations = (uischema, config) => {
  if (!uischema) {
    return void 0;
  }
  const transformNode = (node) => {
    var _a;
    const transformed = { ...node };
    if ("rule" in transformed && ((_a = transformed.rule) == null ? void 0 : _a.condition) && typeof transformed.rule.condition === "object" && "validate" in transformed.rule.condition && typeof transformed.rule.condition.validate === "string") {
      const fnBody = transformed.rule.condition.validate;
      const validate = (context) => {
        try {
          const enhancedContext = {
            ...context,
            config: config == null ? void 0 : config.value
          };
          const validateFn = new Function(
            "context",
            `const validateFn = ${fnBody}; return validateFn(context);`
          );
          const result = validateFn(enhancedContext);
          if (typeof result !== "boolean") {
            console.error(
              `UISchema validate: expected boolean, got ${typeof result}`
            );
            return false;
          }
          return result;
        } catch (e) {
          console.error(`UISchema validate error:`, e);
          return false;
        }
      };
      transformed.rule.condition.validate = validate;
    }
    if ("elements" in transformed && Array.isArray(transformed.elements)) {
      transformed.elements = transformed.elements.map(transformNode);
    }
    return transformed;
  };
  return transformNode(uischema);
};
const parseAndTransformUISchemaRegistryEntries = (uischemaRegistryEntries) => {
  const uischemasMap = typeof uischemaRegistryEntries === "string" ? JSON.parse(uischemaRegistryEntries) : uischemaRegistryEntries ?? [];
  return uischemasMap.map((elem, index) => {
    if (typeof elem.tester === "string") {
      const action = (jsonSchema, schemaPath, path) => {
        try {
          const tester = new Function(
            "jsonSchema, schemaPath, path",
            `const NOT_APPLICABLE = -1; const tester = ${elem.tester}; return tester(jsonSchema, schemaPath, path);`
          );
          const result = tester(jsonSchema, schemaPath, path);
          if (typeof result !== "number") {
            console.error(
              `Error at uischema tester[${index}]: invalid result type, expected number but got ${typeof result}`
            );
          }
          return typeof result === "number" ? result : NOT_APPLICABLE;
        } catch (e) {
          console.error(`Error at uischema tester[${index}]: ${e}`);
          return NOT_APPLICABLE;
        }
      };
      return {
        tester: action,
        uischema: elem.uischema
      };
    } else if (typeof elem.tester === "function") {
      return {
        tester: elem.tester,
        uischema: elem.uischema
      };
    }
    return null;
  }).filter((x) => !!x);
};
const getLightDarkTheme = (dark, currentTheme, exists) => {
  if (!currentTheme || !exists(currentTheme)) {
    return dark ? "dark" : "light";
  }
  const isCurrentDark = currentTheme.endsWith("Dark") || currentTheme.includes("dark");
  if (dark && isCurrentDark || !dark && !isCurrentDark) {
    return currentTheme;
  }
  let newTheme;
  if (dark) {
    if (currentTheme.endsWith("Light")) {
      newTheme = currentTheme.replace("Light", "Dark");
    } else if (currentTheme.includes("light")) {
      newTheme = currentTheme.replace("light", "dark");
    } else {
      const darkVariant = currentTheme + "Dark";
      newTheme = exists(darkVariant) ? darkVariant : "dark";
    }
  } else {
    if (currentTheme.endsWith("Dark")) {
      const baseTheme = currentTheme.replace("Dark", "");
      const lightVariant = baseTheme + "Light";
      newTheme = exists(lightVariant) ? lightVariant : exists(baseTheme) ? baseTheme : "light";
    } else if (currentTheme.includes("dark")) {
      newTheme = currentTheme.replace("dark", "light");
    } else {
      newTheme = currentTheme;
    }
  }
  if (!exists(newTheme)) {
    newTheme = dark ? "dark" : "light";
  }
  return newTheme;
};
const ADDITIONAL_PROPERTIES = "additionalProperties";
const REQUIRED_PROPERTIES = "required";
const distinct = (properties, discriminator) => {
  const known = {};
  return properties.filter((item) => {
    const discriminatorValue = discriminator(item);
    if (Object.prototype.hasOwnProperty.call(known, discriminatorValue)) {
      return false;
    } else {
      known[discriminatorValue] = true;
      return true;
    }
  });
};
class Gen {
  constructor(findOption) {
    // TODO fix @typescript-eslint/ban-types
    // eslint-disable-next-line @typescript-eslint/ban-types
    __publicField(this, "schemaObject", (data) => {
      const props = this.properties(data);
      const schema = {
        type: "object",
        properties: props,
        additionalProperties: this.findOption(props)(ADDITIONAL_PROPERTIES)
      };
      const required = this.findOption(props)(REQUIRED_PROPERTIES);
      if (required.length > 0) {
        schema.required = required;
      }
      return schema;
    });
    __publicField(this, "properties", (data) => {
      const emptyProps = {};
      return Object.keys(data).reduce((acc, propName) => {
        acc[propName] = this.property(data[propName]);
        return acc;
      }, emptyProps);
    });
    __publicField(this, "property", (data) => {
      switch (typeof data) {
        case "string":
          return { type: "string" };
        case "boolean":
          return { type: "boolean" };
        case "number":
          if (Number.isInteger(data)) {
            return { type: "integer" };
          }
          return { type: "number" };
        case "object":
          if (data == null) {
            return { type: "null" };
          }
          return this.schemaObjectOrArray(data);
        default:
          return {};
      }
    });
    __publicField(this, "schemaObjectOrArray", (data) => {
      if (data instanceof Array) {
        return this.schemaArray(data);
      } else {
        return this.schemaObject(data);
      }
    });
    __publicField(this, "schemaArray", (data) => {
      if (data.length > 0) {
        const allProperties = data.map(this.property);
        const uniqueProperties = distinct(
          allProperties,
          (prop) => JSON.stringify(prop)
        );
        if (uniqueProperties.length === 1) {
          return {
            type: "array",
            items: uniqueProperties[0]
          };
        } else {
          return {
            type: "array",
            items: {
              oneOf: uniqueProperties
            }
          };
        }
      } else {
        return {
          type: "array",
          items: {}
        };
      }
    });
    this.findOption = findOption;
  }
}
const generateJsonSchema = (instance, options = {}) => {
  const findOption = (props) => (optionName) => {
    switch (optionName) {
      case ADDITIONAL_PROPERTIES:
        if (Object.prototype.hasOwnProperty.call(options, ADDITIONAL_PROPERTIES)) {
          return options[ADDITIONAL_PROPERTIES];
        }
        return true;
      case REQUIRED_PROPERTIES:
        if (Object.prototype.hasOwnProperty.call(options, REQUIRED_PROPERTIES)) {
          return options[REQUIRED_PROPERTIES](props);
        }
        return Object.keys(props);
      default:
        return;
    }
  };
  const gen = new Gen(findOption);
  return gen.property(instance);
};
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "ResolvedJsonForms",
  props: {
    state: {},
    vuetifyConfig: {}
  },
  emits: ["change", "handle-action"],
  setup(__props, { emit: __emit }) {
    var _a, _b;
    const props = __props;
    const resolvedSchema = reactive({
      schema: void 0,
      resolved: false,
      error: void 0
    });
    const configToUse = ref(props.state.config);
    const resolvedUiSchema = ref(
      resolveUISchemaValidations(props.state.uischema, configToUse)
    );
    const emits = __emit;
    const onChange = (event) => {
      data.value = event.data;
      emits("change", event);
    };
    watch(
      () => props.state.data,
      (value) => {
        data.value = value;
        if (!props.state.schema) {
          resolvedSchema.schema = generateJsonSchema(value);
          if (!props.state.uischema) {
            resolvedUiSchema.value = Generate.uiSchema(
              resolvedSchema.schema,
              void 0,
              void 0,
              resolvedSchema.schema
            ) ?? {
              type: "VerticalLayout",
              elements: []
            };
            if (resolvedUiSchema.value.type === "VerticalLayout") {
              resolvedUiSchema.value.options = {
                vuetify: {
                  "v-container": {
                    fluid: true
                  },
                  "v-row": {
                    "no-gutters": true
                  }
                }
              };
            }
          }
        } else if (!props.state.uischema) {
          resolvedUiSchema.value = Generate.uiSchema(
            resolvedSchema.schema ?? props.state.schema,
            void 0,
            void 0,
            resolvedSchema.schema
          ) ?? {
            type: "VerticalLayout",
            elements: []
          };
          if (resolvedUiSchema.value.type === "VerticalLayout") {
            resolvedUiSchema.value.options = {
              vuetify: {
                "v-container": {
                  fluid: true
                },
                "v-row": {
                  "no-gutters": true
                }
              }
            };
          }
        }
      }
    );
    watch(
      () => props.state.schema,
      async (schema) => {
        await resolveSchema(schema, props.state.schemaUrl);
      }
    );
    watch(
      () => props.state.schemaUrl,
      async (schemaUrl) => {
        await resolveSchema(props.state.schema, schemaUrl);
      }
    );
    watch(
      () => props.state.readonly,
      (value) => {
        readonly.value = value;
      }
    );
    watch(
      () => props.state.additionalErrors,
      (value) => {
        additionalErrors.value = value;
      }
    );
    watch(
      () => props.state.ajv,
      (value) => {
        ajv.value = value ?? createAjv(ajvI18N);
      }
    );
    watch(
      () => props.state.i18n,
      (value) => {
        ajvI18N.value = value;
      }
    );
    watch(
      () => props.state.middleware,
      (value) => {
        middleware.value = createMiddlewareWrapper(value ?? defaultMiddleware);
      }
    );
    watch(
      () => props.state.config,
      (config) => {
        configToUse.value = config;
      },
      { deep: true }
    );
    watch(
      () => props.state.uischema,
      (uischema) => {
        resolvedUiSchema.value = resolveUISchemaValidations(uischema, configToUse);
      },
      { deep: true }
    );
    watch(
      () => props.vuetifyConfig,
      (vuetifyConfig) => {
        var _a2;
        Object.assign(vuetifyConfigToUse, vuetifyConfig);
        vuetifyConfigToUse.dark = ((_a2 = themeInstance.themes.value[vuetifyConfigToUse.theme]) == null ? void 0 : _a2.dark) ?? false;
      },
      { deep: true }
    );
    const resolveSchema = async (schema, schemaUrl) => {
      resolvedSchema.schema = void 0;
      resolvedSchema.resolved = false;
      resolvedSchema.error = void 0;
      if (schema) {
        const refFilter = (refDetails, _path) => {
          var _a2, _b2;
          if (refDetails.type === "local") {
            let uri = (_a2 = refDetails == null ? void 0 : refDetails.uriDetails) == null ? void 0 : _a2.fragment;
            uri = uri ? uri.replace(/\//g, ".") : uri;
            if (uri == null ? void 0 : uri.startsWith(".")) {
              uri = uri.substring(1);
            }
            if (uri && ((_b2 = get(schema, uri)) == null ? void 0 : _b2.$id)) {
              return false;
            }
          }
          return true;
        };
        try {
          const resolveResult = await JsonRefs.resolveRefs(schema, {
            location: schemaUrl,
            filter: refFilter
          });
          resolvedSchema.schema = resolveResult.resolved;
          resolvedSchema.resolved = true;
        } catch (err) {
          resolvedSchema.resolved = true;
          resolvedSchema.error = err instanceof Error ? err.message : String(err);
        }
      } else {
        resolvedSchema.resolved = true;
      }
    };
    onMounted(async () => {
      await resolveSchema(props.state.schema, props.state.schemaUrl);
    });
    const resolvingSchemaMessage = computed(() => {
      var _a2;
      const message = "Resolving Schema...";
      if ((_a2 = props.state.i18n) == null ? void 0 : _a2.translate) {
        return props.state.i18n.translate(message, message);
      }
      return message;
    });
    const createMiddlewareWrapper = (wrappedFunction) => {
      return (state, action, defaultReducer) => {
        const core = wrappedFunction(state, action, defaultReducer);
        jsonformsCore.value = core;
        return core;
      };
    };
    const errorTitle = computed(() => {
      var _a2;
      const message = "Error resolving schema";
      if ((_a2 = props.state.i18n) == null ? void 0 : _a2.translate) {
        return props.state.i18n.translate(
          "ResolvedJsonForms.resolve_schema_error_title",
          message
        );
      }
      return message;
    });
    const currentInstance = getCurrentInstance();
    const jsonformsCore = ref(void 0);
    const themeInstance = useTheme();
    const vuetifyConfigToUse = reactive({
      ...props.vuetifyConfig,
      dark: ((_b = themeInstance.themes.value[(_a = props.vuetifyConfig) == null ? void 0 : _a.theme]) == null ? void 0 : _b.dark) ?? false
    });
    const readonly = ref(props.state.readonly);
    const data = ref(props.state.data);
    const additionalErrors = ref(props.state.additionalErrors);
    const ajvI18N = ref(props.state.i18n);
    const ajv = shallowRef(props.state.ajv ?? createAjv(ajvI18N));
    const middleware = shallowRef(
      createMiddlewareWrapper(props.state.middleware ?? defaultMiddleware)
    );
    const defaultContext = ref({
      schemaUrl: props.state.schemaUrl,
      uidata: reactive({}),
      vuetify: vuetifyConfigToUse,
      config: computed(() => properties.value.config),
      readonly,
      locale: computed(() => {
        var _a2;
        return (_a2 = properties.value.i18n) == null ? void 0 : _a2.locale;
      }),
      translate: computed(() => {
        var _a2;
        return (_a2 = properties.value.i18n) == null ? void 0 : _a2.translate;
      }),
      data,
      schema: computed(() => {
        var _a2;
        return (_a2 = jsonformsCore.value) == null ? void 0 : _a2.schema;
      }),
      uischema: computed(() => {
        var _a2;
        return (_a2 = jsonformsCore.value) == null ? void 0 : _a2.uischema;
      }),
      errors: computed(() => {
        var _a2;
        return (_a2 = jsonformsCore.value) == null ? void 0 : _a2.errors;
      }),
      additionalErrors,
      fireActionEvent: async (action, params, el, element) => {
        var _a2;
        const source = {
          action,
          context: context.value,
          // the action parameters passes from the UI schema
          params: params ? { ...params } : {},
          $el: el ?? ((_a2 = currentInstance == null ? void 0 : currentInstance.proxy) == null ? void 0 : _a2.$el),
          element
        };
        (handleActionEmitter ?? emits)("handle-action", source);
        if (isFunction(source.callback)) {
          await source.callback(source);
        } else {
          console.log("action [" + action + "] is not handled");
        }
      }
    });
    const properties = computed(() => ({
      ...props.state,
      readonly: readonly.value,
      data: data.value,
      additionalErrors: additionalErrors.value,
      uischema: resolvedUiSchema.value,
      config: configToUse.value,
      schema: resolvedSchema.schema ?? props.state.schema,
      renderers: props.state.renderers ? markRaw(props.state.renderers) : props.state.renderers,
      cells: props.state.cells ? markRaw(props.state.cells) : props.state.cells,
      ajv: ajv.value,
      middleware: middleware.value
    }));
    const registerCurrentSchema = (schema, ajv2) => {
      const currentSchemaId = "/";
      ajv2.removeSchema(currentSchemaId);
      if (schema) {
        const { schemaId } = ajv2.opts;
        let id2 = schema[schemaId];
        if (id2) {
          id2 = normalizeId(id2);
          if (id2 && !id2.startsWith("#") && "http://json-schema.org/draft-07/schema" !== id2) {
            if (ajv2.getSchema(id2)) {
              ajv2.removeSchema(id2);
            }
          }
        }
        const registeredSchema = { ...schema, [schemaId]: currentSchemaId };
        ajv2.addSchema(registeredSchema);
      }
    };
    watch(
      () => properties.value.schema,
      (schema) => {
        registerCurrentSchema(schema, properties.value.ajv);
      }
    );
    watch(
      () => properties.value.ajv,
      (ajv2) => {
        registerCurrentSchema(properties.value.schema, ajv2);
      }
    );
    watch(
      () => vuetifyConfigToUse.dark,
      (dark, oldDark) => {
        if (dark !== oldDark) {
          vuetifyConfigToUse.theme = getLightDarkTheme(
            dark,
            vuetifyConfigToUse.theme,
            (theme) => themeInstance.themes.value[theme] !== void 0
          );
        }
      }
    );
    const overrideContext = inject(
      FormContextKey,
      void 0
    );
    const context = overrideContext ? ref({
      ...toRefs(defaultContext.value),
      ...toRefs(overrideContext.value)
    }) : defaultContext;
    provide(FormContextKey, context);
    const handleActionEmitter = inject(
      HandleActionEmitterKey,
      void 0
    );
    if (!handleActionEmitter) {
      provide(HandleActionEmitterKey, emits);
    }
    return (_ctx, _cache) => {
      var _a2;
      return openBlock(), createBlock(unref(VLocaleProvider), {
        rtl: vuetifyConfigToUse.rtl,
        locale: (_a2 = properties.value.i18n) == null ? void 0 : _a2.locale
      }, {
        default: withCtx(() => [
          createVNode(unref(VThemeProvider), {
            theme: vuetifyConfigToUse.theme
          }, {
            default: withCtx(() => [
              createVNode(unref(VDefaultsProvider), {
                defaults: vuetifyConfigToUse.defaults
              }, {
                default: withCtx(() => [
                  resolvedSchema.resolved && resolvedSchema.error === void 0 ? (openBlock(), createBlock(unref(JsonForms), mergeProps({ key: 0 }, properties.value, { onChange }), null, 16)) : (openBlock(), createBlock(unref(VContainer), {
                    key: 1,
                    style: { "height": "400px" }
                  }, {
                    default: withCtx(() => [
                      !resolvedSchema.resolved ? (openBlock(), createBlock(unref(VRow), {
                        key: 0,
                        class: "fill-height",
                        "align-content": "center",
                        justify: "center"
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(VCol), {
                            class: "text-subtitle-1 text-center",
                            cols: "12"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(resolvingSchemaMessage.value), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(unref(VCol), { cols: "6" }, {
                            default: withCtx(() => [
                              createVNode(unref(VProgressLinear), {
                                indeterminate: "",
                                rounded: "",
                                height: "6"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })) : resolvedSchema.error !== void 0 ? (openBlock(), createBlock(unref(VRow), {
                        key: 1,
                        class: "fill-height",
                        "align-content": "center",
                        justify: "center"
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(VCol), {
                            class: "text-subtitle-1 text-center",
                            cols: "12"
                          }, {
                            default: withCtx(() => [
                              createVNode(unref(VAlert), {
                                title: errorTitle.value,
                                text: resolvedSchema.error,
                                type: "error"
                              }, null, 8, ["title", "text"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }, 8, ["defaults"])
            ]),
            _: 1
          }, 8, ["theme"])
        ]),
        _: 1
      }, 8, ["rtl", "locale"]);
    };
  }
});
const allowedTags = [
  "div",
  "span",
  "p",
  "section",
  "article",
  "header",
  "footer",
  "main",
  "aside",
  "ul",
  "ol",
  "li",
  "button",
  "a",
  "strong",
  "em",
  "small",
  "label",
  "slot",
  "style"
];
const dangerousAttributes = /* @__PURE__ */ new Set([
  // HTML injection
  "innerhtml",
  "outerhtml",
  "srcdoc",
  // Form manipulation
  "action",
  "formaction",
  "formenctype",
  "formmethod",
  "formtarget",
  // CSS injection
  "style",
  // Import/module related
  "import",
  "importmap",
  // Meta refresh
  "http-equiv",
  // Sandbox escaping
  "sandbox"
]);
function isAllowedTag(value) {
  return allowedTags.includes(
    typeof value === "string" ? value.toLowerCase() : value
  );
}
function isSafeUrl(url) {
  const lower = url.toLowerCase().trim();
  if (lower.startsWith("javascript:") || lower.startsWith("data:")) {
    return false;
  }
  return lower.startsWith("/") || lower.startsWith("./") || lower.startsWith("../") || lower.startsWith("http://") || lower.startsWith("https://") || lower.startsWith("mailto:") || lower.startsWith("tel:") || lower.startsWith("#");
}
const _sfc_main$5 = defineComponent({
  name: "dynamic-element",
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      required: true,
      validator: (value) => isAllowedTag(value)
    }
  },
  setup(props, { attrs, slots }) {
    return () => {
      const tag = typeof props.tag === "string" ? props.tag.toLowerCase() : props.tag;
      if (!isAllowedTag(tag)) {
        return null;
      }
      const safeAttrs = {};
      for (const [key, val] of Object.entries(attrs)) {
        const lowerKey = key.toLowerCase();
        if (dangerousAttributes.has(lowerKey)) {
          continue;
        }
        if (lowerKey.startsWith("on")) {
          continue;
        }
        if ((lowerKey === "href" || lowerKey === "src") && typeof val === "string") {
          if (!isSafeUrl(val)) {
            continue;
          }
        }
        safeAttrs[key] = val;
      }
      return h(
        tag,
        safeAttrs,
        Object.keys(slots).length ? Object.fromEntries(
          Object.entries(slots).map(([name, slotFn]) => [name, slotFn])
        ) : void 0
      );
    };
  }
});
const allowedSlotAttributes = /* @__PURE__ */ new Set([
  "name",
  // Primary slot attribute
  "slot",
  // For slot assignment
  "id",
  // For targeting
  "class",
  // For styling
  "style",
  // Safe for slots since they're just placeholders
  "title",
  // For accessibility
  "aria-label",
  "aria-describedby",
  "role"
]);
const _sfc_main$4 = defineComponent({
  name: "slot-element",
  inheritAttrs: false,
  setup(props, { attrs, slots }) {
    return () => {
      const safeAttrs = {};
      for (const [key, val] of Object.entries(attrs)) {
        const lowerKey = key.toLowerCase();
        if (lowerKey.startsWith("on")) {
          continue;
        }
        if (!allowedSlotAttributes.has(lowerKey)) {
          continue;
        }
        safeAttrs[key] = val;
      }
      return h(
        "slot",
        safeAttrs,
        Object.keys(slots).length ? Object.fromEntries(
          Object.entries(slots).map(([name, slotFn]) => [name, slotFn])
        ) : void 0
      );
    };
  }
});
const templateCompiler = defineComponent({
  name: "template-compiler",
  components: {
    DispatchRenderer
  },
  inheritAttrs: false,
  props: {
    parent: {
      type: [Object]
    },
    template: {
      type: String,
      default: "<div></div>"
    },
    layout: {
      type: Object,
      required: true
    },
    componentDirectives: {
      type: [Object]
    },
    componentComputed: {
      type: [Object]
    },
    componentMethods: {
      type: [Object]
    },
    componentFilters: {
      type: [Object]
    },
    componentComponents: {
      type: [Object]
    },
    elements: {
      type: [Array]
    }
  },
  data() {
    return {
      component: null
    };
  },
  computed: {
    componentProps() {
      const data = [
        //this.parentData,
        //this.parentProps,
        //(this.parentComponent as any)._provided,
      ];
      const computed2 = this.componentComputed || {};
      const directives = this.componentDirectives || {};
      const methods = this.componentMethods || {};
      const filters = this.componentFilters || {};
      const components2 = this.componentComponents || {};
      return {
        components: components2,
        directives,
        computed: computed2,
        filters,
        methods,
        data: () => merge({}, ...data)
      };
    },
    parentComponent() {
      return this.parent || this.$parent;
    },
    parentData() {
      var _a;
      return ((_a = this.parentComponent) == null ? void 0 : _a.$data) || {};
    },
    parentProps() {
      var _a;
      return ((_a = this.parentComponent) == null ? void 0 : _a.$props) || {};
    },
    defaultElement() {
      return this.elements !== void 0 && this.elements.length == 1 ? this.elements[0] : void 0;
    }
  },
  created() {
    const render = compile(this.template);
    this.component = markRaw(
      defineComponent(
        merge(
          {
            render
          },
          unref(this.componentProps)
        )
      )
    );
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dispatch_renderer = resolveComponent("dispatch-renderer");
  return _ctx.component ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.component), normalizeProps(mergeProps({ key: 0 }, _ctx.$attrs)), createSlots({ _: 2 }, [
    _ctx.defaultElement ? {
      name: "default",
      fn: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, () => [
          (openBlock(), createBlock(_component_dispatch_renderer, {
            key: `${_ctx.layout.path}-${0}`,
            schema: _ctx.layout.schema,
            uischema: _ctx.defaultElement,
            path: _ctx.layout.path,
            enabled: _ctx.layout.enabled,
            renderers: _ctx.layout.renderers,
            cells: _ctx.layout.cells
          }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"]))
        ])
      ]),
      key: "0"
    } : void 0,
    renderList(_ctx.elements, (element, index) => {
      return {
        name: `${element.name}`,
        fn: withCtx(() => [
          renderSlot(_ctx.$slots, element.name, {}, () => [
            (openBlock(), createBlock(_component_dispatch_renderer, {
              key: `${_ctx.layout.path}-${index}`,
              schema: _ctx.layout.schema,
              uischema: element,
              path: _ctx.layout.path,
              enabled: _ctx.layout.enabled,
              renderers: _ctx.layout.renderers,
              cells: _ctx.layout.cells
            }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"]))
          ])
        ])
      };
    })
  ]), 1040)) : createCommentVNode("", true);
}
const TemplateCompiler = /* @__PURE__ */ _export_sfc(templateCompiler, [["render", _sfc_render$g]]);
const _sfc_main$3 = defineComponent({
  name: "VSplitpanes",
  components: {
    Splitpanes
  },
  inheritAttrs: false,
  setup() {
    const rtl = useRtl();
    return {
      rtl
    };
  }
});
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_splitpanes = resolveComponent("splitpanes");
  return openBlock(), createBlock(_component_splitpanes, mergeProps(_ctx.$attrs, {
    class: "v-splitpanes",
    rtl: _ctx.rtl.isRtl.value
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["rtl"]);
}
const VSplitpanes = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$f]]);
const _sfc_main$2 = defineComponent({
  name: "VPane",
  components: {
    Pane
  },
  inheritAttrs: false
});
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pane = resolveComponent("pane");
  return openBlock(), createBlock(_component_pane, mergeProps(_ctx.$attrs, { class: "v-pane" }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16);
}
const VPane = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$e]]);
const VMonacoEditor$2 = () => import("./index-CiWiNs-d.js").then((m) => m.VMonacoEditor);
const createTranslator = (locale, translations) => {
  let localeTranslations = translations ? translations[locale] : void 0;
  if (!localeTranslations && translations) {
    const dashIndex = locale.indexOf("-");
    localeTranslations = dashIndex > 0 ? translations[locale.substring(0, dashIndex)] : void 0;
  }
  if (!localeTranslations) {
    localeTranslations = translations ? translations["en"] : void 0;
  }
  const translate = (id2, defaultMessage, values) => {
    const message = localeTranslations ? get(localeTranslations, id2) : defaultMessage;
    if (message && values) {
      return translateWithParams(message, values) ?? defaultMessage;
    }
    return message ?? defaultMessage;
  };
  return translate;
};
const translateWithParams = memoize(templateToMessage);
function templateToMessage(templateMessage, params = {}) {
  const compiled = templateFn(templateMessage, {
    interpolate: /\${([\s\S]+?)}/g
    // ${myVar}
  });
  try {
    return compiled(params);
  } catch (e) {
    console.log(`Unable to generate message from template: ${templateMessage}`);
    return templateMessage;
  }
}
const controlRenderer$d = defineComponent({
  name: "button-renderer",
  components: {
    VBtn,
    VIcon
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const t = useTranslator();
    const button = useVuetifyButton(useJsonFormsButton(props));
    const formContext = useFormContext();
    const loading = ref(false);
    return {
      ...button,
      t,
      formContext,
      loading
    };
  },
  methods: {
    async click() {
      var _a, _b;
      this.loading = true;
      try {
        if (this.button.action) {
          await ((_b = (_a = this.formContext).fireActionEvent) == null ? void 0 : _b.call(
            _a,
            this.button.action,
            this.button.params ? { ...this.button.params } : {},
            this.$el,
            this.button.uischema
          ));
        } else if (this.button.script) {
          const source = {
            action: this.button.action,
            context: this.formContext,
            // the action parameters passes from the UI schema
            params: this.button.params ? { ...this.button.params } : {},
            $el: this.$el,
            element: this.button.uischema
          };
          await new AsyncFunction(this.button.script).call(source);
        }
      } finally {
        this.loading = false;
      }
    }
  }
});
const _hoisted_1$2 = { key: 1 };
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  return _ctx.button.visible ? (openBlock(), createBlock(_component_v_btn, mergeProps({
    key: 0,
    disabled: !_ctx.button.enabled,
    loading: _ctx.loading,
    color: _ctx.button.color
  }, _ctx.vuetifyProps("v-btn"), {
    icon: _ctx.button.icon !== void 0,
    onClick: _ctx.click
  }), {
    default: withCtx(() => [
      _ctx.button.icon ? (openBlock(), createBlock(_component_v_icon, { key: 0 }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.button.icon), 1)
        ]),
        _: 1
      })) : createCommentVNode("", true),
      _ctx.button.label ? (openBlock(), createElementBlock("span", _hoisted_1$2, toDisplayString(_ctx.button.label), 1)) : createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["disabled", "loading", "color", "icon", "onClick"])) : createCommentVNode("", true);
}
const buttonRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$d, [["render", _sfc_render$d]]);
const controlRenderer$c = defineComponent({
  name: "data-provider-renderer",
  components: {
    DispatchRenderer
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const layout = useVuetifyLayout(useJsonFormsLayout(props));
    const jsonforms = useJsonForms();
    const formContext = useFormContext();
    const data = computed(() => {
      var _a;
      return (_a = jsonforms.core) == null ? void 0 : _a.data;
    });
    const dataProvider = reactive({
      loading: true,
      data: void 0,
      error: void 0
    });
    const url = computed(() => {
      const url2 = layout.layout.value.uischema.url;
      if (url2) {
        return template(url2, {
          imports: {
            data,
            context: formContext,
            config: layout.layout.value.config
          }
        })();
      }
      return url2;
    });
    const elements = computed(
      () => layout.layout.value.uischema.elements
    );
    onMounted(async () => {
      try {
        const response = await fetch(url.value);
        dataProvider.data = await response.json();
      } catch (e) {
        dataProvider.error = e;
      } finally {
        dataProvider.loading = false;
      }
    });
    provide(DataProviderKey, dataProvider);
    return {
      ...layout,
      elements
    };
  }
});
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dispatch_renderer = resolveComponent("dispatch-renderer");
  return openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.elements, (element, index) => {
    return openBlock(), createBlock(_component_dispatch_renderer, {
      key: `${_ctx.layout.path}-${index}`,
      schema: _ctx.layout.schema,
      uischema: element,
      path: _ctx.layout.path,
      enabled: _ctx.layout.enabled,
      renderers: _ctx.layout.renderers,
      cells: _ctx.layout.cells
    }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"]);
  }), 128);
}
const dataProviderRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$c, [["render", _sfc_render$c]]);
const controlRenderer$b = defineComponent({
  name: "data-provider-select-renderer",
  components: {
    ControlWrapper,
    VSelect
  },
  directives: {
    DisabledIconFocus
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const dataProvider = inject(DataProviderKey, null);
    return {
      ...useVuetifyControl(
        useJsonFormsOneOfEnumControl(props),
        (value) => value !== null ? value : void 0
      ),
      dataProvider
    };
  },
  methods: {
    getItemValue(item) {
      var _a;
      const compiled = template(
        (_a = this.control.uischema.options) == null ? void 0 : _a["item-value"]
      );
      return compiled(item);
    },
    getItemText(item) {
      var _a;
      const compiled = template((_a = this.control.uischema.options) == null ? void 0 : _a["item-text"]);
      return compiled(item);
    }
  }
});
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_select = resolveComponent("v-select");
  const _component_control_wrapper = resolveComponent("control-wrapper");
  const _directive_disabled_icon_focus = resolveDirective("disabled-icon-focus");
  return _ctx.dataProvider ? (openBlock(), createBlock(_component_control_wrapper, mergeProps({ key: 0 }, _ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(() => [
      withDirectives(createVNode(_component_v_select, mergeProps({
        id: _ctx.control.id + "-input",
        class: _ctx.styles.control.input,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        label: _ctx.computedLabel,
        hint: _ctx.control.description,
        "persistent-hint": _ctx.persistentHint(),
        required: _ctx.control.required,
        "error-messages": _ctx.control.errors,
        clearable: _ctx.control.enabled,
        value: _ctx.control.data,
        error: _ctx.dataProvider.error !== void 0,
        loading: _ctx.dataProvider.loading,
        items: _ctx.dataProvider.data,
        "item-text": _ctx.getItemText,
        "item-value": _ctx.getItemValue
      }, _ctx.vuetifyProps("v-select"), {
        onChange: _ctx.onChange,
        onFocus: _ctx.handleFocus,
        onBlur: _ctx.handleBlur
      }), null, 16, ["id", "class", "disabled", "autofocus", "placeholder", "label", "hint", "persistent-hint", "required", "error-messages", "clearable", "value", "error", "loading", "items", "item-text", "item-value", "onChange", "onFocus", "onBlur"]), [
        [_directive_disabled_icon_focus]
      ])
    ]),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"])) : createCommentVNode("", true);
}
const dataProviderSelectRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$b, [["render", _sfc_render$b]]);
const aliases$1 = {
  timer: "fa fa-clock",
  window_maximize: "fas fa-compress",
  window_restore: "fas fa-expand"
};
const aliases = {
  timer: "mdi-timer",
  window_maximize: "mdi-fullscreen",
  window_restore: "mdi-fullscreen-exit"
};
const useIcons = () => {
  const iconSet = computed(() => {
    const icons = inject(IconSymbol);
    if (!icons) throw new Error("Missing Vuetify Icons provide!");
    let result = aliases;
    const base = useIcons$1().current.value;
    if (icons.defaultSet === "fa") {
      result = aliases$1;
    }
    return { ...base, ...result };
  });
  return {
    current: iconSet
  };
};
function getDurationMaskOptions() {
  const tokens = {
    "#": { pattern: /\d/ },
    // Allow digits
    P: { pattern: /P/ },
    // Allow uppercase 'P'
    Y: { pattern: /Y/ },
    // Allow uppercase 'Y'
    M: { pattern: /M/ },
    // Allow uppercase 'M'
    W: { pattern: /W/ },
    // Allow uppercase 'W'
    D: { pattern: /D/ },
    // Allow uppercase 'D'
    T: { pattern: /T/ },
    // Allow uppercase 'T'
    H: { pattern: /H/ },
    // Allow uppercase 'H'
    S: { pattern: /S/ }
    // Allow uppercase 'S'
  };
  function mask(value) {
    const result = [];
    let expect = { P: tokens["P"] };
    let timePart = false;
    let haveMinute = false;
    for (let index = 0; index < value.length; index++) {
      const char = value.charAt(index);
      let matched = false;
      for (const [key, token] of Object.entries(expect)) {
        if (token.pattern.test(char)) {
          result.push(key);
          matched = true;
          switch (key) {
            case "P":
            case "Y":
              expect = { "#": tokens["#"], T: tokens["T"] };
              break;
            case "D":
              expect = { T: tokens["T"] };
              break;
            case "W":
              expect = {};
              break;
            case "M":
              if (timePart) {
                expect = { "#": tokens["#"] };
                haveMinute = true;
              } else {
                expect = { "#": tokens["#"], T: tokens["T"] };
              }
              break;
            case "T":
              expect = { "#": tokens["#"] };
              timePart = true;
              break;
            case "H":
              expect = { "#": tokens["#"] };
              break;
            case "S":
              expect = {};
              break;
            case "#":
              expect = { "#": tokens["#"] };
              if (!timePart) {
                if (!result.includes("Y") && !result.includes("M") && !result.includes("D") && !result.includes("W")) {
                  expect["Y"] = tokens["Y"];
                }
                if (!result.includes("M") && !result.includes("D") && !result.includes("W")) {
                  expect["M"] = tokens["M"];
                }
                if (!result.includes("W") && !result.includes("Y") && !result.includes("M") && !result.includes("D")) {
                  expect["W"] = tokens["W"];
                }
                if (!result.includes("D") && !result.includes("W")) {
                  expect["D"] = tokens["D"];
                }
              } else {
                if (!result.includes("H") && !haveMinute && !result.includes("S")) {
                  expect["H"] = tokens["H"];
                }
                if (!haveMinute && !result.includes("S")) {
                  expect["M"] = tokens["M"];
                }
                if (!result.includes("S")) {
                  expect["S"] = tokens["S"];
                }
              }
              break;
          }
          break;
        }
      }
      if (!matched) break;
    }
    return result.join("");
  }
  return { mask, tokens };
}
const controlRenderer$a = defineComponent({
  name: "duration-renderer",
  components: {
    ControlWrapper,
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCol,
    VConfirmEdit,
    VIcon,
    VMenu,
    VRow,
    VNumberInput,
    VTextField
  },
  directives: { DisabledIconFocus, maska: vMaska },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const t = useTranslator();
    const showMenu = ref(false);
    const clearValue = determineClearValue("");
    const adaptValue = (value) => value || clearValue;
    const control = useVuetifyControl(useJsonFormsControl(props), adaptValue);
    const useMask = control.appliedOptions.value.mask !== false;
    const state = computed(() => getDurationMaskOptions());
    const icons = useIcons();
    const maska = reactive({
      masked: "",
      unmasked: "",
      completed: false
    });
    const options = useMask ? computed(() => ({
      mask: state.value.mask,
      tokens: state.value.tokens,
      tokensReplace: true
    })) : null;
    const { mdAndUp } = useDisplay();
    return {
      ...control,
      mdAndUp,
      maska,
      showMenu,
      t,
      adaptValue,
      options,
      useMask,
      icons
    };
  },
  computed: {
    pickerIcon() {
      if (typeof this.appliedOptions.pickerIcon === "string") {
        return this.appliedOptions.pickerIcon;
      }
      return this.icons.current.value.timer;
    },
    inputModel: {
      get() {
        return this.control.data;
      },
      set(val) {
        let value = val;
        if (value == null) {
          this.maska.masked = "";
          this.maska.unmasked = "";
          this.maska.completed = false;
        }
        if (this.useMask && value === "" && this.maska.unmasked === "") {
          return;
        }
        if (this.adaptValue(value) !== this.control.data) {
          this.onChange(value);
        }
      }
    },
    pickerValue: {
      get() {
        return this.parseDuration(this.control.data);
      },
      set(val) {
        const value = this.formatDuration(val);
        if (this.adaptValue(value) !== this.control.data) {
          this.onChange(value);
        }
      }
    },
    cancelLabel() {
      const label = typeof this.appliedOptions.cancelLabel == "string" ? this.appliedOptions.cancelLabel : "Cancel";
      return this.t(label, label);
    },
    okLabel() {
      const label = typeof this.appliedOptions.okLabel == "string" ? this.appliedOptions.okLabel : "OK";
      return this.t(label, label);
    }
  },
  methods: {
    parseDuration(duration) {
      const result = {};
      if (duration === void 0 || duration == null) {
        return result;
      }
      const match = duration.match(
        /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?/
      );
      if (match == null ? void 0 : match[1]) result.years = Number(match[1]);
      if (match == null ? void 0 : match[2]) result.months = Number(match[2]);
      if (match == null ? void 0 : match[3]) result.weeks = Number(match[3]);
      if (match == null ? void 0 : match[4]) result.days = Number(match[4]);
      if (match == null ? void 0 : match[5]) result.hours = Number(match[5]);
      if (match == null ? void 0 : match[6]) result.minutes = Number(match[6]);
      if (match == null ? void 0 : match[7]) result.seconds = Number(match[7]);
      return result;
    },
    formatDuration(parts) {
      if (parts === void 0) {
        return void 0;
      }
      const { years, months, weeks, days, hours, minutes, seconds } = parts;
      if (weeks !== void 0 && weeks !== null) {
        return `P${weeks}W`;
      }
      const datePart = [
        years !== void 0 && years !== null ? `${years}Y` : "",
        months !== void 0 && months !== null ? `${months}M` : "",
        days !== void 0 && days !== null ? `${days}D` : ""
      ].join("");
      const timePart = [
        hours !== void 0 ? `${hours}H` : "",
        minutes !== void 0 ? `${minutes}M` : "",
        seconds !== void 0 ? `${seconds}S` : ""
      ].join("");
      if (datePart || timePart) {
        return `P${datePart}${timePart ? `T${timePart}` : ""}`;
      }
      return "";
    }
  }
});
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_number_input = resolveComponent("v-number-input");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_confirm_edit = resolveComponent("v-confirm-edit");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_control_wrapper = resolveComponent("control-wrapper");
  const _directive_disabled_icon_focus = resolveDirective("disabled-icon-focus");
  const _directive_maska = resolveDirective("maska");
  return openBlock(), createBlock(_component_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(() => [
      withDirectives((openBlock(), createBlock(_component_v_text_field, mergeProps({
        id: _ctx.control.id + "-input",
        class: _ctx.styles.control.input,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        label: _ctx.computedLabel,
        hint: _ctx.control.description,
        "persistent-hint": _ctx.persistentHint(),
        required: _ctx.control.required,
        "error-messages": _ctx.control.errors
      }, _ctx.vuetifyProps("v-text-field"), {
        modelValue: _ctx.inputModel,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.inputModel = $event),
        clearable: _ctx.control.enabled,
        onFocus: _ctx.handleFocus,
        onBlur: _ctx.handleBlur
      }), {
        "prepend-inner": withCtx(() => [
          createVNode(_component_v_menu, mergeProps({
            modelValue: _ctx.showMenu,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.showMenu = $event),
            "close-on-content-click": false,
            transition: "scale-transition",
            "min-width": 290,
            width: "auto"
          }, _ctx.vuetifyProps("v-menu"), {
            activator: "parent",
            disabled: !_ctx.control.enabled
          }), {
            activator: withCtx(({ props }) => [
              createVNode(_component_v_icon, mergeProps(props, { tabindex: "-1" }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.pickerIcon), 1)
                ]),
                _: 2
              }, 1040)
            ]),
            default: withCtx(() => [
              createVNode(_component_v_confirm_edit, {
                modelValue: _ctx.pickerValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.pickerValue = $event),
                "ok-text": _ctx.okLabel,
                "cancel-text": _ctx.cancelLabel,
                onCancel: _cache[1] || (_cache[1] = () => _ctx.showMenu = false),
                onSave: _cache[2] || (_cache[2] = () => _ctx.showMenu = false)
              }, {
                default: withCtx(({ model: proxyModel, save, cancel, actions }) => [
                  createVNode(_component_v_card, {
                    "min-width": _ctx.mdAndUp ? 600 : 290
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_card_text, null, {
                        default: withCtx(() => [
                          createVNode(_component_v_row, null, {
                            default: withCtx(() => [
                              createVNode(_component_v_col, null, {
                                default: withCtx(() => [
                                  withDirectives(createVNode(_component_v_number_input, {
                                    modelValue: proxyModel.value.weeks,
                                    "onUpdate:modelValue": ($event) => proxyModel.value.weeks = $event,
                                    clearable: "",
                                    controlVariant: "stacked",
                                    label: _ctx.t("Weeks", "Weeks"),
                                    min: 0,
                                    disabled: proxyModel.value.years !== void 0 && proxyModel.value.years !== null || proxyModel.value.months !== void 0 && proxyModel.value.months !== null || proxyModel.value.days !== void 0 && proxyModel.value.days !== null || proxyModel.value.hours !== void 0 && proxyModel.value.hours !== null || proxyModel.value.minutes !== void 0 && proxyModel.value.minutes !== null || proxyModel.value.seconds !== void 0 && proxyModel.value.seconds !== null
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]), [
                                    [_directive_disabled_icon_focus]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          createVNode(_component_v_row, null, {
                            default: withCtx(() => [
                              createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: withCtx(() => [
                                  withDirectives(createVNode(_component_v_number_input, {
                                    modelValue: proxyModel.value.years,
                                    "onUpdate:modelValue": ($event) => proxyModel.value.years = $event,
                                    clearable: "",
                                    controlVariant: "stacked",
                                    label: _ctx.t("Years", "Years"),
                                    min: 0,
                                    disabled: proxyModel.value.weeks !== void 0 && proxyModel.value.weeks !== null
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]), [
                                    [_directive_disabled_icon_focus]
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: withCtx(() => [
                                  withDirectives(createVNode(_component_v_number_input, {
                                    modelValue: proxyModel.value.months,
                                    "onUpdate:modelValue": ($event) => proxyModel.value.months = $event,
                                    clearable: "",
                                    controlVariant: "stacked",
                                    label: _ctx.t("Months", "Months"),
                                    min: 0,
                                    disabled: proxyModel.value.weeks !== void 0 && proxyModel.value.weeks !== null
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]), [
                                    [_directive_disabled_icon_focus]
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: withCtx(() => [
                                  withDirectives(createVNode(_component_v_number_input, {
                                    modelValue: proxyModel.value.days,
                                    "onUpdate:modelValue": ($event) => proxyModel.value.days = $event,
                                    clearable: "",
                                    controlVariant: "stacked",
                                    label: _ctx.t("Days", "Days"),
                                    min: 0,
                                    disabled: proxyModel.value.weeks !== void 0 && proxyModel.value.weeks !== null
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]), [
                                    [_directive_disabled_icon_focus]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          createVNode(_component_v_row, null, {
                            default: withCtx(() => [
                              createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: withCtx(() => [
                                  withDirectives(createVNode(_component_v_number_input, {
                                    modelValue: proxyModel.value.hours,
                                    "onUpdate:modelValue": ($event) => proxyModel.value.hours = $event,
                                    clearable: "",
                                    controlVariant: "stacked",
                                    label: _ctx.t("Hours", "Hours"),
                                    min: 0,
                                    disabled: proxyModel.value.weeks !== void 0 && proxyModel.value.weeks !== null
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]), [
                                    [_directive_disabled_icon_focus]
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: withCtx(() => [
                                  withDirectives(createVNode(_component_v_number_input, {
                                    modelValue: proxyModel.value.minutes,
                                    "onUpdate:modelValue": ($event) => proxyModel.value.minutes = $event,
                                    clearable: "",
                                    controlVariant: "stacked",
                                    label: _ctx.t("Minutes", "Minutes"),
                                    min: 0,
                                    disabled: proxyModel.value.weeks !== void 0 && proxyModel.value.weeks !== null
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]), [
                                    [_directive_disabled_icon_focus]
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: withCtx(() => [
                                  withDirectives(createVNode(_component_v_number_input, {
                                    modelValue: proxyModel.value.seconds,
                                    "onUpdate:modelValue": ($event) => proxyModel.value.seconds = $event,
                                    clearable: "",
                                    controlVariant: "stacked",
                                    label: _ctx.t("Seconds", "Seconds"),
                                    min: 0,
                                    disabled: proxyModel.value.weeks !== void 0 && proxyModel.value.weeks !== null
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]), [
                                    [_directive_disabled_icon_focus]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      createVNode(_component_v_card_actions, { class: "d-flex justify-end" }, {
                        default: withCtx(() => [
                          createVNode(_component_v_btn, { onClick: cancel }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.cancelLabel), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          createVNode(_component_v_btn, {
                            color: "primary",
                            onClick: save
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.okLabel), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["min-width"])
                ]),
                _: 1
              }, 8, ["modelValue", "ok-text", "cancel-text"])
            ]),
            _: 1
          }, 16, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 16, ["id", "class", "disabled", "autofocus", "placeholder", "label", "hint", "persistent-hint", "required", "error-messages", "modelValue", "clearable", "onFocus", "onBlur"])), [
        [_directive_disabled_icon_focus],
        [_directive_maska, _ctx.maska, _ctx.options]
      ])
    ]),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}
const controlRenderer$9 = /* @__PURE__ */ _export_sfc(controlRenderer$a, [["render", _sfc_render$a]]);
const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
const toNonNegativeNumber = (param) => {
  const result = param !== void 0 ? toNumber(param) : void 0;
  return result && result >= 0 ? result : void 0;
};
const getFileSize = (schema, uioptions, variant) => {
  let exclusive = false;
  let fileSize = void 0;
  if (variant === "min") {
    fileSize = toNonNegativeNumber(schema == null ? void 0 : schema.formatMinimum);
    if (fileSize === void 0 && (schema == null ? void 0 : schema.formatExclusiveMinimum)) {
      fileSize = toNonNegativeNumber(schema == null ? void 0 : schema.formatExclusiveMinimum);
      exclusive = true;
    }
    if (fileSize === void 0 && uioptions) {
      if (typeof uioptions.formatMinimum === "number" || typeof uioptions.formatMinimum === "string") {
        fileSize = toNonNegativeNumber(uioptions.formatMinimum);
      } else if (typeof uioptions.formatExclusiveMinimum === "number" || typeof uioptions.formatExclusiveMinimum === "string") {
        fileSize = toNonNegativeNumber(uioptions.formatExclusiveMinimum);
        exclusive = true;
      }
    }
  } else {
    fileSize = toNonNegativeNumber(schema == null ? void 0 : schema.formatMaximum);
    if (fileSize === void 0 && (schema == null ? void 0 : schema.formatExclusiveMaximum)) {
      fileSize = toNonNegativeNumber(schema == null ? void 0 : schema.formatExclusiveMaximum);
      exclusive = true;
    }
    if (fileSize === void 0 && uioptions) {
      if (typeof uioptions.formatMaximum === "number" || typeof uioptions.formatMaximum === "string") {
        fileSize = toNonNegativeNumber(uioptions.formatMaximum);
      } else if (typeof uioptions.formatExclusiveMaximum === "number" || typeof uioptions.formatExclusiveMaximum === "string") {
        fileSize = toNonNegativeNumber(uioptions.formatExclusiveMaximum);
        exclusive = true;
      }
    }
  }
  return [fileSize, exclusive];
};
const toBase64 = (file, reader, vm, schemaFormat) => new Promise((resolve, reject) => {
  reader.onload = () => {
    const dataurl = reader.result;
    if (schemaFormat === "uri") {
      resolve(dataurl);
    } else if (schemaFormat === "binary") {
      const insertIndex = dataurl.indexOf(";base64,");
      resolve(
        dataurl.substring(0, insertIndex) + `;filename=${encodeURIComponent(file.name)}` + dataurl.substring(insertIndex)
      );
    } else {
      resolve(dataurl.substring(dataurl.indexOf(",") + 1));
    }
  };
  reader.onabort = (error) => reject(error);
  reader.onerror = (error) => reject(error);
  reader.onprogress = (progress) => {
    if (progress.lengthComputable) {
      vm.progressIndeterminate = false;
      vm.progressValue = progress.loaded / progress.total * 100;
    }
  };
  reader.readAsDataURL(file);
});
const controlRenderer$8 = defineComponent({
  name: "file-control-renderer",
  components: {
    ControlWrapper,
    VFileInput,
    VDialog,
    VCard,
    VCardText,
    VProgressLinear,
    VSpacer,
    VToolbar,
    VToolbarTitle,
    VBtn,
    VIcon
  },
  directives: {
    DisabledIconFocus
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const currentFile = ref(void 0);
    const currentFileReader = new FileReader();
    const currentFileValidationErrors = ref(null);
    const t = useTranslator();
    const input = useJsonFormsControl(props);
    const dialog = ref(false);
    const progressIndeterminate = ref(true);
    const progressValue = ref(0);
    return {
      ...useVuetifyControl(input),
      t,
      dialog,
      progressValue,
      progressIndeterminate,
      currentFile,
      currentFileReader,
      currentFileValidationErrors
    };
  },
  computed: {
    accept() {
      return this.control.schema.contentMediaType;
    },
    errorMessages() {
      return this.currentFileValidationErrors ?? this.control.errors;
    },
    standby() {
      return this.t("Attaching file...", "Attaching file...");
    },
    minFileSize() {
      return getFileSize(
        this.control.schema,
        this.appliedOptions,
        "min"
      )[0];
    },
    minFileSizeExclusive() {
      return getFileSize(
        this.control.schema,
        this.appliedOptions,
        "min"
      )[1];
    },
    maxFileSize() {
      return getFileSize(
        this.control.schema,
        this.appliedOptions,
        "max"
      )[0];
    },
    maxFileSizeExclusive() {
      return getFileSize(
        this.control.schema,
        this.appliedOptions,
        "max"
      )[1];
    }
  },
  methods: {
    reset() {
      this.dialog = false;
      this.progressIndeterminate = true;
      this.progressValue = 0;
      this.currentFileReader = new FileReader();
    },
    abort() {
      this.currentFileReader.abort();
      this.currentFile = void 0;
      this.reset();
    },
    async selectFile(files) {
      const schema = this.control.schema;
      const value = Array.isArray(files) ? files[0] : files;
      if (value == null) {
        this.currentFileValidationErrors = null;
      } else {
        this.currentFileValidationErrors = null;
        if (this.maxFileSize) {
          const maxFileSizeValid = this.maxFileSizeExclusive ? value.size < this.maxFileSize : value.size <= this.maxFileSize;
          if (!maxFileSizeValid) {
            const key = getI18nKey(
              this.control.schema,
              this.control.uischema,
              this.control.path,
              this.maxFileSizeExclusive ? "error.formatExclusiveMaximum" : "error.formatMaximum"
            );
            const formatSize = formatBytes(this.maxFileSize);
            this.currentFileValidationErrors = this.t(
              key,
              `size should be less than ${formatSize}`,
              {
                limitText: `${formatSize}`,
                limit: `${this.maxFileSize}`
              }
            );
          }
        }
        if (this.minFileSize) {
          const minFileSizeValid = this.minFileSizeExclusive ? value.size > this.minFileSize : value.size >= this.minFileSize;
          if (!minFileSizeValid) {
            const key = getI18nKey(
              this.control.schema,
              this.control.uischema,
              this.control.path,
              this.minFileSizeExclusive ? "error.formatExclusiveMinimum" : "error.formatMinimum"
            );
            const formatSize = formatBytes(this.minFileSize);
            this.currentFileValidationErrors = this.t(
              key,
              `size should be greater than ${formatSize}`,
              {
                limitText: `${formatSize}`,
                limit: `${this.minFileSize}`
              }
            );
          }
        }
      }
      if (this.currentFileValidationErrors !== null) {
        this.currentFile = void 0;
      } else {
        if (value) {
          this.dialog = true;
          try {
            this.currentFileReader = new FileReader();
            const base64 = await toBase64(
              value,
              this.currentFileReader,
              this,
              schema.format
            );
            this.onChange(base64);
          } catch (e) {
            this.currentFile = void 0;
            this.currentFileValidationErrors = this.t(
              "error.fileConversion",
              "Failed to process file"
            );
            console.error("File conversion error:", e);
          } finally {
            this.reset();
          }
        } else {
          this.onChange(void 0);
        }
      }
    }
  }
});
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_file_input = resolveComponent("v-file-input");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_progress_linear = resolveComponent("v-progress-linear");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_dialog = resolveComponent("v-dialog");
  const _component_control_wrapper = resolveComponent("control-wrapper");
  const _directive_disabled_icon_focus = resolveDirective("disabled-icon-focus");
  return openBlock(), createBlock(_component_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(() => [
      withDirectives(createVNode(_component_v_file_input, mergeProps({
        id: _ctx.control.id + "-input",
        class: _ctx.styles.control.input,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        label: _ctx.computedLabel,
        hint: _ctx.control.description,
        "persistent-hint": _ctx.persistentHint(),
        required: _ctx.control.required,
        "error-messages": _ctx.errorMessages,
        clearable: _ctx.control.enabled,
        accept: _ctx.accept,
        modelValue: _ctx.currentFile,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.currentFile = $event)
      }, _ctx.vuetifyProps("v-file-input"), {
        "onUpdate:modelValue": _ctx.selectFile,
        onFocus: _ctx.handleFocus,
        onBlur: _ctx.handleBlur
      }), null, 16, ["id", "class", "disabled", "autofocus", "placeholder", "label", "hint", "persistent-hint", "required", "error-messages", "clearable", "accept", "modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]), [
        [_directive_disabled_icon_focus]
      ]),
      createVNode(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.dialog = $event),
        scrim: false,
        persistent: "",
        width: "300"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_card, null, {
            default: withCtx(() => [
              createVNode(_component_v_toolbar, {
                dense: "",
                flat: ""
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_toolbar_title, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.standby), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_spacer),
                  createVNode(_component_v_btn, {
                    onClick: _ctx.abort,
                    icon: ""
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_icon, null, {
                        default: withCtx(() => _cache[3] || (_cache[3] = [
                          createTextVNode("$close")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              createVNode(_component_v_card_text, null, {
                default: withCtx(() => [
                  createVNode(_component_v_progress_linear, {
                    modelValue: _ctx.progressValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.progressValue = $event),
                    indeterminate: _ctx.progressIndeterminate,
                    query: true,
                    height: "25"
                  }, {
                    default: withCtx(() => [
                      createElementVNode("strong", null, toDisplayString(Math.ceil(_ctx.progressValue)) + "%", 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "indeterminate"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}
const fileRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$8, [["render", _sfc_render$9]]);
const VMonacoEditor$1 = defineAsyncComponent(
  () => import("./index-CiWiNs-d.js").then((m) => m.VMonacoEditor)
);
const controlRenderer$7 = defineComponent({
  name: "monaco-control-renderer",
  components: {
    ControlWrapper,
    VMonacoEditor: VMonacoEditor$1,
    VCard,
    VDialog,
    VToolbar,
    VToolbarTitle,
    VBtn,
    VIcon,
    VCardText
  },
  directives: { DisabledIconFocus },
  props: { ...rendererProps() },
  setup(props) {
    const jsonforms = useJsonForms();
    const isMaximized = ref(false);
    const editorRef = ref(null);
    const clearValue = determineClearValue("");
    const control = useJsonFormsControl(props);
    const language = computed(() => {
      var _a, _b, _c;
      const langOption = (_a = control.control.value.uischema.options) == null ? void 0 : _a[":language"];
      if (langOption) {
        const rootData = (_b = jsonforms.core) == null ? void 0 : _b.data;
        return Resolve.data(rootData, langOption);
      }
      return (_c = control.control.value.uischema.options) == null ? void 0 : _c.language;
    });
    const convertJson = computed(
      () => {
        var _a;
        return ((_a = control.control.value.uischema.options) == null ? void 0 : _a.convertJson) ?? false;
      }
    );
    const adaptModelToEditorValue = (value) => {
      if (language.value === "json" && convertJson.value) {
        return value != void 0 ? JSON.stringify(value, null, 2) : "";
      }
      if (value === void 0 || value === null) {
        return "";
      }
      return typeof value === "string" ? value : String(value);
    };
    const vuetifyControl = useVuetifyControl(control, (v) => v, 300);
    const onChange = (value) => {
      let model = value || clearValue;
      if (language.value === "json" && convertJson.value) {
        try {
          model = JSON.parse(value);
        } catch {
          return;
        }
      }
      vuetifyControl.onChange(model);
    };
    const toggleMaximize = () => {
      isMaximized.value = !isMaximized.value;
      nextTick(() => {
        var _a;
        if ((_a = editorRef.value) == null ? void 0 : _a.editor) editorRef.value.editor.layout();
      });
    };
    watch(isMaximized, () => {
      nextTick(() => {
        var _a;
        if ((_a = editorRef.value) == null ? void 0 : _a.editor) editorRef.value.editor.layout();
      });
    });
    const icons = useIcons();
    return {
      ...vuetifyControl,
      onChange,
      jsonforms,
      icons,
      isMaximized,
      editorRef,
      toggleMaximize,
      language,
      adaptModelToEditorValue
    };
  }
});
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_monaco_editor = resolveComponent("v-monaco-editor");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_dialog = resolveComponent("v-dialog");
  const _component_control_wrapper = resolveComponent("control-wrapper");
  const _directive_disabled_icon_focus = resolveDirective("disabled-icon-focus");
  return openBlock(), createBlock(_component_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(["monaco-wrapper", { "monaco-wrapper--maximized": _ctx.isMaximized }])
      }, [
        withDirectives((openBlock(), createBlock(_component_v_monaco_editor, mergeProps({
          id: _ctx.control.id + "-input",
          class: _ctx.styles.control.input,
          disabled: !_ctx.control.enabled,
          autofocus: _ctx.appliedOptions.focus,
          placeholder: _ctx.appliedOptions.placeholder,
          label: _ctx.computedLabel,
          hint: _ctx.control.description,
          "persistent-hint": _ctx.persistentHint(),
          required: _ctx.control.required,
          "error-messages": _ctx.control.errors,
          "model-value": _ctx.adaptModelToEditorValue(_ctx.control.data)
        }, _ctx.vuetifyProps("v-monaco-editor"), {
          language: _ctx.language,
          "onUpdate:modelValue": _ctx.onChange,
          onFocus: _ctx.handleFocus,
          onBlur: _ctx.handleBlur
        }), {
          "append-inner": withCtx(() => [
            withDirectives(createVNode(_component_v_icon, { onClick: _ctx.toggleMaximize }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.isMaximized ? _ctx.icons.current.value.window_restore : _ctx.icons.current.value.window_maximize), 1)
              ]),
              _: 1
            }, 8, ["onClick"]), [
              [vShow, _ctx.isFocused]
            ])
          ]),
          _: 1
        }, 16, ["id", "class", "disabled", "autofocus", "placeholder", "label", "hint", "persistent-hint", "required", "error-messages", "model-value", "language", "onUpdate:modelValue", "onFocus", "onBlur"])), [
          [_directive_disabled_icon_focus]
        ]),
        createVNode(_component_v_dialog, {
          modelValue: _ctx.isMaximized,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.isMaximized = $event),
          fullscreen: "",
          scrim: false,
          persistent: ""
        }, {
          default: withCtx(() => [
            createVNode(_component_v_card, { class: "fill-height" }, {
              default: withCtx(() => [
                createVNode(_component_v_toolbar, { flat: "" }, {
                  default: withCtx(() => [
                    createVNode(_component_v_btn, {
                      icon: "",
                      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.isMaximized = false)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_v_icon, null, {
                          default: withCtx(() => _cache[2] || (_cache[2] = [
                            createTextVNode("mdi-close")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    createVNode(_component_v_toolbar_title, null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.computedLabel), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_card_text, { class: "fill-height pa-0" }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(_component_v_monaco_editor, mergeProps({
                      id: _ctx.control.id + "-input",
                      class: _ctx.styles.control.input,
                      disabled: !_ctx.control.enabled,
                      placeholder: _ctx.appliedOptions.placeholder,
                      required: _ctx.control.required,
                      "error-messages": _ctx.control.errors,
                      "model-value": _ctx.adaptModelToEditorValue(_ctx.control.data)
                    }, _ctx.vuetifyProps("v-monaco-editor"), {
                      language: _ctx.language,
                      "onUpdate:modelValue": _ctx.onChange,
                      onFocus: _ctx.handleFocus,
                      onBlur: _ctx.handleBlur,
                      style: { "width": "100%", "height": "100%" }
                    }), null, 16, ["id", "class", "disabled", "placeholder", "required", "error-messages", "model-value", "language", "onUpdate:modelValue", "onFocus", "onBlur"]), [
                      [_directive_disabled_icon_focus]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 2)
    ]),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}
const monacoRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$7, [["render", _sfc_render$8], ["__scopeId", "data-v-848d6f40"]]);
const controlRenderer$6 = defineComponent({
  name: "null-control-renderer",
  components: {
    VCheckbox,
    ControlWrapper
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const adaptValue = (value) => value === true ? null : void 0;
    const input = useVuetifyControl(useJsonFormsControl(props), adaptValue);
    return { ...input, adaptValue };
  }
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_checkbox = resolveComponent("v-checkbox");
  const _component_control_wrapper = resolveComponent("control-wrapper");
  return openBlock(), createBlock(_component_control_wrapper, mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: withCtx(() => [
      createVNode(_component_v_checkbox, mergeProps({
        id: _ctx.control.id + "-input",
        class: _ctx.styles.control.input,
        disabled: !_ctx.control.enabled,
        autofocus: _ctx.appliedOptions.focus,
        placeholder: _ctx.appliedOptions.placeholder,
        label: _ctx.computedLabel,
        hint: _ctx.control.description,
        "persistent-hint": _ctx.persistentHint(),
        required: _ctx.control.required,
        "error-messages": _ctx.control.errors,
        "model-value": _ctx.control.data === null
      }, _ctx.vuetifyProps("v-checkbox"), {
        "onUpdate:modelValue": _ctx.onChange,
        onFocus: _ctx.handleFocus,
        onBlur: _ctx.handleBlur
      }), null, 16, ["id", "class", "disabled", "autofocus", "placeholder", "label", "hint", "persistent-hint", "required", "error-messages", "model-value", "onUpdate:modelValue", "onFocus", "onBlur"])
    ]),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]);
}
const controlRenderer$5 = /* @__PURE__ */ _export_sfc(controlRenderer$6, [["render", _sfc_render$7]]);
const controlRenderer$4 = defineComponent({
  name: "slot-renderer",
  components: {
    DispatchRenderer
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const layout = useVuetifyLayout(useJsonFormsLayout(props));
    const slotContents = inject(
      TemplateRenderSlotContentsKey,
      computed(() => ({}))
    );
    return {
      ...layout,
      slotContents
    };
  },
  computed: {
    name() {
      return this.uischema.name;
    },
    defaultSlot() {
      const elements = this.layout.uischema.elements;
      return elements && elements.length > 0 ? elements[0] : void 0;
    },
    slotUISchema() {
      const slotContent = this.slotContents[this.name];
      return slotContent ?? this.defaultSlot;
    }
  }
});
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dispatch_renderer = resolveComponent("dispatch-renderer");
  return _ctx.slotUISchema ? (openBlock(), createBlock(_component_dispatch_renderer, {
    key: 0,
    visible: _ctx.layout.visible,
    enabled: _ctx.layout.enabled,
    schema: _ctx.layout.schema,
    uischema: _ctx.slotUISchema,
    path: _ctx.layout.path,
    renderers: _ctx.layout.renderers,
    cells: _ctx.layout.cells
  }, null, 8, ["visible", "enabled", "schema", "uischema", "path", "renderers", "cells"])) : createCommentVNode("", true);
}
const slotRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$4, [["render", _sfc_render$6]]);
const controlRenderer$3 = defineComponent({
  name: "template-label-renderer",
  components: {
    VLabel
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const t = useTranslator();
    const label = useVuetifyLabel(useJsonFormsLabel(props));
    const jsonforms = useJsonForms();
    const formContext = useFormContext();
    return {
      ...label,
      t,
      jsonforms,
      parentComponent: this,
      formContext
    };
  },
  computed: {
    once() {
      var _a, _b, _c, _d;
      return ((_b = (_a = this.uischema) == null ? void 0 : _a.options) == null ? void 0 : _b["v-once"]) === true || ((_d = (_c = this.uischema) == null ? void 0 : _c.options) == null ? void 0 : _d["v-once"]) === "true";
    },
    data() {
      var _a;
      return (_a = this.jsonforms.core) == null ? void 0 : _a.data;
    },
    errors() {
      var _a;
      return (_a = this.jsonforms.core) == null ? void 0 : _a.errors;
    },
    template() {
      var _a;
      if ((_a = this.uischema.options) == null ? void 0 : _a.i18n) {
        return this.t(
          this.uischema.options.i18n,
          this.uischema.text
        );
      }
      return this.uischema.text;
    },
    translatedLabel() {
      const compile2 = template(this.template, {
        imports: {
          data: this.data,
          context: this.formContext,
          errors: this.errors,
          translate: this.translate.bind(this)
        }
      });
      return compile2();
    }
  },
  methods: {
    translate(key, defaultMessage) {
      return this.t(key, defaultMessage ?? "");
    }
  }
});
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_label = resolveComponent("v-label");
  return _ctx.label.visible ? (openBlock(), createBlock(_component_v_label, mergeProps({
    key: 0,
    class: _ctx.styles.label.root,
    "v-once": _ctx.once
  }, _ctx.vuetifyProps("v-label")), {
    default: withCtx(() => [
      createTextVNode(toDisplayString(_ctx.translatedLabel), 1)
    ]),
    _: 1
  }, 16, ["class", "v-once"])) : createCommentVNode("", true);
}
const templateLabelRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$3, [["render", _sfc_render$5]]);
const VMonacoEditor = defineAsyncComponent(
  () => import("./index-CiWiNs-d.js").then((m) => m.VMonacoEditor)
);
const controlRenderer$2 = defineComponent({
  name: "vue-template-layout-renderer",
  inheritAttrs: false,
  components: {
    TemplateCompiler,
    VDefaultsProvider: VDefaultsProvider$1
  },
  props: {
    ...rendererProps()
  },
  async setup(props) {
    const t = useTranslator();
    const layout = useVuetifyLayout(useJsonFormsLayout(props));
    const jsonforms = useJsonForms();
    const context = useFormContext();
    const templateError = ref(null);
    const defaultComponents = await import("vuetify/components");
    return {
      ...layout,
      t,
      jsonforms,
      parentComponent: this,
      templateError,
      context,
      defaultComponents,
      defaultDirectives
    };
  },
  errorCaptured: function(err, _instance, info) {
    if (info == "render") {
      this.templateError = err instanceof Error ? err.message : String(err);
    }
  },
  computed: {
    data() {
      var _a;
      const jsonforms = this.jsonforms;
      return (_a = jsonforms.core) == null ? void 0 : _a.data;
    },
    errors() {
      var _a;
      const jsonforms = this.jsonforms;
      return (_a = jsonforms.core) == null ? void 0 : _a.errors;
    },
    template() {
      return this.layout.uischema.template;
    },
    namedElements() {
      var _a;
      return (_a = this.layout.uischema.elements) == null ? void 0 : _a.map(
        (element, index) => {
          if (element.name === void 0) {
            element.name = `${index}`;
          }
          return element;
        }
      );
    },
    componentDirectives() {
      const override = unref(
        inject(
          TemplateDirectivesKey,
          void 0
        )
      );
      return override ? {
        ...this.defaultDirectives,
        ...override
      } : this.defaultDirectives;
    },
    componentComputed() {
      const defaultComputed = {};
      defaultComputed.data = () => this.data;
      defaultComputed.errors = () => this.errors;
      defaultComputed.elements = () => this.namedElements;
      defaultComputed.context = () => this.context;
      const override = unref(
        inject(TemplateComputedKey, void 0)
      );
      return override ? { ...defaultComputed, ...override } : defaultComputed;
    },
    componentMethods() {
      const defaultMethods = {
        translate: this.translate.bind(this.parentComponent)
      };
      const override = unref(
        inject(TemplateMethodsKey, void 0)
      );
      return override ? { ...defaultMethods, ...override } : defaultMethods;
    },
    componentFilters() {
      const defaultFilters = {
        translate: this.translate.bind(this.parentComponent)
      };
      const override = unref(
        inject(TemplateFiltersKey, void 0)
      );
      return override ? { ...defaultFilters, ...override } : defaultFilters;
    },
    componentComponents() {
      const override = unref(
        inject(
          TemplateComponentsKey,
          void 0
        )
      );
      return {
        ...this.defaultComponents,
        VMonacoEditor,
        ValidationIcon,
        SlotElement: _sfc_main$4,
        VSplitpanes,
        VPane,
        ...override ? override : {}
      };
    }
  },
  methods: {
    translate(key, defaultMessage) {
      return this.t(key, defaultMessage ?? "");
    }
  },
  filters: {
    translate: function(value) {
      if (!value) return "";
      value = value.toString();
      return this.t(value, "");
    }
  }
});
const _hoisted_1$1 = {
  key: 0,
  class: "error"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_template_compiler = resolveComponent("template-compiler");
  const _component_v_defaults_provider = resolveComponent("v-defaults-provider");
  return openBlock(), createBlock(_component_v_defaults_provider, {
    disabled: !_ctx.vuetifyProps("defaults"),
    defaults: _ctx.vuetifyProps("defaults")
  }, {
    default: withCtx(() => [
      _ctx.templateError !== null ? (openBlock(), createElementBlock("div", _hoisted_1$1, " Template Error: " + toDisplayString(_ctx.templateError), 1)) : _ctx.layout.visible ? (openBlock(), createBlock(_component_template_compiler, {
        key: 1,
        template: _ctx.template,
        parent: _ctx.parentComponent,
        elements: _ctx.namedElements,
        componentComputed: _ctx.componentComputed,
        componentDirectives: _ctx.componentDirectives,
        componentMethods: _ctx.componentMethods,
        componentFilters: _ctx.componentFilters,
        componentComponents: _ctx.componentComponents,
        layout: _ctx.layout
      }, null, 8, ["template", "parent", "elements", "componentComputed", "componentDirectives", "componentMethods", "componentFilters", "componentComponents", "layout"])) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["disabled", "defaults"]);
}
const vueTemplateLayoutRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$2, [["render", _sfc_render$4]]);
class RactiveTemplateController {
  constructor(onMountSlots) {
    __publicField(this, "ractive", null);
    __publicField(this, "onMountSlots");
    __publicField(this, "container", null);
    __publicField(this, "template", null);
    __publicField(this, "data", null);
    this.onMountSlots = onMountSlots;
  }
  async destroy() {
    if (this.ractive) {
      this.ractive.off();
      await this.ractive.teardown().catch(() => {
      });
      this.ractive = null;
    }
  }
  updateData(keyPath, value) {
    if (this.ractive) {
      this.ractive.set(keyPath, value);
    }
  }
  async setup(container, template2, data, visible) {
    this.container = container;
    this.template = Ractive.parse(template2);
    this.data = data;
    if (!visible) {
      await this.destroy();
      return;
    }
    await this.render();
  }
  async updateVisibility(visible) {
    if (visible && !this.ractive) {
      await this.render();
    } else if (!visible && this.ractive) {
      await this.destroy();
    }
  }
  async render() {
    var _a;
    if (!this.container) return;
    await this.destroy();
    this.container.innerHTML = "";
    const partials = {};
    (_a = this.data.elements) == null ? void 0 : _a.forEach((el) => {
      partials[el.name] = `<div data-slot="${el.name}"></div>`;
    });
    this.ractive = new Ractive({
      el: this.container,
      template: this.template,
      partials,
      data: this.data,
      twoway: true,
      lazy: false
    });
    const runMount = () => {
      const els = this.container.querySelectorAll("[data-slot]");
      const slots = Array.from(els).map((el) => ({
        name: el.getAttribute("data-slot"),
        el
      }));
      this.onMountSlots(slots);
    };
    this.ractive.on("render", runMount);
    this.ractive.on("update", runMount);
    runMount();
  }
}
const SlotHost = defineComponent({
  name: "SlotHost",
  props: {
    mountTo: {
      type: Object,
      required: true
    }
  },
  setup(props, { slots }) {
    const root = ref(null);
    onMounted(() => {
      if (root.value && props.mountTo) {
        props.mountTo.appendChild(root.value);
      }
    });
    onBeforeUnmount(() => {
      if (root.value && root.value.parentNode) {
        root.value.parentNode.removeChild(root.value);
      }
    });
    return () => h(
      "div",
      {
        ref: root,
        style: { display: "contents" }
      },
      slots.default ? slots.default() : []
    );
  }
});
const _sfc_main$1 = defineComponent({
  name: "template-layout-renderer",
  inheritAttrs: false,
  components: {
    VDefaultsProvider: VDefaultsProvider$1,
    VAlert,
    DispatchRenderer,
    SlotHost
  },
  props: { ...rendererProps() },
  setup(props) {
    const t = useTranslator();
    const input = useVuetifyLayout(useJsonFormsLayout(props));
    const jsonforms = useJsonForms();
    const context = useFormContext();
    const templateRoot = ref(null);
    const templateError = ref(null);
    const slotPlaceholders = ref([]);
    const layout = computed(() => input.layout.value);
    const data = computed(() => {
      var _a;
      return (_a = jsonforms.core) == null ? void 0 : _a.data;
    });
    const errors = computed(() => {
      var _a;
      return (_a = jsonforms.core) == null ? void 0 : _a.errors;
    });
    const template2 = computed(
      () => layout.value.uischema.template
    );
    const namedElements = computed(() => {
      const uischema = layout.value.uischema;
      return (uischema.elements || []).map((element, index) => ({
        ...element,
        name: element.name ?? `${index}`
      }));
    });
    const namedElementMap = computed(
      () => Object.fromEntries(namedElements.value.map((e) => [e.name, e]))
    );
    const controller = markRaw(
      new RactiveTemplateController((slots) => {
        slotPlaceholders.value = slots;
      })
    );
    const isVisible2 = computed(() => input.layout.value.visible);
    watch(isVisible2, (visible) => {
      controller.updateVisibility(visible);
    });
    const initializeRactive = async () => {
      await nextTick();
      if (!template2.value || !templateRoot.value) return;
      templateError.value = null;
      try {
        await controller.setup(
          templateRoot.value,
          template2.value,
          {
            data: data.value,
            errors: errors.value,
            context: context.value,
            elements: namedElements.value,
            translate: (k, d) => t.value(k, d || "")
          },
          isVisible2.value
        );
      } catch (e) {
        templateError.value = (e == null ? void 0 : e.message) ?? String(e);
      }
    };
    watch(template2, initializeRactive);
    watch(data, (v) => controller.updateData("data", v), { deep: true });
    watch(errors, (v) => controller.updateData("errors", v), { deep: true });
    watch(context, (v) => controller.updateData("context", v), { deep: true });
    watch(namedElements, (v) => controller.updateData("elements", v), {
      deep: true
    });
    watch(t, () => {
      controller.updateData(
        "translate",
        (k, d) => t.value(k, d || "")
      );
    });
    onMounted(initializeRactive);
    onBeforeUnmount(async () => {
      await controller.destroy();
      slotPlaceholders.value = [];
    });
    const errorTitle = computed(
      () => t.value("TemplateLayoutRenderer.template_error_title", "Template Error")
    );
    return {
      ...input,
      layout,
      templateRoot,
      templateError,
      errorTitle,
      slotPlaceholders,
      namedElementMap,
      vuetifyProps: input.vuetifyProps
    };
  }
});
const _hoisted_1 = {
  ref: "templateRoot",
  style: { "display": "contents" }
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_alert = resolveComponent("v-alert");
  const _component_dispatch_renderer = resolveComponent("dispatch-renderer");
  const _component_slot_host = resolveComponent("slot-host");
  const _component_v_defaults_provider = resolveComponent("v-defaults-provider");
  return openBlock(), createBlock(_component_v_defaults_provider, {
    disabled: !_ctx.vuetifyProps("defaults"),
    defaults: _ctx.vuetifyProps("defaults")
  }, {
    default: withCtx(() => [
      _ctx.templateError !== null ? (openBlock(), createBlock(_component_v_alert, {
        key: 0,
        title: _ctx.errorTitle,
        text: _ctx.templateError,
        type: "error"
      }, null, 8, ["title", "text"])) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_1, null, 512),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.slotPlaceholders, ({ name, el }) => {
        return openBlock(), createBlock(_component_slot_host, {
          key: name,
          "mount-to": el
        }, {
          default: withCtx(() => [
            _ctx.namedElementMap[name] ? (openBlock(), createBlock(_component_dispatch_renderer, {
              key: 0,
              schema: _ctx.layout.schema,
              uischema: _ctx.namedElementMap[name],
              path: _ctx.layout.path,
              enabled: _ctx.layout.enabled,
              renderers: _ctx.layout.renderers,
              cells: _ctx.layout.cells
            }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"])) : createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["mount-to"]);
      }), 128))
    ]),
    _: 1
  }, 8, ["disabled", "defaults"]);
}
const templateLayoutRenderer = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$3]]);
const controlRenderer$1 = defineComponent({
  name: "template-renderer",
  components: {
    DispatchRenderer
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const layout = useVuetifyLayout(useJsonFormsLayout(props));
    const jsonforms = useJsonForms();
    const elementTemplates = computed(() => {
      var _a;
      const elements = ((_a = unref(layout.layout).uischema) == null ? void 0 : _a.elements) || [];
      return elements.reduce(
        function(result, element) {
          const name = element.name;
          if (name) {
            result[name] = element;
          }
          return result;
        },
        {}
      );
    });
    const parentSlotContents = inject(TemplateRenderSlotContentsKey, void 0);
    const slotContents = computed(
      () => parentSlotContents ? { ...parentSlotContents.value, ...elementTemplates.value } : elementTemplates.value
    );
    provide(TemplateRenderSlotContentsKey, slotContents);
    return {
      ...layout,
      jsonforms
    };
  },
  computed: {
    name() {
      return this.layout.uischema.name;
    },
    templateUISchema() {
      var _a;
      const uischemas = this.jsonforms.uischemas;
      return uischemas ? (_a = find(uischemas, (entry2) => entry2.uischema.name === this.name)) == null ? void 0 : _a.uischema : void 0;
    }
  }
});
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dispatch_renderer = resolveComponent("dispatch-renderer");
  return _ctx.templateUISchema ? (openBlock(), createBlock(_component_dispatch_renderer, {
    key: 0,
    visible: _ctx.layout.visible,
    enabled: _ctx.layout.enabled,
    schema: _ctx.layout.schema,
    uischema: _ctx.templateUISchema,
    path: _ctx.layout.path,
    renderers: _ctx.layout.renderers,
    cells: _ctx.layout.cells
  }, null, 8, ["visible", "enabled", "schema", "uischema", "path", "renderers", "cells"])) : createCommentVNode("", true);
}
const templateRenderer = /* @__PURE__ */ _export_sfc(controlRenderer$1, [["render", _sfc_render$2]]);
const splitLayoutRenderer$1 = defineComponent({
  name: "split-layout-renderer",
  components: {
    DispatchRenderer,
    VSplitpanes,
    VPane,
    VSheet
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    return {
      ...useVuetifyLayout(useJsonFormsLayout(props))
    };
  }
});
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dispatch_renderer = resolveComponent("dispatch-renderer");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_v_pane = resolveComponent("v-pane");
  const _component_v_splitpanes = resolveComponent("v-splitpanes");
  return _ctx.layout.visible && _ctx.layout.uischema.elements.length > 0 ? (openBlock(), createBlock(_component_v_splitpanes, mergeProps({
    key: 0,
    horizontal: !_ctx.appliedOptions.horizontal
  }, _ctx.vuetifyProps("v-splitpanes")), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.layout.uischema.elements, (element, index) => {
        return openBlock(), createBlock(_component_v_pane, mergeProps({
          key: `${_ctx.layout.path}-${_ctx.layout.uischema.elements.length}-${index}`,
          ref_for: true
        }, _ctx.vuetifyProps(`v-pane[${index}]`)), {
          default: withCtx(() => [
            createVNode(_component_v_sheet, mergeProps({ ref_for: true }, _ctx.vuetifyProps(`v-sheet[${index}]`)), {
              default: withCtx(() => [
                createVNode(_component_dispatch_renderer, {
                  schema: _ctx.layout.schema,
                  uischema: element,
                  path: _ctx.layout.path,
                  enabled: _ctx.layout.enabled,
                  renderers: _ctx.layout.renderers,
                  cells: _ctx.layout.cells
                }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells"])
              ]),
              _: 2
            }, 1040)
          ]),
          _: 2
        }, 1040);
      }), 128))
    ]),
    _: 1
  }, 16, ["horizontal"])) : createCommentVNode("", true);
}
const splitLayoutRenderer = /* @__PURE__ */ _export_sfc(splitLayoutRenderer$1, [["render", _sfc_render$1]]);
function getProps() {
  return {
    gridOptions: {},
    modules: [],
    // @START_DEFAULTS@
    statusBar: void 0,
    sideBar: void 0,
    suppressContextMenu: void 0,
    preventDefaultOnContextMenu: void 0,
    allowContextMenuWithControlKey: void 0,
    columnMenu: void 0,
    suppressMenuHide: void 0,
    enableBrowserTooltips: void 0,
    tooltipTrigger: void 0,
    tooltipShowDelay: void 0,
    tooltipHideDelay: void 0,
    tooltipMouseTrack: void 0,
    tooltipShowMode: void 0,
    tooltipInteraction: void 0,
    popupParent: void 0,
    copyHeadersToClipboard: void 0,
    copyGroupHeadersToClipboard: void 0,
    clipboardDelimiter: void 0,
    suppressCopyRowsToClipboard: void 0,
    suppressCopySingleCellRanges: void 0,
    suppressLastEmptyLineOnPaste: void 0,
    suppressClipboardPaste: void 0,
    suppressClipboardApi: void 0,
    suppressCutToClipboard: void 0,
    columnDefs: void 0,
    defaultColDef: void 0,
    defaultColGroupDef: void 0,
    columnTypes: void 0,
    dataTypeDefinitions: void 0,
    maintainColumnOrder: void 0,
    enableStrictPivotColumnOrder: void 0,
    suppressFieldDotNotation: void 0,
    headerHeight: void 0,
    groupHeaderHeight: void 0,
    floatingFiltersHeight: void 0,
    pivotHeaderHeight: void 0,
    pivotGroupHeaderHeight: void 0,
    hidePaddedHeaderRows: void 0,
    allowDragFromColumnsToolPanel: void 0,
    suppressMovableColumns: void 0,
    suppressColumnMoveAnimation: void 0,
    suppressMoveWhenColumnDragging: void 0,
    suppressDragLeaveHidesColumns: void 0,
    suppressGroupChangesColumnVisibility: void 0,
    suppressMakeColumnVisibleAfterUnGroup: void 0,
    suppressRowGroupHidesColumns: void 0,
    colResizeDefault: void 0,
    suppressAutoSize: void 0,
    autoSizePadding: void 0,
    skipHeaderOnAutoSize: void 0,
    autoSizeStrategy: void 0,
    components: void 0,
    editType: void 0,
    suppressStartEditOnTab: void 0,
    getFullRowEditValidationErrors: void 0,
    invalidEditValueMode: void 0,
    singleClickEdit: void 0,
    suppressClickEdit: void 0,
    readOnlyEdit: void 0,
    stopEditingWhenCellsLoseFocus: void 0,
    enterNavigatesVertically: void 0,
    enterNavigatesVerticallyAfterEdit: void 0,
    enableCellEditingOnBackspace: void 0,
    undoRedoCellEditing: void 0,
    undoRedoCellEditingLimit: void 0,
    defaultCsvExportParams: void 0,
    suppressCsvExport: void 0,
    defaultExcelExportParams: void 0,
    suppressExcelExport: void 0,
    excelStyles: void 0,
    findSearchValue: void 0,
    findOptions: void 0,
    quickFilterText: void 0,
    cacheQuickFilter: void 0,
    includeHiddenColumnsInQuickFilter: void 0,
    quickFilterParser: void 0,
    quickFilterMatcher: void 0,
    applyQuickFilterBeforePivotOrAgg: void 0,
    excludeChildrenWhenTreeDataFiltering: void 0,
    enableAdvancedFilter: void 0,
    alwaysPassFilter: void 0,
    includeHiddenColumnsInAdvancedFilter: void 0,
    advancedFilterParent: void 0,
    advancedFilterBuilderParams: void 0,
    advancedFilterParams: void 0,
    suppressAdvancedFilterEval: void 0,
    suppressSetFilterByDefault: void 0,
    enableFilterHandlers: void 0,
    filterHandlers: void 0,
    enableCharts: void 0,
    chartThemes: void 0,
    customChartThemes: void 0,
    chartThemeOverrides: void 0,
    chartToolPanelsDef: void 0,
    chartMenuItems: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0,
    localeText: void 0,
    masterDetail: void 0,
    keepDetailRows: void 0,
    keepDetailRowsCount: void 0,
    detailCellRenderer: void 0,
    detailCellRendererParams: void 0,
    detailRowHeight: void 0,
    detailRowAutoHeight: void 0,
    context: void 0,
    alignedGrids: void 0,
    tabIndex: void 0,
    rowBuffer: void 0,
    valueCache: void 0,
    valueCacheNeverExpires: void 0,
    enableCellExpressions: void 0,
    suppressTouch: void 0,
    suppressFocusAfterRefresh: void 0,
    suppressBrowserResizeObserver: void 0,
    suppressPropertyNamesCheck: void 0,
    suppressChangeDetection: void 0,
    debug: void 0,
    loading: void 0,
    overlayLoadingTemplate: void 0,
    loadingOverlayComponent: void 0,
    loadingOverlayComponentParams: void 0,
    suppressLoadingOverlay: void 0,
    overlayNoRowsTemplate: void 0,
    noRowsOverlayComponent: void 0,
    noRowsOverlayComponentParams: void 0,
    suppressNoRowsOverlay: void 0,
    pagination: void 0,
    paginationPageSize: void 0,
    paginationPageSizeSelector: void 0,
    paginationAutoPageSize: void 0,
    paginateChildRows: void 0,
    suppressPaginationPanel: void 0,
    pivotMode: void 0,
    pivotPanelShow: void 0,
    pivotMaxGeneratedColumns: void 0,
    pivotDefaultExpanded: void 0,
    pivotColumnGroupTotals: void 0,
    pivotRowTotals: void 0,
    pivotSuppressAutoColumn: void 0,
    suppressExpandablePivotGroups: void 0,
    functionsReadOnly: void 0,
    aggFuncs: void 0,
    suppressAggFuncInHeader: void 0,
    alwaysAggregateAtRootLevel: void 0,
    aggregateOnlyChangedColumns: void 0,
    suppressAggFilteredOnly: void 0,
    removePivotHeaderRowWhenSingleValueColumn: void 0,
    animateRows: void 0,
    cellFlashDuration: void 0,
    cellFadeDuration: void 0,
    allowShowChangeAfterFilter: void 0,
    domLayout: void 0,
    ensureDomOrder: void 0,
    enableCellSpan: void 0,
    enableRtl: void 0,
    suppressColumnVirtualisation: void 0,
    suppressMaxRenderedRowRestriction: void 0,
    suppressRowVirtualisation: void 0,
    rowDragManaged: void 0,
    rowDragInsertDelay: void 0,
    suppressRowDrag: void 0,
    suppressMoveWhenRowDragging: void 0,
    rowDragEntireRow: void 0,
    rowDragMultiRow: void 0,
    rowDragText: void 0,
    dragAndDropImageComponent: void 0,
    dragAndDropImageComponentParams: void 0,
    fullWidthCellRenderer: void 0,
    fullWidthCellRendererParams: void 0,
    embedFullWidthRows: void 0,
    groupDisplayType: void 0,
    groupDefaultExpanded: void 0,
    autoGroupColumnDef: void 0,
    groupMaintainOrder: void 0,
    groupSelectsChildren: void 0,
    groupLockGroupColumns: void 0,
    groupAggFiltering: void 0,
    groupTotalRow: void 0,
    grandTotalRow: void 0,
    suppressStickyTotalRow: void 0,
    groupSuppressBlankHeader: void 0,
    groupSelectsFiltered: void 0,
    showOpenedGroup: void 0,
    groupHideParentOfSingleChild: void 0,
    groupRemoveSingleChildren: void 0,
    groupRemoveLowestSingleChildren: void 0,
    groupHideOpenParents: void 0,
    groupAllowUnbalanced: void 0,
    rowGroupPanelShow: void 0,
    groupRowRenderer: void 0,
    groupRowRendererParams: void 0,
    treeData: void 0,
    treeDataChildrenField: void 0,
    treeDataParentIdField: void 0,
    rowGroupPanelSuppressSort: void 0,
    suppressGroupRowsSticky: void 0,
    groupHierarchyConfig: void 0,
    pinnedTopRowData: void 0,
    pinnedBottomRowData: void 0,
    enableRowPinning: void 0,
    isRowPinnable: void 0,
    isRowPinned: void 0,
    rowModelType: void 0,
    rowData: void 0,
    asyncTransactionWaitMillis: void 0,
    suppressModelUpdateAfterUpdateTransaction: void 0,
    datasource: void 0,
    cacheOverflowSize: void 0,
    infiniteInitialRowCount: void 0,
    serverSideInitialRowCount: void 0,
    suppressServerSideFullWidthLoadingRow: void 0,
    cacheBlockSize: void 0,
    maxBlocksInCache: void 0,
    maxConcurrentDatasourceRequests: void 0,
    blockLoadDebounceMillis: void 0,
    purgeClosedRowNodes: void 0,
    serverSideDatasource: void 0,
    serverSideSortAllLevels: void 0,
    serverSideEnableClientSideSort: void 0,
    serverSideOnlyRefreshFilteredGroups: void 0,
    serverSidePivotResultFieldSeparator: void 0,
    viewportDatasource: void 0,
    viewportRowModelPageSize: void 0,
    viewportRowModelBufferSize: void 0,
    alwaysShowHorizontalScroll: void 0,
    alwaysShowVerticalScroll: void 0,
    debounceVerticalScrollbar: void 0,
    suppressHorizontalScroll: void 0,
    suppressScrollOnNewData: void 0,
    suppressScrollWhenPopupsAreOpen: void 0,
    suppressAnimationFrame: void 0,
    suppressMiddleClickScrolls: void 0,
    suppressPreventDefaultOnMouseWheel: void 0,
    scrollbarWidth: void 0,
    rowSelection: void 0,
    cellSelection: void 0,
    rowMultiSelectWithClick: void 0,
    suppressRowDeselection: void 0,
    suppressRowClickSelection: void 0,
    suppressCellFocus: void 0,
    suppressHeaderFocus: void 0,
    selectionColumnDef: void 0,
    rowNumbers: void 0,
    suppressMultiRangeSelection: void 0,
    enableCellTextSelection: void 0,
    enableRangeSelection: void 0,
    enableRangeHandle: void 0,
    enableFillHandle: void 0,
    fillHandleDirection: void 0,
    suppressClearOnFillReduction: void 0,
    sortingOrder: void 0,
    accentedSort: void 0,
    unSortIcon: void 0,
    suppressMultiSort: void 0,
    alwaysMultiSort: void 0,
    multiSortKey: void 0,
    suppressMaintainUnsortedOrder: void 0,
    icons: void 0,
    rowHeight: void 0,
    rowStyle: void 0,
    rowClass: void 0,
    rowClassRules: void 0,
    suppressRowHoverHighlight: void 0,
    suppressRowTransform: void 0,
    columnHoverHighlight: void 0,
    gridId: void 0,
    deltaSort: void 0,
    treeDataDisplayType: void 0,
    enableGroupEdit: void 0,
    initialState: void 0,
    theme: void 0,
    loadThemeGoogleFonts: void 0,
    themeCssLayer: void 0,
    styleNonce: void 0,
    themeStyleContainer: void 0,
    getContextMenuItems: void 0,
    getMainMenuItems: void 0,
    postProcessPopup: void 0,
    processUnpinnedColumns: void 0,
    processCellForClipboard: void 0,
    processHeaderForClipboard: void 0,
    processGroupHeaderForClipboard: void 0,
    processCellFromClipboard: void 0,
    sendToClipboard: void 0,
    processDataFromClipboard: void 0,
    isExternalFilterPresent: void 0,
    doesExternalFilterPass: void 0,
    getChartToolbarItems: void 0,
    createChartContainer: void 0,
    focusGridInnerElement: void 0,
    navigateToNextHeader: void 0,
    tabToNextHeader: void 0,
    navigateToNextCell: void 0,
    tabToNextCell: void 0,
    getLocaleText: void 0,
    getDocument: void 0,
    paginationNumberFormatter: void 0,
    getGroupRowAgg: void 0,
    isGroupOpenByDefault: void 0,
    ssrmExpandAllAffectsAllRows: void 0,
    initialGroupOrderComparator: void 0,
    processPivotResultColDef: void 0,
    processPivotResultColGroupDef: void 0,
    getDataPath: void 0,
    getChildCount: void 0,
    getServerSideGroupLevelParams: void 0,
    isServerSideGroupOpenByDefault: void 0,
    isApplyServerSideTransaction: void 0,
    isServerSideGroup: void 0,
    getServerSideGroupKey: void 0,
    getBusinessKeyForNode: void 0,
    getRowId: void 0,
    resetRowDataOnUpdate: void 0,
    processRowPostCreate: void 0,
    isRowSelectable: void 0,
    isRowMaster: void 0,
    fillOperation: void 0,
    postSortRows: void 0,
    getRowStyle: void 0,
    getRowClass: void 0,
    getRowHeight: void 0,
    isFullWidthRow: void 0,
    isRowValidDropPosition: void 0,
    // @END_DEFAULTS@
    // @START_EVENT_PROPS@
    "onColumn-everything-changed": void 0,
    "onNew-columns-loaded": void 0,
    "onColumn-pivot-mode-changed": void 0,
    "onPivot-max-columns-exceeded": void 0,
    "onColumn-row-group-changed": void 0,
    "onExpand-or-collapse-all": void 0,
    "onColumn-pivot-changed": void 0,
    "onGrid-columns-changed": void 0,
    "onColumn-value-changed": void 0,
    "onColumn-moved": void 0,
    "onColumn-visible": void 0,
    "onColumn-pinned": void 0,
    "onColumn-group-opened": void 0,
    "onColumn-resized": void 0,
    "onDisplayed-columns-changed": void 0,
    "onVirtual-columns-changed": void 0,
    "onColumn-header-mouse-over": void 0,
    "onColumn-header-mouse-leave": void 0,
    "onColumn-header-clicked": void 0,
    "onColumn-header-context-menu": void 0,
    "onAsync-transactions-flushed": void 0,
    "onRow-group-opened": void 0,
    "onRow-data-updated": void 0,
    "onPinned-row-data-changed": void 0,
    "onPinned-rows-changed": void 0,
    "onRange-selection-changed": void 0,
    "onCell-selection-changed": void 0,
    "onChart-created": void 0,
    "onChart-range-selection-changed": void 0,
    "onChart-options-changed": void 0,
    "onChart-destroyed": void 0,
    "onTool-panel-visible-changed": void 0,
    "onTool-panel-size-changed": void 0,
    "onModel-updated": void 0,
    "onCut-start": void 0,
    "onCut-end": void 0,
    "onPaste-start": void 0,
    "onPaste-end": void 0,
    "onFill-start": void 0,
    "onFill-end": void 0,
    "onCell-selection-delete-start": void 0,
    "onCell-selection-delete-end": void 0,
    "onRange-delete-start": void 0,
    "onRange-delete-end": void 0,
    "onUndo-started": void 0,
    "onUndo-ended": void 0,
    "onRedo-started": void 0,
    "onRedo-ended": void 0,
    "onCell-clicked": void 0,
    "onCell-double-clicked": void 0,
    "onCell-mouse-down": void 0,
    "onCell-context-menu": void 0,
    "onCell-value-changed": void 0,
    "onCell-edit-request": void 0,
    "onRow-value-changed": void 0,
    "onHeader-focused": void 0,
    "onCell-focused": void 0,
    "onRow-selected": void 0,
    "onSelection-changed": void 0,
    "onTooltip-show": void 0,
    "onTooltip-hide": void 0,
    "onCell-key-down": void 0,
    "onCell-mouse-over": void 0,
    "onCell-mouse-out": void 0,
    "onFilter-changed": void 0,
    "onFilter-modified": void 0,
    "onFilter-ui-changed": void 0,
    "onFilter-opened": void 0,
    "onFloating-filter-ui-changed": void 0,
    "onAdvanced-filter-builder-visible-changed": void 0,
    "onSort-changed": void 0,
    "onVirtual-row-removed": void 0,
    "onRow-clicked": void 0,
    "onRow-double-clicked": void 0,
    "onGrid-ready": void 0,
    "onGrid-pre-destroyed": void 0,
    "onGrid-size-changed": void 0,
    "onViewport-changed": void 0,
    "onFirst-data-rendered": void 0,
    "onDrag-started": void 0,
    "onDrag-stopped": void 0,
    "onDrag-cancelled": void 0,
    "onRow-editing-started": void 0,
    "onRow-editing-stopped": void 0,
    "onCell-editing-started": void 0,
    "onCell-editing-stopped": void 0,
    "onBody-scroll": void 0,
    "onBody-scroll-end": void 0,
    "onPagination-changed": void 0,
    "onComponent-state-changed": void 0,
    "onStore-refreshed": void 0,
    "onState-updated": void 0,
    "onColumn-menu-visible-changed": void 0,
    "onContext-menu-visible-changed": void 0,
    "onRow-drag-enter": void 0,
    "onRow-drag-move": void 0,
    "onRow-drag-leave": void 0,
    "onRow-drag-end": void 0,
    "onRow-drag-cancel": void 0,
    "onFind-changed": void 0,
    "onRow-resize-started": void 0,
    "onRow-resize-ended": void 0,
    "onColumns-reset": void 0,
    "onBulk-editing-started": void 0,
    "onBulk-editing-stopped": void 0,
    "onBatch-editing-started": void 0,
    "onBatch-editing-stopped": void 0
    // @END_EVENT_PROPS@
  };
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "VAgGrid",
  props: /* @__PURE__ */ mergeDefaults({
    gridOptions: {},
    modules: {},
    statusBar: {},
    sideBar: { type: [Object, String, Array, Boolean, null] },
    suppressContextMenu: { type: Boolean },
    preventDefaultOnContextMenu: { type: Boolean },
    allowContextMenuWithControlKey: { type: Boolean },
    columnMenu: {},
    suppressMenuHide: { type: Boolean },
    enableBrowserTooltips: { type: Boolean },
    tooltipTrigger: {},
    tooltipShowDelay: {},
    tooltipHideDelay: {},
    tooltipMouseTrack: { type: Boolean },
    tooltipShowMode: {},
    tooltipInteraction: { type: Boolean },
    popupParent: {},
    copyHeadersToClipboard: { type: Boolean },
    copyGroupHeadersToClipboard: { type: Boolean },
    clipboardDelimiter: {},
    suppressCopyRowsToClipboard: { type: Boolean },
    suppressCopySingleCellRanges: { type: Boolean },
    suppressLastEmptyLineOnPaste: { type: Boolean },
    suppressClipboardPaste: { type: Boolean },
    suppressClipboardApi: { type: Boolean },
    suppressCutToClipboard: { type: Boolean },
    columnDefs: {},
    defaultColDef: {},
    defaultColGroupDef: {},
    columnTypes: {},
    dataTypeDefinitions: {},
    maintainColumnOrder: { type: Boolean },
    enableStrictPivotColumnOrder: { type: Boolean },
    suppressFieldDotNotation: { type: Boolean },
    headerHeight: {},
    groupHeaderHeight: {},
    floatingFiltersHeight: {},
    pivotHeaderHeight: {},
    pivotGroupHeaderHeight: {},
    hidePaddedHeaderRows: { type: Boolean },
    allowDragFromColumnsToolPanel: { type: Boolean },
    suppressMovableColumns: { type: Boolean },
    suppressColumnMoveAnimation: { type: Boolean },
    suppressMoveWhenColumnDragging: { type: Boolean },
    suppressDragLeaveHidesColumns: { type: Boolean },
    suppressGroupChangesColumnVisibility: { type: [Boolean, String] },
    suppressMakeColumnVisibleAfterUnGroup: { type: Boolean },
    suppressRowGroupHidesColumns: { type: Boolean },
    colResizeDefault: {},
    suppressAutoSize: { type: Boolean },
    autoSizePadding: {},
    skipHeaderOnAutoSize: { type: Boolean },
    autoSizeStrategy: {},
    components: {},
    editType: {},
    suppressStartEditOnTab: { type: Boolean },
    getFullRowEditValidationErrors: { type: Function },
    invalidEditValueMode: {},
    singleClickEdit: { type: Boolean },
    suppressClickEdit: { type: Boolean },
    readOnlyEdit: { type: Boolean },
    stopEditingWhenCellsLoseFocus: { type: Boolean },
    enterNavigatesVertically: { type: Boolean },
    enterNavigatesVerticallyAfterEdit: { type: Boolean },
    enableCellEditingOnBackspace: { type: Boolean },
    undoRedoCellEditing: { type: Boolean },
    undoRedoCellEditingLimit: {},
    defaultCsvExportParams: {},
    suppressCsvExport: { type: Boolean },
    defaultExcelExportParams: {},
    suppressExcelExport: { type: Boolean },
    excelStyles: {},
    findSearchValue: {},
    findOptions: {},
    quickFilterText: {},
    cacheQuickFilter: { type: Boolean },
    includeHiddenColumnsInQuickFilter: { type: Boolean },
    quickFilterParser: { type: Function },
    quickFilterMatcher: { type: Function },
    applyQuickFilterBeforePivotOrAgg: { type: Boolean },
    excludeChildrenWhenTreeDataFiltering: { type: Boolean },
    enableAdvancedFilter: { type: Boolean },
    alwaysPassFilter: { type: Function },
    includeHiddenColumnsInAdvancedFilter: { type: Boolean },
    advancedFilterParent: {},
    advancedFilterBuilderParams: {},
    advancedFilterParams: {},
    suppressAdvancedFilterEval: { type: Boolean },
    suppressSetFilterByDefault: { type: Boolean },
    enableFilterHandlers: { type: Boolean },
    filterHandlers: {},
    enableCharts: { type: Boolean },
    chartThemes: {},
    customChartThemes: {},
    chartThemeOverrides: {},
    chartToolPanelsDef: {},
    chartMenuItems: { type: [Array, Function] },
    loadingCellRenderer: {},
    loadingCellRendererParams: {},
    loadingCellRendererSelector: { type: Function },
    localeText: {},
    masterDetail: { type: Boolean },
    keepDetailRows: { type: Boolean },
    keepDetailRowsCount: {},
    detailCellRenderer: {},
    detailCellRendererParams: {},
    detailRowHeight: {},
    detailRowAutoHeight: { type: Boolean },
    context: {},
    alignedGrids: { type: [Array, Function] },
    tabIndex: {},
    rowBuffer: {},
    valueCache: { type: Boolean },
    valueCacheNeverExpires: { type: Boolean },
    enableCellExpressions: { type: Boolean },
    suppressTouch: { type: Boolean },
    suppressFocusAfterRefresh: { type: Boolean },
    suppressBrowserResizeObserver: { type: Boolean },
    suppressPropertyNamesCheck: { type: Boolean },
    suppressChangeDetection: { type: Boolean },
    debug: { type: Boolean },
    loading: { type: Boolean },
    overlayLoadingTemplate: {},
    loadingOverlayComponent: {},
    loadingOverlayComponentParams: {},
    suppressLoadingOverlay: { type: Boolean },
    overlayNoRowsTemplate: {},
    noRowsOverlayComponent: {},
    noRowsOverlayComponentParams: {},
    suppressNoRowsOverlay: { type: Boolean },
    pagination: { type: Boolean },
    paginationPageSize: {},
    paginationPageSizeSelector: { type: [Array, Boolean] },
    paginationAutoPageSize: { type: Boolean },
    paginateChildRows: { type: Boolean },
    suppressPaginationPanel: { type: Boolean },
    pivotMode: { type: Boolean },
    pivotPanelShow: {},
    pivotMaxGeneratedColumns: {},
    pivotDefaultExpanded: {},
    pivotColumnGroupTotals: {},
    pivotRowTotals: {},
    pivotSuppressAutoColumn: { type: Boolean },
    suppressExpandablePivotGroups: { type: Boolean },
    functionsReadOnly: { type: Boolean },
    aggFuncs: {},
    suppressAggFuncInHeader: { type: Boolean },
    alwaysAggregateAtRootLevel: { type: Boolean },
    aggregateOnlyChangedColumns: { type: Boolean },
    suppressAggFilteredOnly: { type: Boolean },
    removePivotHeaderRowWhenSingleValueColumn: { type: Boolean },
    animateRows: { type: Boolean },
    cellFlashDuration: {},
    cellFadeDuration: {},
    allowShowChangeAfterFilter: { type: Boolean },
    domLayout: {},
    ensureDomOrder: { type: Boolean },
    enableCellSpan: { type: Boolean },
    enableRtl: { type: Boolean },
    suppressColumnVirtualisation: { type: Boolean },
    suppressMaxRenderedRowRestriction: { type: Boolean },
    suppressRowVirtualisation: { type: Boolean },
    rowDragManaged: { type: Boolean },
    rowDragInsertDelay: {},
    suppressRowDrag: { type: Boolean },
    suppressMoveWhenRowDragging: { type: Boolean },
    rowDragEntireRow: { type: Boolean },
    rowDragMultiRow: { type: Boolean },
    rowDragText: { type: Function },
    dragAndDropImageComponent: {},
    dragAndDropImageComponentParams: {},
    fullWidthCellRenderer: {},
    fullWidthCellRendererParams: {},
    embedFullWidthRows: { type: Boolean },
    groupDisplayType: {},
    groupDefaultExpanded: {},
    autoGroupColumnDef: {},
    groupMaintainOrder: { type: Boolean },
    groupSelectsChildren: { type: Boolean },
    groupLockGroupColumns: {},
    groupAggFiltering: { type: [Boolean, Function] },
    groupTotalRow: { type: [String, Function] },
    grandTotalRow: {},
    suppressStickyTotalRow: { type: [Boolean, String] },
    groupSuppressBlankHeader: { type: Boolean },
    groupSelectsFiltered: { type: Boolean },
    showOpenedGroup: { type: Boolean },
    groupHideParentOfSingleChild: { type: [Boolean, String] },
    groupRemoveSingleChildren: { type: Boolean },
    groupRemoveLowestSingleChildren: { type: Boolean },
    groupHideOpenParents: { type: Boolean },
    groupAllowUnbalanced: { type: Boolean },
    rowGroupPanelShow: {},
    groupRowRenderer: {},
    groupRowRendererParams: {},
    treeData: { type: Boolean },
    treeDataChildrenField: {},
    treeDataParentIdField: {},
    rowGroupPanelSuppressSort: { type: Boolean },
    suppressGroupRowsSticky: { type: Boolean },
    groupHierarchyConfig: {},
    pinnedTopRowData: {},
    pinnedBottomRowData: {},
    enableRowPinning: { type: [Boolean, String] },
    isRowPinnable: { type: Function },
    isRowPinned: { type: Function },
    rowModelType: {},
    rowData: {},
    asyncTransactionWaitMillis: {},
    suppressModelUpdateAfterUpdateTransaction: { type: Boolean },
    datasource: {},
    cacheOverflowSize: {},
    infiniteInitialRowCount: {},
    serverSideInitialRowCount: {},
    suppressServerSideFullWidthLoadingRow: { type: Boolean },
    cacheBlockSize: {},
    maxBlocksInCache: {},
    maxConcurrentDatasourceRequests: {},
    blockLoadDebounceMillis: {},
    purgeClosedRowNodes: { type: Boolean },
    serverSideDatasource: {},
    serverSideSortAllLevels: { type: Boolean },
    serverSideEnableClientSideSort: { type: Boolean },
    serverSideOnlyRefreshFilteredGroups: { type: Boolean },
    serverSidePivotResultFieldSeparator: {},
    viewportDatasource: {},
    viewportRowModelPageSize: {},
    viewportRowModelBufferSize: {},
    alwaysShowHorizontalScroll: { type: Boolean },
    alwaysShowVerticalScroll: { type: Boolean },
    debounceVerticalScrollbar: { type: Boolean },
    suppressHorizontalScroll: { type: Boolean },
    suppressScrollOnNewData: { type: Boolean },
    suppressScrollWhenPopupsAreOpen: { type: Boolean },
    suppressAnimationFrame: { type: Boolean },
    suppressMiddleClickScrolls: { type: Boolean },
    suppressPreventDefaultOnMouseWheel: { type: Boolean },
    scrollbarWidth: {},
    rowSelection: {},
    cellSelection: { type: [Boolean, Object] },
    rowMultiSelectWithClick: { type: Boolean },
    suppressRowDeselection: { type: Boolean },
    suppressRowClickSelection: { type: Boolean },
    suppressCellFocus: { type: Boolean },
    suppressHeaderFocus: { type: Boolean },
    selectionColumnDef: {},
    rowNumbers: { type: [Boolean, Object] },
    suppressMultiRangeSelection: { type: Boolean },
    enableCellTextSelection: { type: Boolean },
    enableRangeSelection: { type: Boolean },
    enableRangeHandle: { type: Boolean },
    enableFillHandle: { type: Boolean },
    fillHandleDirection: {},
    suppressClearOnFillReduction: { type: Boolean },
    sortingOrder: {},
    accentedSort: { type: Boolean },
    unSortIcon: { type: Boolean },
    suppressMultiSort: { type: Boolean },
    alwaysMultiSort: { type: Boolean },
    multiSortKey: {},
    suppressMaintainUnsortedOrder: { type: Boolean },
    icons: {},
    rowHeight: {},
    rowStyle: {},
    rowClass: {},
    rowClassRules: {},
    suppressRowHoverHighlight: { type: Boolean },
    suppressRowTransform: { type: Boolean },
    columnHoverHighlight: { type: Boolean },
    gridId: {},
    deltaSort: { type: Boolean },
    treeDataDisplayType: {},
    enableGroupEdit: { type: Boolean },
    initialState: {},
    loadThemeGoogleFonts: { type: Boolean },
    themeCssLayer: {},
    styleNonce: {},
    themeStyleContainer: {},
    getContextMenuItems: { type: Function },
    getMainMenuItems: { type: Function },
    postProcessPopup: { type: Function },
    processUnpinnedColumns: { type: Function },
    processCellForClipboard: { type: Function },
    processHeaderForClipboard: { type: Function },
    processGroupHeaderForClipboard: { type: Function },
    processCellFromClipboard: { type: Function },
    sendToClipboard: { type: Function },
    processDataFromClipboard: { type: Function },
    isExternalFilterPresent: { type: Function },
    doesExternalFilterPass: { type: Function },
    getChartToolbarItems: { type: Function },
    createChartContainer: { type: Function },
    focusGridInnerElement: { type: Function },
    navigateToNextHeader: { type: Function },
    tabToNextHeader: { type: Function },
    navigateToNextCell: { type: Function },
    tabToNextCell: { type: Function },
    getLocaleText: { type: Function },
    getDocument: { type: Function },
    paginationNumberFormatter: { type: Function },
    getGroupRowAgg: { type: Function },
    isGroupOpenByDefault: { type: Function },
    ssrmExpandAllAffectsAllRows: { type: Boolean },
    initialGroupOrderComparator: { type: Function },
    processPivotResultColDef: { type: Function },
    processPivotResultColGroupDef: { type: Function },
    getDataPath: { type: Function },
    getChildCount: { type: Function },
    getServerSideGroupLevelParams: { type: Function },
    isServerSideGroupOpenByDefault: { type: Function },
    isApplyServerSideTransaction: { type: Function },
    isServerSideGroup: { type: Function },
    getServerSideGroupKey: { type: Function },
    getBusinessKeyForNode: { type: Function },
    getRowId: { type: Function },
    resetRowDataOnUpdate: { type: Boolean },
    processRowPostCreate: { type: Function },
    isRowSelectable: { type: Function },
    isRowMaster: { type: Function },
    fillOperation: { type: Function },
    postSortRows: { type: Function },
    getRowStyle: { type: Function },
    getRowClass: { type: Function },
    getRowHeight: { type: Function },
    isFullWidthRow: { type: Function },
    isRowValidDropPosition: {},
    "onTool-panel-visible-changed": {},
    "onTool-panel-size-changed": {},
    "onColumn-menu-visible-changed": {},
    "onContext-menu-visible-changed": {},
    "onCut-start": {},
    "onCut-end": {},
    "onPaste-start": {},
    "onPaste-end": {},
    "onColumn-visible": {},
    "onColumn-pinned": {},
    "onColumn-resized": {},
    "onColumn-moved": {},
    "onColumn-value-changed": {},
    "onColumn-pivot-mode-changed": {},
    "onColumn-pivot-changed": {},
    "onColumn-group-opened": {},
    "onNew-columns-loaded": {},
    "onGrid-columns-changed": {},
    "onDisplayed-columns-changed": {},
    "onVirtual-columns-changed": {},
    "onColumn-everything-changed": {},
    "onColumns-reset": {},
    "onColumn-header-mouse-over": {},
    "onColumn-header-mouse-leave": {},
    "onColumn-header-clicked": {},
    "onColumn-header-context-menu": {},
    "onComponent-state-changed": {},
    "onCell-value-changed": {},
    "onCell-edit-request": {},
    "onRow-value-changed": {},
    "onCell-editing-started": {},
    "onCell-editing-stopped": {},
    "onRow-editing-started": {},
    "onRow-editing-stopped": {},
    "onBulk-editing-started": {},
    "onBulk-editing-stopped": {},
    "onBatch-editing-started": {},
    "onBatch-editing-stopped": {},
    "onUndo-started": {},
    "onUndo-ended": {},
    "onRedo-started": {},
    "onRedo-ended": {},
    "onCell-selection-delete-start": {},
    "onCell-selection-delete-end": {},
    "onRange-delete-start": {},
    "onRange-delete-end": {},
    "onFill-start": {},
    "onFill-end": {},
    "onFilter-opened": {},
    "onFilter-changed": {},
    "onFilter-modified": {},
    "onFilter-ui-changed": {},
    "onFloating-filter-ui-changed": {},
    "onAdvanced-filter-builder-visible-changed": {},
    "onFind-changed": {},
    "onChart-created": {},
    "onChart-range-selection-changed": {},
    "onChart-options-changed": {},
    "onChart-destroyed": {},
    "onCell-key-down": {},
    "onGrid-ready": {},
    "onGrid-pre-destroyed": {},
    "onFirst-data-rendered": {},
    "onGrid-size-changed": {},
    "onModel-updated": {},
    "onVirtual-row-removed": {},
    "onViewport-changed": {},
    "onBody-scroll": {},
    "onBody-scroll-end": {},
    "onDrag-started": {},
    "onDrag-stopped": {},
    "onDrag-cancelled": {},
    "onState-updated": {},
    "onPagination-changed": {},
    "onRow-drag-enter": {},
    "onRow-drag-move": {},
    "onRow-drag-leave": {},
    "onRow-drag-end": {},
    "onRow-drag-cancel": {},
    "onRow-resize-started": {},
    "onRow-resize-ended": {},
    "onColumn-row-group-changed": {},
    "onRow-group-opened": {},
    "onExpand-or-collapse-all": {},
    "onPivot-max-columns-exceeded": {},
    "onPinned-row-data-changed": {},
    "onPinned-rows-changed": {},
    "onRow-data-updated": {},
    "onAsync-transactions-flushed": {},
    "onStore-refreshed": {},
    "onHeader-focused": {},
    "onCell-clicked": {},
    "onCell-double-clicked": {},
    "onCell-focused": {},
    "onCell-mouse-over": {},
    "onCell-mouse-out": {},
    "onCell-mouse-down": {},
    "onRow-clicked": {},
    "onRow-double-clicked": {},
    "onRow-selected": {},
    "onSelection-changed": {},
    "onCell-context-menu": {},
    "onRange-selection-changed": {},
    "onCell-selection-changed": {},
    "onTooltip-show": {},
    "onTooltip-hide": {},
    "onSort-changed": {},
    theme: {}
  }, {
    ...getProps()
  }),
  setup(__props, { expose: __expose }) {
    const attrs = useAttrs();
    const props = __props;
    const style = attrs.style || {};
    const vuetifyTheme = useTheme();
    const themeClasses = computed(() => {
      const classes = ["v-ag-grid"];
      classes.push(
        selectedTheme.value.dark ? "ag-theme-quartz-dark" : "ag-theme-quartz"
      );
      classes.push(`v-theme--${selectedTheme.value.name}`);
      return classes;
    });
    const rtl = useRtl();
    const api = ref(void 0);
    const gridRef = ref(null);
    const AgGridVue = defineAsyncComponent(
      () => Promise.all([import("ag-grid-vue3"), import("ag-grid-community")]).then(
        ([vueModule, gridModule]) => {
          const { ModuleRegistry, AllCommunityModule } = gridModule;
          ModuleRegistry.registerModules([AllCommunityModule]);
          return vueModule.AgGridVue;
        }
      )
    );
    __expose({
      api
    });
    onMounted(() => {
      nextTick(() => {
        var _a;
        if ((_a = gridRef.value) == null ? void 0 : _a.api) {
          api.value = gridRef.value.api;
        }
      });
    });
    const selectedTheme = computed(() => {
      const themeName = props.theme;
      let theme = vuetifyTheme.current.value;
      if (themeName && vuetifyTheme.themes.value[themeName]) {
        const computedTheme = getLightDarkTheme(
          vuetifyTheme.current.value.dark,
          themeName,
          (themeName2) => vuetifyTheme.themes.value[themeName2] !== void 0
        );
        theme = vuetifyTheme.themes.value[computedTheme];
        return { name: computedTheme, ...theme };
      } else {
        const matchingEntry = Object.entries(vuetifyTheme.themes.value).find(
          ([, t]) => t === theme
        );
        if (matchingEntry) {
          const [name] = matchingEntry;
          return { name, ...theme };
        }
      }
      const fallbackName = theme.dark ? "dark" : "light";
      return { name: fallbackName, ...theme };
    });
    const propsWithoutTheme = computed(() => {
      const { theme, ...rest } = props;
      return rest;
    });
    return (_ctx, _cache) => {
      const _component_v_progress_circular = resolveComponent("v-progress-circular");
      return openBlock(), createBlock(Suspense, null, {
        default: withCtx(() => [
          createVNode(unref(AgGridVue), mergeProps({
            ref_key: "gridRef",
            ref: gridRef
          }, { ...propsWithoutTheme.value, ...unref(attrs) }, {
            class: themeClasses.value,
            enableRtl: unref(rtl).isRtl.value,
            theme: "legacy"
          }), null, 16, ["class", "enableRtl"])
        ]),
        fallback: withCtx(() => [
          createElementVNode("div", {
            class: "d-flex align-center justify-center",
            style: normalizeStyle(unref(style))
          }, [
            createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "48"
            })
          ], 4)
        ]),
        _: 1
      });
    };
  }
});
function isColDef(col) {
  return !("children" in col);
}
const rowIdSymbol = Symbol("rowId");
function ensureRowId(row) {
  if (!row[rowIdSymbol]) {
    row[rowIdSymbol] = uniqueId();
  }
}
const components = {
  DispatchRendererCell: defineComponent({
    name: "DispatchRendererCell",
    components: { DispatchRenderer },
    props: {
      params: {
        type: Object,
        required: true
      }
    },
    setup({ params }) {
      return () => {
        const { propertyName, node, control } = params;
        const controlWithoutLabel = (scope) => {
          return { type: "Control", scope, label: false };
        };
        function resolveUiSchema(propName) {
          return control.schema.properties && propName ? controlWithoutLabel(`#/properties/${propName}`) : controlWithoutLabel("#");
        }
        return h(DispatchRenderer, {
          schema: control.schema,
          uischema: resolveUiSchema(propertyName),
          path: composePaths(control.path, `${node.sourceRowIndex}`),
          enabled: control.enabled,
          renderers: control.renderers,
          cells: control.cells
        });
      };
    },
    methods: {
      // ag grid will check if we have a refresh function that will return true then it will reuse the renderer instead of recreating it
      refresh(_params) {
        return true;
      }
    }
  })
};
const AgGridArrayControlRenderer = defineComponent({
  name: "AgGridArrayControlRenderer",
  components: {
    VBtn,
    VCard,
    VCardText,
    VCardTitle,
    VIcon,
    VProgressCircular,
    VSpacer,
    VToolbar,
    VToolbarTitle,
    VTooltip,
    ValidationIcon,
    VAgGrid: _sfc_main
  },
  props: {
    ...rendererProps()
  },
  setup(props) {
    const icons = useIcons();
    const input = useVuetifyArrayControl(useJsonFormsArrayControl(props));
    const gridApi = shallowRef(null);
    const suppressRowDrag = ref(!input.control.value.enabled);
    const schema = ref(input.control.value.schema);
    watch(
      () => input.control.value.schema,
      (newSchema) => {
        schema.value = newSchema;
      }
    );
    const showSortButtons = ref(input.appliedOptions.value.showSortButtons);
    watch(
      () => input.appliedOptions.value.showSortButtons,
      (newValue) => {
        showSortButtons.value = newValue;
      }
    );
    const enabled = ref(input.control.value.enabled);
    watch(
      () => input.control.value.enabled,
      (newValue) => {
        enabled.value = newValue;
      }
    );
    const gridOptions = computed(() => {
      var _a, _b;
      const baseOptions = ((_b = (_a = props.uischema) == null ? void 0 : _a.options) == null ? void 0 : _b.agGridOptions) || {};
      let haveRowDragColumn = false;
      const schemaColumnDefs = Object.entries(
        schema.value.type === "object" ? schema.value.properties || {} : { "": { title: "" } }
        // primitive
      ).map(([propertyName, propertySchema]) => {
        var _a2;
        const baseDef = {
          headerName: propertySchema.title ?? startCaseFn(propertyName),
          field: propertyName,
          autoHeight: true
        };
        const extraDef = ((_a2 = baseOptions.columnDefs) == null ? void 0 : _a2.find(
          (c) => isColDef(c) && c.field === propertyName
        )) || {};
        if (isColDef(extraDef) && extraDef.rowDrag) {
          haveRowDragColumn = true;
        }
        const cellDef = isColDef(extraDef) ? {
          editable: false,
          cellRendererSelector: (params) => {
            return params.node.group ? void 0 : {
              component: "DispatchRendererCell",
              params: {
                propertyName,
                control: input.control.value
              }
            };
          },
          cellRendererParams: {
            deferRender: true
          }
        } : {};
        return {
          ...baseDef,
          ...extraDef,
          ...cellDef
        };
      });
      const schemaColumnDefsControls = [];
      if (enabled.value && showSortButtons.value && !haveRowDragColumn) {
        schemaColumnDefsControls.push({
          headerName: "",
          rowDrag: true,
          suppressMovable: true,
          sortable: false,
          filter: false,
          resizable: false,
          width: 36
        });
      }
      delete baseOptions.rowData;
      let getRowId = void 0;
      if (schema.value.type === "object" || schema.value.type === "array") {
        getRowId = (params) => {
          const data = params.data;
          if (typeof data === "object" && data !== null) {
            ensureRowId(data);
            return data[rowIdSymbol];
          } else {
            return String(data);
          }
        };
      }
      const vuetifyProps = input.vuetifyProps("v-ag-grid") ?? {};
      return {
        ...baseOptions,
        ...vuetifyProps,
        columnDefs: [...schemaColumnDefsControls, ...schemaColumnDefs],
        selectionColumnDef: {
          cellStyle: {
            display: "flex",
            alignItems: "center"
          },
          ...baseOptions.selectionColumnDef ?? {}
        },
        defaultColDef: {
          sortable: true,
          filter: true,
          resizable: true,
          ...baseOptions.defaultColDef ?? {}
        },
        components,
        suppressRowDrag: baseOptions.suppressRowDrag || suppressRowDrag.value,
        getRowId
      };
    });
    const dataLength = computed(() => {
      var _a;
      return ((_a = input.control.value.data) == null ? void 0 : _a.length) || 0;
    });
    const onGridReady = (event) => {
      gridApi.value = event.api;
    };
    const selectedIndexes = ref([]);
    const sortedGrid = ref(false);
    const filteredGrid = ref(false);
    const onSelectionChanged = (event) => {
      var _a;
      selectedIndexes.value = ((_a = event.selectedNodes) == null ? void 0 : _a.map((rowNode) => rowNode.sourceRowIndex)) ?? [];
    };
    const onSortChanged = (event) => {
      sortedGrid.value = event.api.getColumnState().filter((col) => col.sort).length > 0;
      suppressRowDrag.value = filteredGrid.value || sortedGrid.value;
    };
    const onFilterChanged = (event) => {
      filteredGrid.value = Object.keys(event.api.getFilterModel()).length > 0;
      suppressRowDrag.value = filteredGrid.value || sortedGrid.value;
    };
    const onRowDragEnd = (event) => {
      var _a, _b;
      const fromIndex = event.node.sourceRowIndex ?? -1;
      const toIndex = event.overIndex;
      if (fromIndex === -1 || event.overIndex === -1 || fromIndex === toIndex) {
        return;
      }
      if (fromIndex > toIndex) {
        const numberOfMoves = fromIndex - toIndex;
        for (let i = 0; i < numberOfMoves; i++) {
          (_a = input.moveUp) == null ? void 0 : _a.call(input, input.control.value.path, fromIndex - i)();
        }
      } else {
        const numberOfMoves = toIndex - fromIndex;
        for (let i = 0; i < numberOfMoves; i++) {
          (_b = input.moveDown) == null ? void 0 : _b.call(input, input.control.value.path, fromIndex + i)();
        }
      }
      event.api.clearFocusedCell();
    };
    const rowSelection = ref({
      mode: "multiRow",
      checkboxes: enabled.value,
      headerCheckbox: enabled.value
    });
    return {
      ...input,
      onGridReady,
      gridApi,
      dataLength,
      icons,
      gridOptions,
      components,
      selectedIndexes,
      rowSelection,
      onSelectionChanged,
      onFilterChanged,
      onSortChanged,
      onRowDragEnd
    };
  },
  methods: {
    composePaths,
    createDefaultValue,
    addButtonClick() {
      this.addItem(
        this.control.path,
        createDefaultValue(this.control.schema, this.control.rootSchema)
      )();
    },
    removeItemsClick() {
      var _a;
      (_a = this.removeItems) == null ? void 0 : _a.call(this, this.control.path, this.selectedIndexes)();
      nextTick(() => {
        var _a2, _b;
        (_a2 = this.gridApi) == null ? void 0 : _a2.deselectAll();
        (_b = this.gridApi) == null ? void 0 : _b.redrawRows();
      });
    }
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_validation_icon = resolveComponent("validation-icon");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_ag_grid = resolveComponent("v-ag-grid");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");
  return _ctx.control.visible ? (openBlock(), createBlock(_component_v_card, mergeProps({
    key: 0,
    class: _ctx.styles.arrayList.root,
    elevation: "0"
  }, _ctx.vuetifyProps("v-card")), {
    default: withCtx(() => [
      createVNode(_component_v_card_title, mergeProps({
        class: _ctx.styles.arrayList.title
      }, _ctx.vuetifyProps("v-card-title")), {
        default: withCtx(() => [
          createVNode(_component_v_toolbar, mergeProps({
            flat: "",
            class: _ctx.styles.arrayList.toolbar
          }, _ctx.vuetifyProps("v-toolbar")), {
            default: withCtx(() => [
              createVNode(_component_v_toolbar_title, {
                class: normalizeClass(_ctx.styles.arrayList.label)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.computedLabel), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              createVNode(_component_v_spacer),
              _ctx.control.childErrors.length > 0 ? (openBlock(), createBlock(_component_validation_icon, {
                key: 0,
                errors: _ctx.control.childErrors
              }, null, 8, ["errors"])) : createCommentVNode("", true),
              createVNode(_component_v_tooltip, { location: "bottom" }, {
                activator: withCtx(({ props }) => [
                  createVNode(_component_v_btn, mergeProps({
                    icon: "",
                    variant: "text",
                    elevation: "0",
                    small: "",
                    "aria-label": _ctx.control.translations.addAriaLabel
                  }, props, {
                    class: _ctx.styles.arrayList.addButton,
                    disabled: !_ctx.control.enabled || _ctx.appliedOptions.restrict && _ctx.control.arraySchema !== void 0 && _ctx.control.arraySchema.maxItems !== void 0 && _ctx.dataLength >= _ctx.control.arraySchema.maxItems,
                    onClick: _ctx.addButtonClick
                  }), {
                    default: withCtx(() => [
                      createVNode(_component_v_icon, null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.icons.current.value.itemAdd), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040, ["aria-label", "class", "disabled", "onClick"])
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(_ctx.control.translations.addTooltip), 1)
                ]),
                _: 1
              }),
              createVNode(_component_v_tooltip, { location: "bottom" }, {
                activator: withCtx(({ props }) => [
                  createVNode(_component_v_btn, mergeProps(props, {
                    icon: "",
                    variant: "text",
                    elevation: "0",
                    small: "",
                    "aria-label": _ctx.control.translations.removeAriaLabel,
                    class: _ctx.styles.arrayList.itemDelete,
                    disabled: !_ctx.control.enabled || _ctx.selectedIndexes.length === 0 || _ctx.appliedOptions.restrict && _ctx.control.arraySchema !== void 0 && _ctx.control.arraySchema.minItems !== void 0 && _ctx.dataLength - _ctx.selectedIndexes.length <= _ctx.control.arraySchema.minItems,
                    onClick: _ctx.removeItemsClick
                  }), {
                    default: withCtx(() => [
                      createVNode(_component_v_icon, { class: "notranslate" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.icons.current.value.itemDelete), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040, ["aria-label", "class", "disabled", "onClick"])
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(_ctx.control.translations.removeTooltip), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 16, ["class"])
        ]),
        _: 1
      }, 16, ["class"]),
      createVNode(_component_v_card_text, normalizeProps(guardReactiveProps(_ctx.vuetifyProps("v-card-text"))), {
        default: withCtx(() => [
          createVNode(_component_v_ag_grid, mergeProps({
            rowData: _ctx.control.data
          }, _ctx.gridOptions, {
            components: _ctx.components,
            rowSelection: _ctx.rowSelection,
            onGridReady: _ctx.onGridReady,
            onSelectionChanged: _ctx.onSelectionChanged,
            onFilterChanged: _ctx.onFilterChanged,
            onSortChanged: _ctx.onSortChanged,
            onRowDragEnd: _ctx.onRowDragEnd,
            style: {
              width: _ctx.appliedOptions.gridWidth || "100%",
              height: _ctx.appliedOptions.gridHeight || "400px"
            }
          }), null, 16, ["rowData", "components", "rowSelection", "onGridReady", "onSelectionChanged", "onFilterChanged", "onSortChanged", "onRowDragEnd", "style"])
        ]),
        _: 1
      }, 16)
    ]),
    _: 1
  }, 16, ["class"])) : createCommentVNode("", true);
}
const controlRenderer = /* @__PURE__ */ _export_sfc(AgGridArrayControlRenderer, [["render", _sfc_render]]);
const entry$d = {
  renderer: buttonRenderer,
  tester: rankWith(1, uiTypeIs("Button"))
};
const entry$c = {
  renderer: dataProviderRenderer,
  tester: rankWith(1, uiTypeIs("DataProvider"))
};
const entry$b = {
  renderer: dataProviderSelectRenderer,
  tester: rankWith(
    11,
    and(isStringControl, optionIs("variant", "data-provider-select"))
  )
};
const entry$a = {
  renderer: controlRenderer$9,
  tester: rankWith(2, and(isStringControl, formatIs("duration")))
};
const isBase64String = and(
  uiTypeIs("Control"),
  isStringControl,
  schemaMatches((schema) => {
    const s = schema;
    return s.contentEncoding === "base64" || s.format === "binary" || s.format === "byte";
  })
);
const entry$9 = {
  renderer: fileRenderer,
  tester: rankWith(2, isBase64String)
};
const hasStringValueOption = (optionName) => (uischema) => {
  if (isEmpty(uischema)) {
    return false;
  }
  const options = uischema.options;
  return options && !isEmpty(options) && typeof options[optionName] === "string" || false;
};
const entry$8 = {
  renderer: monacoRenderer,
  tester: rankWith(
    3,
    and(
      optionIs("format", "code"),
      or(
        and(
          isStringControl,
          or(
            hasStringValueOption("language"),
            hasStringValueOption(":language")
          )
        ),
        // if the language is set to 'json' we can use the monaco editor for any type
        and(
          and(uiTypeIs("Control")),
          optionIs("language", "json"),
          optionIs("convertJson", true)
        )
      )
    )
  )
};
const isNullControl = and(uiTypeIs("Control"), schemaTypeIs("null"));
const entry$7 = {
  renderer: controlRenderer$5,
  tester: rankWith(1, isNullControl)
};
const entry$6 = {
  renderer: slotRenderer,
  tester: rankWith(2, uiTypeIs("Slot"))
};
const entry$5 = {
  renderer: templateLabelRenderer,
  tester: rankWith(2, and(uiTypeIs("Label"), optionIs("template", true)))
};
const langIs$1 = (expected) => (uischema, schema, context) => {
  return uischema.lang === expected || uischema.lang === void 0 && context.config && context.config.defaultTemplateLang === expected;
};
const entry$4 = {
  renderer: vueTemplateLayoutRenderer,
  tester: rankWith(2, and(uiTypeIs("TemplateLayout"), langIs$1("vue")))
};
const langIs = (expected) => (uischema, schema, context) => {
  return uischema.lang === expected || uischema.lang === void 0 && (!context.config || context.config.defaultTemplateLang === expected || context.config.defaultTemplateLang === void 0);
};
const entry$3 = {
  renderer: templateLayoutRenderer,
  tester: rankWith(2, and(uiTypeIs("TemplateLayout"), langIs("ractive")))
};
const hasName = (uischema) => !isEmpty(uischema) && typeof uischema.name === "string";
const entry$2 = {
  renderer: templateRenderer,
  tester: rankWith(2, and(uiTypeIs("Template"), hasName))
};
const entry$1 = {
  renderer: splitLayoutRenderer,
  tester: rankWith(2, uiTypeIs("SplitLayout"))
};
const isArrayControl = and(uiTypeIs("Control"), schemaTypeIs("array"));
const entry = {
  renderer: controlRenderer,
  tester: rankWith(4, and(optionIs("variant", "ag-grid"), isArrayControl))
};
const extraVuetifyRenderers = [
  entry$d,
  entry$c,
  entry$b,
  entry$a,
  entry$9,
  entry$8,
  entry$7,
  entry$6,
  entry$5,
  entry$4,
  entry$3,
  entry$2,
  entry$1,
  entry
];
export {
  controlRenderer as AgGridArrayControlRenderer,
  AsyncFunction,
  buttonRenderer as ButtonRenderer,
  DataProviderKey,
  dataProviderRenderer as DataProviderRenderer,
  dataProviderSelectRenderer as DataProviderSelectRenderer,
  controlRenderer$9 as DurationRenderer,
  _sfc_main$5 as DynamicElement,
  fileRenderer as FileRenderer,
  FormContextKey,
  HandleActionEmitterKey,
  monacoRenderer as MonacoRenderer,
  controlRenderer$5 as NullControlRenderer,
  _sfc_main$6 as ResolvedJsonForms,
  _sfc_main$4 as SlotElement,
  slotRenderer as SlotRenderer,
  splitLayoutRenderer as SplitLayoutRenderer,
  TemplateCompiler,
  TemplateComponentsKey,
  TemplateComputedKey,
  TemplateDirectivesKey,
  TemplateFiltersKey,
  templateLabelRenderer as TemplateLabelRenderer,
  templateLayoutRenderer as TemplateLayoutRenderer,
  TemplateMethodsKey,
  TemplateRenderSlotContentsKey,
  templateRenderer as TemplateRenderer,
  VMonacoEditor$2 as VMonacoEditor,
  VPane,
  VSplitpanes,
  vueTemplateLayoutRenderer as VueTemplateLayoutRenderer,
  ajvKeywords,
  createAjv,
  createTranslator,
  dateOffset,
  dateUnit,
  datetimeOffset,
  dynamic,
  extraVuetifyRenderers,
  getLightDarkTheme,
  mapStateToButtonProps,
  parseAndTransformUISchemaRegistryEntries,
  resolveUISchemaValidations,
  searchParams,
  template,
  timeOffset,
  useElementArrayControl,
  useFormContext,
  useJsonFormsButton,
  useVuetifyButton
};
//# sourceMappingURL=jsonforms-vuetify-renderers.esm.js.map
